<template>
  <div :style="{ '--color': color, '--borderColor': borderColor }">
    <ValidationProvider
      v-if="validation"
      :rules="'requiredJudet'"
      v-slot="{ errors }"
      :name="'judet'"
    >
      <div class="selectInputWrapper">
        <select
          v-model="county"
          required
          ref="select"
          :name="'Judet*'"
          :id="field.fieldId"
          class="form-control"
          @change="updateComponent"
          :class="{ 'is-invalid': errors.length }"
          :style="styles"
        >
          <option value disabled :selected="!selectedValue" hidden></option>
          <option
            v-for="option in locations"
            :key="option.name"
            :selected="option.name == selectedValue"
            :disabled="option.disabled"
            :value="option.name"
          >
            {{ option.name }}
          </option>
        </select>
        <!-- <img
            v-if="errors.length"
            class="error_min inputError"
            src="../../assets/icons/risk-icon.svg"
            height="18px"
            width="18px"
            alt
          /> -->
        <span class="floating-label">{{ placeholder }}</span>
      </div>
      <div class="validation-error" v-if="errors.length">{{ errors[0] }}</div>
    </ValidationProvider>
    <template v-else>
      <div class="selectInputWrapper">
        <select
          class="form-control"
          v-model="county"
          required
          ref="select"
          :name="name"
          :id="field.fieldId"
          @change="updateComponent"
        >
          <option value disabled :selected="!selectedValue" hidden></option>
          <option
            v-for="option in options"
            :key="option.value"
            :selected="option.value == selectedValue"
            :disabled="option.disabled"
            :value="option.value"
          >
            {{ option.text }}
          </option>
        </select>
        <span class="floating-label">{{ placeholder }}</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "select-input-county",
  data() {
    return {
      localSelected: this.selectedValue || "",
      county: null,
      city: null,
      cities: [],
      locations: [
        {
          name: "Alba",
          cities: [
            "Abrud",
            "Achimetesti",
            "Acmariu",
            "Aiud",
            "Alba Iulia",
            "Albac",
            "Alecus",
            "Almasu Mare",
            "Almasu de Mijloc",
            "Ampoita",
            "Anghelesti",
            "Arieseni",
            "Aronesti",
            "Arti",
            "Asinip",
            "Avram Iancu",
            "Avramesti",
            "Avramesti",
            "Baba",
            "Baia de Aries",
            "Balomiru de Camp",
            "Beldiu",
            "Benic",
            "Berghin",
            "Beta",
            "Bidigesti",
            "Biharia",
            "Biia",
            "Bilanesti",
            "Bisericani",
            "Bistra",
            "Blaj",
            "Blandiana",
            "Blidesti",
            "Bobaresti",
            "Bobaresti",
            "Bocesti",
            "Bodesti",
            "Bodresti",
            "Bogdanesti",
            "Bogdanesti",
            "Boglesti",
            "Boldesti",
            "Bolovanesti",
            "Bordestii Poieni",
            "Botesti",
            "Botesti",
            "Boz",
            "Botani",
            "Bradeana",
            "Bradet",
            "Bradesti",
            "Brazesti",
            "Bubesti",
            "Bucerdea Granoasa",
            "Bucerdea Vinoasa",
            "Bucium",
            "Bucium-Sat",
            "Budeni",
            "Budaiesti",
            "Bulbuc",
            "Buninginea",
            "Bunta",
            "Burzesti",
            "Burzonesti",
            "Butesti",
            "Butesti",
            "Bardesti",
            "Barlesti",
            "Barlesti",
            "Barlesti",
            "Barlesti-Catun",
            "Barsana",
            "Barzan",
            "Barzogani",
            "Bacainti",
            "Badai",
            "Bagau",
            "Bai",
            "Balcaciu",
            "Balesti",
            "Balesti-Catun",
            "Balmosesti",
            "Barbesti",
            "Barasti",
            "Bazesti",
            "Capu Dealului",
            "Carpen",
            "Carpenii de Sus",
            "Casa de Piatra",
            "Cenade",
            "Cerbu",
            "Cergau Mare",
            "Cergau Mic",
            "Ceru-Bacainti",
            "Cetatea de Balta",
            "Cetea",
            "Cheia",
            "Cheile Cibului",
            "Cheleteni",
            "Cib",
            "Cicard",
            "Cicau",
            "Cioara de Sus",
            "Ciocasu",
            "Cionesti",
            "Cistei",
            "Cisteiu de Mures",
            "Ciuculesti",
            "Ciugud",
            "Ciugudu de Jos",
            "Ciugudu de Sus",
            "Ciuguzel",
            "Ciuldesti",
            "Ciumbrud",
            "Ciuruleasa",
            "Coasta Hentii",
            "Cobles",
            "Cocesti",
            "Cocosesti",
            "Cojocani",
            "Coleseni",
            "Colibi",
            "Coltesti",
            "Copand",
            "Corna",
            "Cornu",
            "Coroiesti",
            "Cortesti",
            "Costesti",
            "Costesti",
            "Cotorasti",
            "Coslariu",
            "Coslariu Nou",
            "Craiva",
            "Cretesti",
            "Cricau",
            "Cristesti",
            "Criseni",
            "Craciunelu de Jos",
            "Craciunelu de Sus",
            "Cucuta",
            "Cugir",
            "Culdesti",
            "Cunta",
            "Curmatura",
            "Curpeni",
            "Curaturi",
            "Cut",
            "Calnic",
            "Campeni",
            "Campu Goblii",
            "Candesti",
            "Carasti",
            "Cartulesti",
            "Calugaresti",
            "Captalan",
            "Capud",
            "Capalna",
            "Capalna de Jos",
            "Carpinis",
            "Carpinis",
            "Casoaia",
            "Daia Romana",
            "Deal",
            "Dealu Bajului",
            "Dealu Caselor",
            "Dealu Crisului",
            "Dealu Dostatului",
            "Dealu Ferului",
            "Dealu Frumos",
            "Dealu Frumos",
            "Dealu Geoagiului",
            "Dealu Goiesti",
            "Dealu Lamasoi",
            "Dealu Muntelui",
            "Dealu Ordancusii",
            "Dealu Roatei",
            "Decea",
            "Deoncesti",
            "Deve",
            "Dilimani",
            "Dobra",
            "Dobresti",
            "Dobrot",
            "Dogaresti",
            "Dolesti",
            "Doptau",
            "Dos",
            "Dosu Luncii",
            "Dosu Vasesti",
            "Dostat",
            "Drasov",
            "Drambar",
            "Dragoiesti-Lunca",
            "Duduieni",
            "Dumbrava",
            "Dumbrava",
            "Dumbrava",
            "Dumbravita",
            "Dumesti",
            "Dumitra",
            "Dumacesti",
            "Dupa Deal",
            "Dupa Deal",
            "Dupa Plese",
            "Durasti",
            "Dambureni",
            "Darlesti",
            "Daroaia",
            "Fata",
            "Fata Cristesei",
            "Fata Lapusului",
            "Fata Pietrii",
            "Fata-Lazesti",
            "Feisa",
            "Fenes",
            "Feresti",
            "Fericet",
            "Ficaresti",
            "Floresti",
            "Floresti",
            "Floresti",
            "Furduiesti",
            "Fantanele",
            "Faget",
            "Fagetu de Jos",
            "Fagetu de Sus",
            "Farau",
            "Galati",
            "Galbena",
            "Galda de Jos",
            "Galda de Sus",
            "Galtiu",
            "Geamana",
            "Geoagiu de Sus",
            "Geogel",
            "Geomal",
            "Ghedulesti",
            "Ghetari",
            "Ghioncani",
            "Ghirbom",
            "Giurgiut",
            "Gligoresti",
            "Glod",
            "Glogovet",
            "Goiesti",
            "Gojeiesti",
            "Gorgan",
            "Grosi",
            "Gura Ariesului",
            "Gura Cutului",
            "Gura Izbitei",
            "Gura Rosiei",
            "Gura Sohodol",
            "Garbova",
            "Garbova de Jos",
            "Garbova de Sus",
            "Garbovita",
            "Garda Seaca",
            "Garda de Sus",
            "Garda-Barbulesti",
            "Garde",
            "Gabud",
            "Ganesti",
            "Haiducesti",
            "Hategana",
            "Heleresti",
            "Helesti",
            "Henig",
            "Heria",
            "Hoanca",
            "Hoanca",
            "Hodisesti",
            "Hodobana",
            "Holobani",
            "Hoparta",
            "Horea",
            "Hudricesti",
            "Huzaresti",
            "Hadarau",
            "Hanasesti",
            "Hanasesti",
            "Hapria",
            "Harasti",
            "Iacobesti",
            "Ibru",
            "Iclod",
            "Ighiel",
            "Ighiu",
            "Ignatesti",
            "Iliesti",
            "Incesti",
            "Incesti",
            "Inoc",
            "Inuri",
            "Isca",
            "Ivanis",
            "Izbicioara",
            "Izbita",
            "Izlaz",
            "Izvoarele",
            "Izvoarele",
            "Izvoru Ampoiului",
            "Jeflesti",
            "Jidostina",
            "Jidvei",
            "Jojei",
            "Joldisesti",
            "Jurcuiesti",
            "Laz",
            "Laz",
            "Lazuri",
            "Lazuri",
            "Lehesti",
            "Leorint",
            "Lespezea",
            "Limba",
            "Lipaia",
            "Livezile",
            "Lodroman",
            "Loman",
            "Lopadea Noua",
            "Lopadea Veche",
            "Luminesti",
            "Lunca",
            "Lunca",
            "Lunca",
            "Lunca",
            "Lunca Ampoitei",
            "Lunca Bisericii",
            "Lunca Goiesti",
            "Lunca Larga",
            "Lunca Larga",
            "Lunca Merilor",
            "Lunca Metesului",
            "Lunca Muresului",
            "Lunca Tarnavei",
            "Lunca Vesesti",
            "Lunca de Jos",
            "Lupu",
            "Lupulesti",
            "Lupaiesti",
            "Lupsa",
            "Lupseni",
            "Lazesti",
            "Lazesti",
            "Matei",
            "Medresti",
            "Medves",
            "Mereteu",
            "Mesentea",
            "Metes",
            "Mescreac",
            "Micoslaca",
            "Mihalt",
            "Mihaiesti",
            "Miraslau",
            "Modolesti",
            "Modolesti",
            "Mogos",
            "Morcanesti",
            "Moraresti",
            "Moraresti",
            "Muncelu",
            "Munesti",
            "Muntari",
            "Mununa",
            "Musca",
            "Macaresti",
            "Maghierat",
            "Magura",
            "Magura",
            "Mahaceni",
            "Mamaligani",
            "Mancesti",
            "Manarade",
            "Manastire",
            "Margaia",
            "Margineni",
            "Marinesti",
            "Martesti",
            "Martinie",
            "Matisesti",
            "Matisesti",
            "Matacina",
            "Necrilesti",
            "Necsesti",
            "Negesti",
            "Negresti",
            "Nelegesti",
            "Nemesi",
            "Nicoresti",
            "Niculesti",
            "Novacesti",
            "Noslac",
            "Nadastia",
            "Namas",
            "Napaiesti",
            "Obreja",
            "Ocna Mures",
            "Ocnisoara",
            "Ocoale",
            "Ocolis",
            "Odverem",
            "Ohaba",
            "Oidesti",
            "Oiejdea",
            "Olteni",
            "Oncesti",
            "Orgesti",
            "Ormenis",
            "Orasti",
            "Peles",
            "Perjesti",
            "Petelei",
            "Petreasa",
            "Petreni",
            "Petelca",
            "Pianu de Jos",
            "Pianu de Sus",
            "Pirita",
            "Pitarcesti",
            "Pitiga",
            "Plai",
            "Plai",
            "Plaiuri",
            "Plescuta",
            "Plesesti",
            "Plesi",
            "Plisti",
            "Podu lui Paul",
            "Poduri-Bricesti",
            "Poiana",
            "Poiana",
            "Poiana",
            "Poiana Aiudului",
            "Poiana Ampoiului",
            "Poiana Galdei",
            "Poiana Ursului",
            "Poiana Vadului",
            "Poieni",
            "Poieni",
            "Poieni",
            "Poienile-Mogos",
            "Poienita",
            "Poienita",
            "Poiu",
            "Ponor",
            "Ponorel",
            "Popesti",
            "Popestii de Jos",
            "Popestii de Sus",
            "Potionci",
            "Posaga de Jos",
            "Posaga de Sus",
            "Posogani",
            "Preluca",
            "Preluca",
            "Presaca Ampoiului",
            "Puiuletesti",
            "Purcareti",
            "Puselesti",
            "Panca",
            "Parau-Carbunari",
            "Parau Gruiului",
            "Parau lui Mihai",
            "Padure",
            "Padurea",
            "Panade",
            "Pantesti",
            "Patrusesti",
            "Patrutesti",
            "Patrangeni",
            "Patrahaitesti",
            "Pastesti",
            "Rachis",
            "Ravicesti",
            "Reciu",
            "Remetea",
            "Rimetea",
            "Robesti",
            "Rogoz",
            "Rosesti",
            "Rosia Montana",
            "Rosia de Secas",
            "Runc",
            "Runc",
            "Runc",
            "Runc",
            "Runcuri",
            "Rusesti",
            "Rusi",
            "Ramet",
            "Rachita",
            "Racatau",
            "Radesti",
            "Rahau",
            "Raicani",
            "Ratitis",
            "Razboieni-Cetate",
            "Sartas",
            "Scoarta",
            "Scarisoara",
            "Sebes",
            "Sebesel",
            "Sebisesti",
            "Secasel",
            "Segaj",
            "Sfoartea",
            "Sfarcea",
            "Sicoiesti",
            "Silivas",
            "Simulesti",
            "Snide",
            "Sohodol",
            "Sohodol",
            "Spatac",
            "Straja",
            "Stremt",
            "Strungari",
            "Sturu",
            "Stalnisoara",
            "Stana de Mures",
            "Stanesti",
            "Stauini",
            "Sub Piatra",
            "Sucesti",
            "Surdesti",
            "Suseni",
            "Sanbenedic",
            "Sancel",
            "Sancrai",
            "Sanmiclaus",
            "Santimbru",
            "Santamarie",
            "Sagagea",
            "Salciua de Jos",
            "Salciua de Sus",
            "Salistea",
            "Salistea-Deal",
            "Salagesti",
            "Saracsau",
            "Sasciori",
            "Tamboresti",
            "Tecsesti",
            "Teiu",
            "Teius",
            "Teleac",
            "Tibru",
            "Tolacesti",
            "Tomesti",
            "Tomnatec",
            "Tomutesti",
            "Tonea",
            "Totoi",
            "Totesti",
            "Trifesti",
            "Trifesti",
            "Trisoresti",
            "Trampoiele",
            "Trancesti",
            "Turdas",
            "Tarsa",
            "Tarsa-Plai",
            "Tartaria",
            "Tatarlaua",
            "Tau",
            "Tau Bistra",
            "Tauni",
            "Tauti",
            "Ungurei",
            "Unirea",
            "Urdes",
            "Vadu Motilor",
            "Vale in Jos",
            "Valea Abruzel",
            "Valea Alba",
            "Valea Barnii",
            "Valea Bucurului",
            "Valea Barlutesti",
            "Valea Cerbului",
            "Valea Ciuciului",
            "Valea Cocesti",
            "Valea Fagetului",
            "Valea Giogesti",
            "Valea Goblii",
            "Valea Holhorii",
            "Valea Inzelului",
            "Valea Larga",
            "Valea Lunga",
            "Valea Lupsii",
            "Valea Maciului",
            "Valea Mare",
            "Valea Mica",
            "Valea Mlacii",
            "Valea Morii",
            "Valea Manastirii",
            "Valea Negrilesii",
            "Valea Poienii",
            "Valea Poienii",
            "Valea Sasului",
            "Valea Uzei",
            "Valea Utului",
            "Valea Verde",
            "Valea Vintului",
            "Valea lui Mihai",
            "Valea Sesii",
            "Valea Sesii",
            "Valea Tupilor",
            "Vama Seaca",
            "Vanvucesti",
            "Verdesti",
            "Veseus",
            "Vidolm",
            "Vidra",
            "Vidrisoara",
            "Viezuri",
            "Vingard",
            "Vinta",
            "Vintu de Jos",
            "Vladesti",
            "Vladosesti",
            "Vulcan",
            "Vurpar",
            "Valcea",
            "Valcesti",
            "Valcaneasa",
            "Valtori",
            "Valtori",
            "Vartop",
            "Vartanesti",
            "Varsi-Rontu",
            "Varsii Mari",
            "Varsii Mici",
            "Vai",
            "Valeni",
            "Valeni",
            "Valisoara",
            "Vasesti",
            "Zlatna",
            "Zanzesti",
            "Zagris",
            "Zaries",
            "Intregalde",
            "Sard",
            "Sasa",
            "Seusa",
            "Sibot",
            "Silea",
            "Simocesti",
            "Soal",
            "Soicesti",
            "Soimus",
            "Sona",
            "Spring",
            "Spalnaca",
            "Stefanca",
            "Stei-Arieseni",
            "Stertesti",
            "Stiuleti",
            "Sugag",
            "Tarina",
            "Telna",
            "Tifra",
            "Toci",
            "Taranesti"
          ]
        },
        {
          name: "Arad",
          cities: [
            "Aciuta",
            "Adea",
            "Agrisu Mare",
            "Agrisu Mic",
            "Aldesti",
            "Almas",
            "Alunis",
            "Andrei Saguna",
            "Apateu",
            "Arad",
            "Archis",
            "Araneag",
            "Avram Iancu",
            "Avram Iancu",
            "Bacau de Mijloc",
            "Baia",
            "Baratca",
            "Bata",
            "Beliu",
            "Belotint",
            "Benesti",
            "Berechiu",
            "Berindia",
            "Birchis",
            "Bochia",
            "Bocsig",
            "Bodesti",
            "Bodrogu Nou",
            "Bodrogu Vechi",
            "Bontesti",
            "Botfei",
            "Brazii",
            "Brusturi",
            "Bruznic",
            "Buceava-Soimus",
            "Budesti",
            "Buhani",
            "Bulci",
            "Buteni",
            "Barsa",
            "Barzava",
            "Barzesti",
            "Banesti",
            "Batuta",
            "Camna",
            "Cermei",
            "Chelmac",
            "Cherelus",
            "Chesint",
            "Chier",
            "Chisindia",
            "Chisineu-Cris",
            "Chislaca",
            "Cicir",
            "Cil",
            "Cintei",
            "Ciuntesti",
            "Cladova",
            "Clit",
            "Cociuba",
            "Comanesti",
            "Conop",
            "Corbesti",
            "Coroi",
            "Covasant",
            "Craiva",
            "Cristesti",
            "Crocna",
            "Cruceni",
            "Cuias",
            "Cuied",
            "Curtici",
            "Cuvesdia",
            "Cuvin",
            "Calugareni",
            "Caprioara",
            "Capruta",
            "Capalnas",
            "Carand",
            "Dezna",
            "Dieci",
            "Donceni",
            "Dorgos",
            "Dorobanti",
            "Draut",
            "Dud",
            "Dulcele",
            "Dumbrava",
            "Dumbravita",
            "Felnac",
            "Fenis",
            "Firiteaz",
            "Fiscut",
            "Frumuseni",
            "Fantanele",
            "Galsa",
            "Ghioroc",
            "Groseni",
            "Grosi",
            "Grosii Noi",
            "Graniceri",
            "Gura Vaii",
            "Gurahont",
            "Gurba",
            "Hodis",
            "Hontisor",
            "Horia",
            "Hunedoara Timisana",
            "Halmagiu",
            "Halmagel",
            "Halalis",
            "Hasmas",
            "Iacobini",
            "Iercoseni",
            "Iermata",
            "Iermata Neagra",
            "Ignesti",
            "Ilteu",
            "Ineu",
            "Ionesti",
            "Iosas",
            "Iratosu",
            "Joia Mare",
            "Julita",
            "Labasint",
            "Lalasint",
            "Laz",
            "Lazuri",
            "Leasa",
            "Lestioara",
            "Lipova",
            "Livada",
            "Luguzau",
            "Luncsoara",
            "Lupesti",
            "Macea",
            "Mailat",
            "Mermesti",
            "Milova",
            "Minead",
            "Minis",
            "Minisel",
            "Minisu de Sus",
            "Misca",
            "Mocrea",
            "Moneasa",
            "Monorostia",
            "Moroda",
            "Motiori",
            "Munar",
            "Mustesti",
            "Mandruloc",
            "Manerau",
            "Masca",
            "Maderat",
            "Madrigesti",
            "Magulicea",
            "Manastur",
            "Maraus",
            "Nadas",
            "Neagra",
            "Nermis",
            "Neudorf",
            "Nicolae Balcescu",
            "Nadab",
            "Nadlac",
            "Nadalbesti",
            "Obarsia",
            "Odvos",
            "Olari",
            "Ostrov",
            "Pecica",
            "Peregu Mare",
            "Peregu Mic",
            "Pescari",
            "Petris",
            "Pilu",
            "Plescuta",
            "Poiana",
            "Poienari",
            "Prunisor",
            "Pancota",
            "Parnesti",
            "Paiuseni",
            "Patars",
            "Paulian",
            "Paulis",
            "Revetis",
            "Rogoz de Beliu",
            "Rostoci",
            "Rosia",
            "Rosia Noua",
            "Radesti",
            "Ranusa",
            "Rapsig",
            "Satu Mare",
            "Satu Mic",
            "Satu Nou",
            "Sebis",
            "Secaci",
            "Secas",
            "Secusigiu",
            "Sederhat",
            "Seleus",
            "Seliste",
            "Selistea",
            "Semlac",
            "Sintea Mare",
            "Sintea Mica",
            "Slatina de Cris",
            "Slatina de Mures",
            "Socodor",
            "Stejar",
            "Stoinesti",
            "Susag",
            "Susani",
            "Sambateni",
            "Sanleani",
            "Sanmartin",
            "Sanpaul",
            "Sanpetru German",
            "Santana",
            "Sarbi",
            "Salajeni",
            "Savarsin",
            "Taut",
            "Temesesti",
            "Tisa",
            "Tisa Noua",
            "Toc",
            "Troas",
            "Turnu",
            "Tarnova",
            "Tarnavita",
            "Tagadau",
            "Talagiu",
            "Talmaci",
            "Urvisu de Beliu",
            "Ususau",
            "Valea Mare",
            "Valea Mare",
            "Variasu Mare",
            "Variasu Mic",
            "Varnita",
            "Vasile Goldis",
            "Vidra",
            "Vinga",
            "Virismort",
            "Vladimirescu",
            "Voivodeni",
            "Vanatori",
            "Varfurile",
            "Varadia de Mures",
            "Varsand",
            "Vasoaia",
            "Zerind",
            "Zerindu Mic",
            "Zimandcuz",
            "Zimandu Nou",
            "Zimbru",
            "Zabalt",
            "Zabrani",
            "Zadareni",
            "Zarand",
            "Sagu",
            "Seitin",
            "Sepreus",
            "Siad",
            "Siclau",
            "Sicula",
            "Silindia",
            "Simand",
            "Siria",
            "Sistarovat",
            "Sofronea",
            "Somosches",
            "Tela",
            "Tipar",
            "Tohesti",
            "Tarmure"
          ]
        },
        {
          name: "Arges",
          cities: [
            "Adunati",
            "Afrimesti",
            "Albesti",
            "Albestii Pamanteni",
            "Albestii Ungureni",
            "Albota",
            "Albotele",
            "Alunis",
            "Alunisu",
            "Alunisu",
            "Anghinesti",
            "Aninoasa",
            "Arefu",
            "Argesani",
            "Argeselu",
            "Babaroaga",
            "Balabani",
            "Baloteasca",
            "Bascov",
            "Bascovele",
            "Beculesti",
            "Beleti",
            "Berevoesti",
            "Berindesti",
            "Bilcesti",
            "Blaju",
            "Blejani",
            "Bogati",
            "Bolculesti",
            "Bolovanesti",
            "Bordeieni",
            "Borlesti",
            "Borobanesti",
            "Borovinesti",
            "Boteni",
            "Botesti",
            "Botarcani",
            "Brabeti",
            "Bradu",
            "Branistea",
            "Bratia",
            "Bratia",
            "Brosteni",
            "Brosteni",
            "Branzari",
            "Bradetu",
            "Bradulet",
            "Braileni",
            "Brateasca",
            "Bratesti",
            "Bucov",
            "Bucsenesti",
            "Bucsenesti-Lotasi",
            "Budeasa Mare",
            "Budeasa Mica",
            "Budisteni",
            "Bughea de Jos",
            "Bughea de Sus",
            "Bujoi",
            "Bujoreni",
            "Bumbueni",
            "Bunesti",
            "Bunesti",
            "Burdea",
            "Burdesti",
            "Buretesti",
            "Burlusi",
            "Burnesti",
            "Buta",
            "Buzoesti",
            "Bantau",
            "Barla",
            "Barlogu",
            "Barloi",
            "Barsestii de Jos",
            "Barsestii de Sus",
            "Barzesti",
            "Babana",
            "Bacesti",
            "Badeni",
            "Badesti",
            "Badesti",
            "Badicea",
            "Badila",
            "Badislava",
            "Badulesti",
            "Baiculesti",
            "Baila",
            "Bajesti",
            "Bajanesti",
            "Balilesti",
            "Balilesti",
            "Balteni",
            "Baltata",
            "Banicesti",
            "Banaresti",
            "Barbalani",
            "Barbalatesti",
            "Barbatesti",
            "Baranesti",
            "Barasti",
            "Batrani",
            "Calotesti",
            "Capu Piscului",
            "Capu Piscului",
            "Catane",
            "Catanele",
            "Ceauresti",
            "Ceausesti",
            "Cepari",
            "Ceparii Pamanteni",
            "Ceparii Ungureni",
            "Cerbu",
            "Cerbureni",
            "Cersani",
            "Cetateni",
            "Chilii",
            "Chiritesti",
            "Chiritesti",
            "Chiritesti",
            "Chitani",
            "Chitesti",
            "Cicanesti",
            "Ciesti",
            "Ciobani",
            "Ciobanesti",
            "Ciocanu",
            "Ciocesti",
            "Ciocanesti",
            "Ciocanai",
            "Ciofrangeni",
            "Ciolcesti",
            "Ciomagesti",
            "Ciresu",
            "Ciulnita",
            "Ciupa-Manciulescu",
            "Ciuresti",
            "Cismea",
            "Clucereasa",
            "Cocenesti",
            "Cochinesti",
            "Cocu",
            "Colibasi",
            "Colnic",
            "Coltu",
            "Contesti",
            "Corbeni",
            "Corbi",
            "Corbsori",
            "Cornatel",
            "Cosaci",
            "Costesti",
            "Costesti",
            "Costesti-Valsan",
            "Costita",
            "Coteasca",
            "Cotenesti",
            "Cotesti",
            "Cotmeana",
            "Cotmeana",
            "Cotmenita",
            "Cotu",
            "Cotu",
            "Cotu Malului",
            "Coseri",
            "Cosesti",
            "Crintesti",
            "Crivatu",
            "Crucisoara",
            "Crampotani",
            "Cuca",
            "Cungrea",
            "Curtea de Arges",
            "Curteanca",
            "Campulung",
            "Candesti",
            "Carcesti",
            "Carciumaresti",
            "Carstieni",
            "Caldararu",
            "Calinesti",
            "Capatanenii Pamanteni",
            "Capatanenii Ungureni",
            "Carpenis",
            "Cateasca",
            "Catunasi",
            "Davidesti",
            "Deagu de Jos",
            "Deagu de Sus",
            "Dealu",
            "Dealu Bisericii",
            "Dealu Bradului",
            "Dealu Frumos",
            "Dealu Obejdeanului",
            "Dealu Orasului",
            "Dealu Padurii",
            "Dealu Tolcesii",
            "Dealu Viilor",
            "Dealu Viilor",
            "Dedulesti",
            "Diconesti",
            "Dincani",
            "Dinculesti",
            "Doblea",
            "Dobresti",
            "Dobrogostea",
            "Dobrotu",
            "Dogari",
            "Domnesti",
            "Dragoslavele",
            "Draganu-Olteni",
            "Draghescu",
            "Draghicesti",
            "Draghici",
            "Dragolesti",
            "Dumbrava",
            "Dumbravesti",
            "Dumiresti",
            "Dambovicioara",
            "Darmanesti",
            "Enculesti",
            "Fata",
            "Fedelesoiu",
            "Florieni",
            "Fratesti",
            "Fratici",
            "Furduesti",
            "Furesti",
            "Furnicosi",
            "Falfani",
            "Fantanea",
            "Facaletesti",
            "Fagetu",
            "Galesu",
            "Geamana",
            "Giuclani",
            "Glavacioc",
            "Gliganu de Jos",
            "Gliganu de Sus",
            "Glodu",
            "Glodu",
            "Glambocata",
            "Glambocata-Deal",
            "Glambocel",
            "Glambocelu",
            "Glambocu",
            "Godeni",
            "Goia",
            "Goleasca",
            "Golesti",
            "Golesti",
            "Gorani",
            "Gorganu",
            "Goranesti",
            "Greaban",
            "Greabanu",
            "Grosani",
            "Grosi",
            "Gruiu",
            "Gruiu",
            "Gura Pravat",
            "Gura Vaii",
            "Galcesti",
            "Gainusa",
            "Galesesti",
            "Galeteanu",
            "Galasesti",
            "Gamacesti",
            "Ganesti",
            "Gardinesti",
            "Gaujani",
            "Hintesti",
            "Huluba",
            "Humele",
            "Harsesti",
            "Hartiesti",
            "Ianculesti",
            "Ioanicesti",
            "Ionesti",
            "Izbasesti",
            "Izvorani",
            "Izvoru",
            "Izvoru de Jos",
            "Izvoru de Sus",
            "Jgheaburi",
            "Jugur",
            "Jupanesti",
            "Lacurile",
            "Leicesti",
            "Lentea",
            "Leordeni",
            "Leresti",
            "Lespezi",
            "Lesile",
            "Lintesti",
            "Lipia",
            "Livezeni",
            "Loturi",
            "Lucieni",
            "Luminile",
            "Lunca",
            "Lunca Corbului",
            "Lunca Gartii",
            "Lungani",
            "Lungulesti",
            "Lupueni",
            "Laceni",
            "Laicai",
            "Langesti",
            "Lapusani",
            "Launele de Sus",
            "Lazaresti",
            "Lazaresti",
            "Malu",
            "Malu",
            "Malu Vanat",
            "Mares",
            "Martalogi",
            "Mavrodolu",
            "Merisani",
            "Metofu",
            "Mica",
            "Micesti",
            "Miercani",
            "Mihaesti",
            "Mioarele",
            "Mioveni",
            "Mirosi",
            "Moara Mocanului",
            "Mogosesti",
            "Moraresti",
            "Morasti",
            "Mozacu",
            "Mozaceni",
            "Mozacenii-Vale",
            "Mosoaia",
            "Mosteni-Greci",
            "Mustatesti",
            "Muscel",
            "Musatesti",
            "Mandra",
            "Marghia de Jos",
            "Marghia de Sus",
            "Martesti",
            "Macai",
            "Malureni",
            "Mancioiu",
            "Manesti",
            "Manicesti",
            "Maracineni",
            "Matau",
            "Negesti",
            "Negrasi",
            "Negreni",
            "Negresti",
            "Nejlovelu",
            "Nigrisoara",
            "Nucsoara",
            "Namaesti",
            "Oarja",
            "Odaeni",
            "Oestii Pamanteni",
            "Oestii Ungureni",
            "Ogrezea",
            "Opresti",
            "Orodel",
            "Otelu",
            "Palanga",
            "Paltenu",
            "Paraschivesti",
            "Petresti",
            "Piatra",
            "Piatra",
            "Piatra",
            "Pielesti",
            "Pietroasa",
            "Pietrosani",
            "Piscani",
            "Pitesti",
            "Pitoi",
            "Pitigaia",
            "Podeni",
            "Podisoru",
            "Podu Brosteni",
            "Podu Dambovitei",
            "Poduri",
            "Poiana Lacului",
            "Poienari",
            "Poienari",
            "Poienari",
            "Poienita",
            "Poienarei",
            "Pojorata",
            "Popesti",
            "Popesti",
            "Popesti",
            "Priboaia",
            "Priboieni",
            "Priseaca",
            "Prislopu Mare",
            "Prislopu Mic",
            "Prodani",
            "Prosia",
            "Purcareni",
            "Purcareni",
            "Putina",
            "Parvu Rosu",
            "Pacioiu",
            "Padureni",
            "Padureti",
            "Paduroiu din Deal",
            "Paduroiu din Vale",
            "Patuleni",
            "Pauleasca",
            "Pauleasca",
            "Pauleni",
            "Paunesti",
            "Racovita",
            "Radu Negru",
            "Recea",
            "Recea",
            "Redea",
            "Retevoiesti",
            "Robaia",
            "Rociu",
            "Rogojina",
            "Romana",
            "Rotunda",
            "Rucar",
            "Rudeni",
            "Rudeni",
            "Ruginoasa",
            "Raca",
            "Rajletu-Govora",
            "Rancaciov",
            "Rachitele de Jos",
            "Rachitele de Sus",
            "Radesti",
            "Radutesti",
            "Ratesti",
            "Ratoi",
            "Satu Nou",
            "Sboghitesti",
            "Schiau",
            "Schitu Golesti",
            "Schitu Scoicesti",
            "Schitu-Matei",
            "Silistea",
            "Silisteni",
            "Sinesti",
            "Slatina",
            "Slobozia",
            "Slobozia",
            "Slobozia",
            "Slamnesti",
            "Slanic",
            "Slatioarele",
            "Smei",
            "Smeura",
            "Spiridoni",
            "Stejari",
            "Stoenesti",
            "Stolnici",
            "Stroesti",
            "Strambeni",
            "Strambeni",
            "Stalpeni",
            "Starci",
            "Stanesti",
            "Stanicei",
            "Surdulesti",
            "Suseni",
            "Suseni",
            "Suslanesti",
            "Salistea",
            "Salatrucu",
            "Samara",
            "Samaila",
            "Sandulesti",
            "Sapunari",
            "Satic",
            "Teiu",
            "Teodoresti",
            "Tigveni",
            "Tigveni",
            "Tomulesti",
            "Tomsanca",
            "Toplita",
            "Topoloveni",
            "Turburea",
            "Turcesti",
            "Tutana",
            "Uda",
            "Udeni-Zavoi",
            "Uiasca",
            "Uleni",
            "Ulita",
            "Ungheni",
            "Ungureni",
            "Ungureni",
            "Urechesti",
            "Urlucea",
            "Urlueni",
            "Urluiesti",
            "Ursoaia",
            "Valea Bradului",
            "Valea Brazilor",
            "Valea Badenilor",
            "Valea Calului",
            "Valea Cetatuia",
            "Valea Corbului",
            "Valea Cucii",
            "Valea Danului",
            "Valea Faurului",
            "Valea Hotarului",
            "Valea Iasului",
            "Valea Mare",
            "Valea Mare Pravat",
            "Valea Mare-Bratia",
            "Valea Mare-Podgoria",
            "Valea Muscelului",
            "Valea Magurei",
            "Valea Manastirii",
            "Valea Marului",
            "Valea Nandrii",
            "Valea Nenii",
            "Valea Pechii",
            "Valea Popii",
            "Valea Popii",
            "Valea Rizii",
            "Valea Silistii",
            "Valea Stanii",
            "Valea Uleiului",
            "Valea Ursului",
            "Valea lui Enache",
            "Valea lui Mas",
            "Valea Indarat",
            "Vata",
            "Vedea",
            "Vernesti",
            "Vetisoara",
            "Viisoara",
            "Vladesti",
            "Vladesti",
            "Vladuta",
            "Vlascuta",
            "Voinesti",
            "Vonigeasa",
            "Voroveni",
            "Vranesti",
            "Vulpesti",
            "Vulturesti",
            "Valcelele",
            "Valsanesti",
            "Varloveni",
            "Varsesti",
            "Vacarea",
            "Valeni",
            "Valeni-Podgoria",
            "Varzaru",
            "Varzaroaia",
            "Zamfiresti",
            "Zamfiresti",
            "Zgripcesti",
            "Zidurile",
            "Zigoneni",
            "Zuvelcati",
            "Zarnesti",
            "Zavoi",
            "Selari",
            "Selareasca",
            "Sendrulesti",
            "Serboeni",
            "Serbanesti",
            "Serbanesti",
            "Stefan cel Mare",
            "Stefanesti",
            "Stefanesti",
            "Stefanestii Noi",
            "Suici",
            "Tiganesti",
            "Titesti",
            "Tutulesti"
          ]
        },
        {
          name: "Bacau",
          cities: [
            "Agas",
            "Albele",
            "Antohesti",
            "Apa Asau",
            "Ardeoani",
            "Arini",
            "Asau",
            "Bacau",
            "Bahna",
            "Balcani",
            "Balotesti",
            "Banca",
            "Barati",
            "Barcana",
            "Barna",
            "Bazga",
            "Belciuneasa",
            "Beleghet",
            "Benesti",
            "Berbinceni",
            "Beresti",
            "Beresti-Bistrita",
            "Beresti-Tazlau",
            "Berzunti",
            "Bibiresti",
            "Bijghir",
            "Blaga",
            "Blidari",
            "Blagesti",
            "Boanta",
            "Bobos",
            "Bodeasa",
            "Bogata",
            "Bogdan Voda",
            "Bogdana",
            "Bogdanesti",
            "Bogdanesti",
            "Bogdanesti",
            "Boistea",
            "Boistea de Jos",
            "Bolovanis",
            "Bolatau",
            "Borsani",
            "Bosia",
            "Bostanesti",
            "Bota",
            "Botesti",
            "Bosoteni",
            "Brad",
            "Brad",
            "Brad",
            "Brusturoasa",
            "Bratesti",
            "Bratila",
            "Buchila",
            "Buciumi",
            "Bucsa",
            "Bucsesti",
            "Buda",
            "Buda",
            "Buda",
            "Budesti",
            "Buhocel",
            "Buhoci",
            "Buhusi",
            "Burdusaci",
            "Buruienis",
            "Buruienisu de Sus",
            "Baclesti",
            "Balca",
            "Barsanesti",
            "Barzulesti",
            "Bacioiu",
            "Bahnaseni",
            "Baimac",
            "Balaia",
            "Balusa",
            "Balaneasa",
            "Balanesti",
            "Balanesti",
            "Baltata",
            "Barboasa",
            "Barnesti",
            "Bartasesti",
            "Basasti",
            "Calapodesti",
            "Camenca",
            "Capata",
            "Caraclau",
            "Casin",
            "Cernu",
            "Cetatuia",
            "Chetreni",
            "Chetris",
            "Chicerea",
            "Chilia Benei",
            "Chiticeni",
            "Ciobanus",
            "Ciucani",
            "Ciughes",
            "Ciumasi",
            "Ciuturesti",
            "Cleja",
            "Climesti",
            "Cociu",
            "Colonesti",
            "Coman",
            "Comanesti",
            "Contesti",
            "Corbasca",
            "Cornet",
            "Cornesti",
            "Cornii de Jos",
            "Cornii de Sus",
            "Cornatel",
            "Cornatelu",
            "Costei",
            "Coteni",
            "Cotu Grosului",
            "Cotumba",
            "Cosnea",
            "Cotofanesti",
            "Crihan",
            "Craiesti",
            "Cuchinis",
            "Cucova",
            "Cucuieti",
            "Cucuieti",
            "Curita",
            "Campeni",
            "Carligi",
            "Cabesti",
            "Cadaresti",
            "Caiuti",
            "Calcai",
            "Calinesti",
            "Calini",
            "Calugareni",
            "Capotesti",
            "Cauia",
            "Dealu Mare",
            "Dealu Morii",
            "Dealu Perjului",
            "Deleni",
            "Diaconesti",
            "Dienet",
            "Dofteana",
            "Dorneni",
            "Dorneni",
            "Dorofei",
            "Dospinesti",
            "Dragomir",
            "Dragesti",
            "Dragesti",
            "Dragugesti",
            "Dragusani",
            "Dumbrava",
            "Dumbrava",
            "Dumbrava",
            "Dumbraveni",
            "Dadesti",
            "Damienesti",
            "Danaila",
            "Darmaneasca",
            "Darmanesti",
            "Enachesti",
            "Faraoani",
            "Farcasa",
            "Ferestrau-Oituz",
            "Fichitesti",
            "Filipeni",
            "Filipesti",
            "Filipesti",
            "Floresti",
            "Floresti",
            "Floresti",
            "Frumoasa",
            "Frumuselu",
            "Fruntesti",
            "Fulgeris",
            "Fundeni",
            "Fundoaia",
            "Fundu Racaciuni",
            "Fundu Tutovei",
            "Fundu Vaii",
            "Fundatura",
            "Fundatura Rachitoasa",
            "Furnicari",
            "Fantanele",
            "Fantanele",
            "Faget",
            "Fagetu de Sus",
            "Fagetel",
            "Faghieni",
            "Galbeni",
            "Galbeni",
            "Galeri",
            "Gheorghe Doja",
            "Gherdana",
            "Ghilavesti",
            "Ghimes",
            "Ghionoaia",
            "Gioseni",
            "Giurgeni",
            "Giurgioana",
            "Glodisoarele",
            "Glavanesti",
            "Godinestii de Jos",
            "Godinestii de Sus",
            "Goioasa",
            "Gorghesti",
            "Grigoreni",
            "Gradesti",
            "Gura Craiesti",
            "Gura Vaii",
            "Gura Vaii",
            "Gutinas",
            "Garla Anei",
            "Garleni",
            "Garlenii de Sus",
            "Gasteni",
            "Gaiceana",
            "Hanta",
            "Helegiu",
            "Heltiu",
            "Hemeius",
            "Hemieni",
            "Hertioana de Jos",
            "Hertioana-Razesi",
            "Holt",
            "Horgesti",
            "Huruiesti",
            "Hutu",
            "Hanganesti",
            "Harja",
            "Harlesti",
            "Haghiac",
            "Haghiac",
            "Haineala",
            "Halmacioaia",
            "Iaz",
            "Iliesi",
            "Itesti",
            "Izvoru Berheciului",
            "Itcani",
            "Lapos",
            "Larga",
            "Lehancea",
            "Leontinesti",
            "Lespezi",
            "Letea Veche",
            "Lichitiseni",
            "Lilieci",
            "Lipova",
            "Livezi",
            "Ludasi",
            "Luizi-Calugara",
            "Lunca Asau",
            "Lunca Dochiei",
            "Luncani",
            "Lupesti",
            "Larguta",
            "Magazia",
            "Marginea",
            "Marvila",
            "Mateiesti",
            "Medeleni",
            "Milestii de Jos",
            "Milestii de Sus",
            "Misihanesti",
            "Moinesti",
            "Motoc",
            "Motocesti",
            "Motoseni",
            "Movilita",
            "Muncelu",
            "Magla",
            "Malosu",
            "Magiresti",
            "Magura",
            "Manastirea Casin",
            "Marcesti",
            "Margineni",
            "Marascu",
            "Marasti",
            "Nadisa",
            "Nazarioaia",
            "Negoiesti",
            "Negreni",
            "Negri",
            "Negulesti",
            "Neguseni",
            "Nicolae Balcescu",
            "Nicoresti",
            "Nanesti",
            "Nastaseni",
            "Obarsia",
            "Ocheni",
            "Odobesti",
            "Oituz",
            "Oncesti",
            "Oncestii Vechi",
            "Onesti",
            "Oniscani",
            "Oprisesti",
            "Orbeni",
            "Orasa",
            "Osebiti",
            "Otelesti",
            "Pajistea",
            "Palanca",
            "Parava",
            "Parincea",
            "Perchiu",
            "Petresti",
            "Petricica",
            "Plopana",
            "Plopu",
            "Plopu",
            "Podis",
            "Podu Turcului",
            "Poduri",
            "Poglet",
            "Poiana",
            "Poiana",
            "Poiana",
            "Poiana",
            "Poiana",
            "Poiana Negustorului",
            "Poiana Sarata",
            "Poieni",
            "Poieni",
            "Popeni",
            "Popesti",
            "Popoiu",
            "Praja",
            "Pralea",
            "Preluci",
            "Prisaca",
            "Prohozesti",
            "Pradais",
            "Prajesti",
            "Prajesti",
            "Prajoaia",
            "Pustiana",
            "Putini",
            "Putredeni",
            "Pancesti",
            "Pargaresti",
            "Parjol",
            "Parvulesti",
            "Parau Boghii",
            "Padureni",
            "Padureni",
            "Padureni",
            "Padureni",
            "Padureni",
            "Pagubeni",
            "Paltinata",
            "Paltinis",
            "Pancesti",
            "Racova",
            "Radomiresti",
            "Recea",
            "Reprivat",
            "Rogoaza",
            "Romanesti",
            "Rotaria",
            "Rosiori",
            "Rusenii Razesi",
            "Rusenii de Sus",
            "Rusi-Ciutea",
            "Rachitis",
            "Rachitisu",
            "Rachitoasa",
            "Racusana",
            "Racaciuni",
            "Racatau de Jos",
            "Racatau-Razesi",
            "Racauti",
            "Radeana",
            "Radoaia",
            "Rastoaca",
            "Razesu",
            "Sascut",
            "Sascut-Sat",
            "Satu Nou",
            "Satu Nou",
            "Satu Nou",
            "Satu Nou",
            "Satu Nou",
            "Satu Nou",
            "Schineni",
            "Schineni",
            "Schitu Frumoasa",
            "Scorteni",
            "Scurta",
            "Scutaru",
            "Scariga",
            "Scarisoara",
            "Seaca",
            "Secuieni",
            "Siretu",
            "Siretu",
            "Slobozia",
            "Slobozia",
            "Slobozia",
            "Slobozia Noua",
            "Slanic-Moldova",
            "Soci",
            "Sohodol",
            "Sohodor",
            "Solont",
            "Somusca",
            "Spria",
            "Stejaru",
            "Straja",
            "Strugari",
            "Straminoasa",
            "Stufu",
            "Stanesti",
            "Stanisesti",
            "Sulta",
            "Sarbi",
            "Salatruc",
            "Sanduleni",
            "Sarata",
            "Sarata",
            "Saucesti",
            "Tamasi",
            "Tarnita",
            "Taula",
            "Teius",
            "Temelia",
            "Tescani",
            "Tisa",
            "Tisa-Silvestri",
            "Tochilea",
            "Tomozia",
            "Traian",
            "Trebes",
            "Turluianu",
            "Tuta",
            "Targu Ocna",
            "Targu Trotus",
            "Tamasoaia",
            "Tarhausi",
            "Tarata",
            "Tatarasti",
            "Tavadaresti",
            "Ungureni",
            "Ungureni",
            "Urechesti",
            "Ursoaia",
            "Valea Arinilor",
            "Valea Botului",
            "Valea Budului",
            "Valea Caselor",
            "Valea Fanatului",
            "Valea Hogei",
            "Valea Lupului",
            "Valea Mare",
            "Valea Mare",
            "Valea Merilor",
            "Valea Mica",
            "Valea Mica",
            "Valea Mosneagului",
            "Valea Marului",
            "Valea Nacului",
            "Valea Salciei",
            "Valea Seaca",
            "Valea Seaca",
            "Valea lui Ion",
            "Valea Sosii",
            "Versesti",
            "Viforeni",
            "Viisoara",
            "Viisoara",
            "Vladnic",
            "Vranceni",
            "Vultureni",
            "Valcele",
            "Valeni",
            "Valeni",
            "Valeni",
            "Zemes",
            "Zlatari",
            "Zapodia",
            "Zapodia",
            "Sendresti",
            "Serbesti",
            "Serpeni",
            "Sesuri",
            "Stefan Voda",
            "Stefan cel Mare",
            "Surina",
            "Tepoaia",
            "Tiganesti",
            "Tagara",
            "Tardenii Mari"
          ]
        },
        {
          name: "Bihor",
          cities: [
            "Abram",
            "Abramut",
            "Adoni",
            "Albesti",
            "Albis",
            "Alesd",
            "Almasu Mare",
            "Almasu Mic",
            "Almasu Mic",
            "Alparea",
            "Ant",
            "Apateu",
            "Arpasel",
            "Ateas",
            "Auseu",
            "Avram Iancu",
            "Astileu",
            "Balc",
            "Batar",
            "Beius",
            "Beiusele",
            "Belejeni",
            "Belfir",
            "Berechiu",
            "Betfia",
            "Beznea",
            "Bicaci",
            "Bicacel",
            "Biharia",
            "Birtin",
            "Bistra",
            "Bogei",
            "Boianu Mare",
            "Boiu",
            "Borod",
            "Borozel",
            "Borumlaca",
            "Borz",
            "Bors",
            "Borsa",
            "Botean",
            "Bratca",
            "Briheni",
            "Brusturi",
            "Brusturi",
            "Bradet",
            "Bratesti",
            "Bucium",
            "Bucuroaia",
            "Budoi",
            "Budureasa",
            "Buduslau",
            "Bulz",
            "Buntesti",
            "Burda",
            "Burzuc",
            "Butani",
            "Balc",
            "Baile Felix",
            "Balaia",
            "Baleni",
            "Balnaca",
            "Balnaca-Grosi",
            "Cacuciu Nou",
            "Cacuciu Vechi",
            "Calea Mare",
            "Cauaceu",
            "Cefa",
            "Ceica",
            "Ceisoara",
            "Cenalos",
            "Cetariu",
            "Cetea",
            "Cherechiu",
            "Cheresig",
            "Cheriu",
            "Chesa",
            "Chesereu",
            "Chijic",
            "Chioag",
            "Chiraleu",
            "Chiribis",
            "Chistag",
            "Chiscau",
            "Chisirid",
            "Chislaz",
            "Cihei",
            "Ciuhoi",
            "Ciulesti",
            "Ciumeghiu",
            "Ciutelec",
            "Cociuba Mare",
            "Cociuba Mica",
            "Codrisoru",
            "Codru",
            "Cohani",
            "Copacel",
            "Copaceni",
            "Corbesti",
            "Corboaia",
            "Cordau",
            "Cornisesti",
            "Cornitel",
            "Cotiglet",
            "Cosdeni",
            "Crestur",
            "Cresuia",
            "Cristioru de Jos",
            "Cristioru de Sus",
            "Crancesti",
            "Cucuceni",
            "Cuiesd",
            "Curtuiseni",
            "Curatele",
            "Cusuius",
            "Cuzap",
            "Campani",
            "Campani de Pomezeu",
            "Cabesti",
            "Calacea",
            "Calugari",
            "Calatani",
            "Calatea",
            "Capalna",
            "Carpinet",
            "Carandeni",
            "Caranzel",
            "Carasau",
            "Cauasd",
            "Damis",
            "Derna",
            "Dernisoara",
            "Dicanesti",
            "Dijir",
            "Diosig",
            "Dobresti",
            "Dobricionesti",
            "Dolea",
            "Dragesti",
            "Dragoteni",
            "Draganesti",
            "Dumbrava",
            "Dumbravani",
            "Dumbravita",
            "Dumbravita de Codru",
            "Dusesti",
            "Fegernic",
            "Fegernicu Nou",
            "Felcheriu",
            "Feneris",
            "Ferice",
            "Finis",
            "Fizis",
            "Foglas",
            "Fonau",
            "Forosig",
            "Forau",
            "Fughiu",
            "Fanate",
            "Fasca",
            "Fancica",
            "Galospetreu",
            "Gepiu",
            "Gepis",
            "Gheghie",
            "Ghida",
            "Ghighiseni",
            "Ghiorac",
            "Ginta",
            "Girisu Negru",
            "Girisu de Cris",
            "Giulesti",
            "Goila",
            "Grosi",
            "Gruilung",
            "Gradinari",
            "Gurani",
            "Gurbediu",
            "Gurbesti",
            "Gurbesti",
            "Galaseni",
            "Haieu",
            "Hidis",
            "Hidisel",
            "Hidiselu de Jos",
            "Hidiselu de Sus",
            "Hinchiris",
            "Hodis",
            "Hodisel",
            "Hodos",
            "Holod",
            "Homorog",
            "Hotar",
            "Hotarel",
            "Husasau de Cris",
            "Husasau de Tinca",
            "Huta",
            "Huta Voivozi",
            "Harsesti",
            "Haucesti",
            "Ianca",
            "Ianosda",
            "Inand",
            "Incesti",
            "Ineu",
            "Ioanis",
            "Iteu",
            "Iteu Nou",
            "Izbuc",
            "Izvoarele",
            "Josani",
            "Josani",
            "Lacu Sarat",
            "Lazuri",
            "Lazuri de Beius",
            "Leheceni",
            "Lelesti",
            "Les",
            "Livada Beiusului",
            "Livada de Bihor",
            "Loranta",
            "Lorau",
            "Lugasu de Jos",
            "Lugasu de Sus",
            "Lunca",
            "Luncasprie",
            "Luncsoara",
            "Lupoaia",
            "Lazareni",
            "Marghita",
            "Margine",
            "Meziad",
            "Mierag",
            "Mierlau",
            "Miersig",
            "Mihai Bravu",
            "Miheleu",
            "Mizies",
            "Misca",
            "Motesti",
            "Munteni",
            "Madaras",
            "Magesti",
            "Magura",
            "Martihaz",
            "Nimaiesti",
            "Niuved",
            "Nojorid",
            "Nucet",
            "Nadar",
            "Ogesti",
            "Olcea",
            "Oradea",
            "Ortiteag",
            "Orvisele",
            "Otomani",
            "Osand",
            "Osorhei",
            "Paleu",
            "Palota",
            "Parhida",
            "Petid",
            "Petrani",
            "Petreasa",
            "Petreu",
            "Petrileni",
            "Pestere",
            "Picleu",
            "Pietroasa",
            "Pocioveliste",
            "Poclusa de Barcau",
            "Poclusa de Beius",
            "Pocola",
            "Poiana",
            "Poiana",
            "Poiana Tasad",
            "Poienii de Jos",
            "Poienii de Sus",
            "Poietari",
            "Pomezeu",
            "Ponoara",
            "Popesti",
            "Posoloaca",
            "Prisaca",
            "Pacalesti",
            "Padureni",
            "Pagaia",
            "Pantasesti",
            "Paulesti",
            "Pausa",
            "Reghea",
            "Remetea",
            "Remeti",
            "Rieni",
            "Rogoz",
            "Rohani",
            "Roit",
            "Rontau",
            "Rotaresti",
            "Rosia",
            "Rosiori",
            "Rugea",
            "Rapa",
            "Rabagani",
            "Racas",
            "Saca",
            "Sacalasau",
            "Sacalasau Nou",
            "Salonta",
            "Santaul Mare",
            "Santaul Mic",
            "Sarcau",
            "Satu Barba",
            "Satu Nou",
            "Sebis",
            "Seghiste",
            "Sfarnas",
            "Sighistel",
            "Sitani",
            "Sititelec",
            "Socet",
            "Sohodol",
            "Spinus",
            "Spinus de Pomezeu",
            "Stracos",
            "Stancesti",
            "Subpiatra",
            "Sudrigiu",
            "Suiug",
            "Suplacu de Barcau",
            "Suplacu de Tinca",
            "Surduc",
            "Surducel",
            "Sambata",
            "Saniob",
            "Sanlazar",
            "Sanmartin",
            "Sanmartin de Beius",
            "Sannicolau Roman",
            "Sannicolau de Beius",
            "Santandrei",
            "Santelec",
            "Santimreu",
            "Santion",
            "Sarbesti",
            "Sarbi",
            "Sabolciu",
            "Sacueni",
            "Sacadat",
            "Salacea",
            "Salard",
            "Saldabagiu Mic",
            "Saldabagiu de Barcau",
            "Saldabagiu de Munte",
            "Saliste",
            "Saliste de Beius",
            "Saliste de Pomezeu",
            "Saliste de Vascau",
            "Sarand",
            "Sarsig",
            "Saucani",
            "Saud",
            "Talpe",
            "Talpos",
            "Tarcea",
            "Teleac",
            "Telechiu",
            "Tileagd",
            "Tilecus",
            "Tinca",
            "Toboliu",
            "Tomnatic",
            "Topa de Cris",
            "Topa de Jos",
            "Topa de Sus",
            "Topesti",
            "Totoreni",
            "Tria",
            "Tulca",
            "Targusor",
            "Tamasda",
            "Tamaseu",
            "Tarcaia",
            "Tarcaita",
            "Tarian",
            "Taut",
            "Tautelec",
            "Tauteu",
            "Tasad",
            "Ucuris",
            "Uileacu de Beius",
            "Uileacu de Cris",
            "Uileacu de Munte",
            "Ursad",
            "Urvind",
            "Urvis de Beius",
            "Vadu Crisului",
            "Vaida",
            "Valea Cerului",
            "Valea Crisului",
            "Valea Mare de Codru",
            "Valea Mare de Cris",
            "Valea Tarnei",
            "Valea de Jos",
            "Valea de Sus",
            "Valea lui Mihai",
            "Varasau",
            "Varviz",
            "Vascau",
            "Viisoara",
            "Vintere",
            "Voivozi",
            "Voivozi",
            "Valcelele",
            "Varciorog",
            "Valani de Pomezeu",
            "Valanii de Beius",
            "Varzari",
            "Varaseni",
            "Vasad",
            "Zece Hotare",
            "Zavoiu",
            "Sauaieu",
            "Serani",
            "Serghis",
            "Silindru",
            "Simian",
            "Sinteu",
            "Sisterea",
            "Soimi",
            "Soimus",
            "Stei",
            "Sumugiu",
            "Suncuius",
            "Suncuis",
            "Sustiu",
            "Susturogi",
            "Tetchea",
            "Tiganestii de Beius",
            "Tiganestii de Cris"
          ]
        },
        {
          name: "Bistrita-Nasaud",
          cities: [
            "Agries",
            "Agriesel",
            "Agrisu de Jos",
            "Agrisu de Sus",
            "Albestii Bistritei",
            "Alunisul",
            "Anies",
            "Apatiu",
            "Arcalia",
            "Archiud",
            "Ardan",
            "Arsita",
            "Bata",
            "Beclean",
            "Beudiu",
            "Bichigiu",
            "Bidiu",
            "Bistrita",
            "Bistrita Bargaului",
            "Blajenii de Jos",
            "Blajenii de Sus",
            "Borleasa",
            "Bozies",
            "Branistea",
            "Breaza",
            "Bretea",
            "Brateni",
            "Budacu de Jos",
            "Budacu de Sus",
            "Budesti",
            "Budesti-Fanate",
            "Budurleni",
            "Budus",
            "Bungard",
            "Buza Catun",
            "Barla",
            "Caila",
            "Cepari",
            "Chetiu",
            "Chintelnic",
            "Chiochis",
            "Chirales",
            "Chiuza",
            "Ciceu-Corabia",
            "Ciceu-Giurgesti",
            "Ciceu-Mihaiesti",
            "Ciceu-Poieni",
            "Ciosa",
            "Cireasi",
            "Ciresoaia",
            "Coasta",
            "Cociu",
            "Coldau",
            "Colibita",
            "Comlod",
            "Corvinesti",
            "Cosbuc",
            "Coseriu",
            "Crainimat",
            "Cristestii Ciceului",
            "Cristur-Sieu",
            "Cusma",
            "Camp",
            "Caianu Mare",
            "Caianu Mic",
            "Dealul Stefanitei",
            "Delureni",
            "Dipsa",
            "Dobric",
            "Dobricel",
            "Domnesti",
            "Dorolea",
            "Draga",
            "Dumbrava",
            "Dumbrava",
            "Dumbraveni",
            "Dumbravita",
            "Dumitra",
            "Dumitrita",
            "Dupa Deal",
            "Enciu",
            "Feldru",
            "Feleac",
            "Fiad",
            "Figa",
            "Floresti",
            "Fanate",
            "Fanatele Silivasului",
            "Fantanele",
            "Fantanita",
            "Galatii Bistritei",
            "Gersa I",
            "Gersa II",
            "Ghemes",
            "Gledin",
            "Herina",
            "Hirean",
            "Halmasau",
            "Hasmasu Ciceului",
            "Ilisua",
            "Ilva Mare",
            "Ilva Mica",
            "Ivaneasa",
            "Jeica",
            "Jelna",
            "Jimbor",
            "Josenii Bargaului",
            "La Curte",
            "Lechinta",
            "Lelesti",
            "Lesu",
            "Livezile",
            "Lunca",
            "Lunca Borlesei",
            "Lunca Ilvei",
            "Lunca Lesului",
            "Lunca Sateasca",
            "Maieru",
            "Malin",
            "Manic",
            "Matei",
            "Micestii de Campie",
            "Mijlocenii Bargaului",
            "Milas",
            "Mintiu",
            "Mires",
            "Mititei",
            "Mocod",
            "Mogoseni",
            "Moliset",
            "Monariu",
            "Monor",
            "Morut",
            "Muresenii Bargaului",
            "Magura Ilvei",
            "Magurele",
            "Malut",
            "Mariselu",
            "Negrilesti",
            "Nepos",
            "Neteni",
            "Nimigea de Jos",
            "Nimigea de Sus",
            "Nuseni",
            "Nasaud",
            "Oarzina",
            "Ocnita",
            "Orheiu Bistritei",
            "Orosfaia",
            "Parva",
            "Perisor",
            "Petris",
            "Piatra",
            "Piatra Fantanele",
            "Pinticu",
            "Podenii",
            "Poderei",
            "Podirei",
            "Poiana Ilvei",
            "Poienile Zagrei",
            "Porumbenii",
            "Posmus",
            "Prundu Bargaului",
            "Purcarete",
            "Paltineasa",
            "Ragla",
            "Rebra",
            "Rebrisoara",
            "Reteag",
            "Rodna",
            "Romuli",
            "Runcu Salvei",
            "Rusu Bargaului",
            "Rusu de Jos",
            "Rusu de Sus",
            "Rustior",
            "Racatesu",
            "Salva",
            "Satu Nou",
            "Scoabe",
            "Sebis",
            "Silivasu de Campie",
            "Simionesti",
            "Sita",
            "Spermezeu",
            "Strugureni",
            "Stramba",
            "Stupini",
            "Suplai",
            "Susenii Bargaului",
            "Sangeorz-Bai",
            "Sangeorzu Nou",
            "Saniacob",
            "Sanmihaiu de Campie",
            "Sannicoara",
            "Santioana",
            "Salcuta",
            "Saratel",
            "Sasarm",
            "Teaca",
            "Telciu",
            "Telcisor",
            "Tiha Bargaului",
            "Tonciu",
            "Tureac",
            "Tarlisua",
            "Tarpiu",
            "Taure",
            "Uriu",
            "Urmenis",
            "Valea",
            "Valea Mare",
            "Valea Mare",
            "Valea Magherusului",
            "Valea Poenii",
            "Valea Vinului",
            "Vermes",
            "Viile Tecii",
            "Visuia",
            "Vita",
            "Zagra",
            "Zoreni",
            "Sant",
            "Sendroaia",
            "Sesuri Spermezeu-Vale",
            "Sieu",
            "Sieu-Magherus",
            "Sieu-Odorhei",
            "Sieu-Sfantu",
            "Sieut",
            "Sintereag",
            "Sintereag-Gara",
            "Sirioara",
            "Soimus",
            "Sopteriu",
            "Tagu",
            "Tentea",
            "Tigau",
            "Tagsoru"
          ]
        },
        {
          name: "Botosani",
          cities: [
            "Adaseni",
            "Agafton",
            "Alba",
            "Albesti",
            "Arborea",
            "Aurel Vlaicu",
            "Avram Iancu",
            "Avrameni",
            "Baisa",
            "Bajura",
            "Balinti",
            "Balta Arsa",
            "Baranca",
            "Baranca",
            "Baseu",
            "Belcea",
            "Berza",
            "Bivolari",
            "Blandesti",
            "Bodeasa",
            "Bogdanesti",
            "Bohoghina",
            "Bold",
            "Borolea",
            "Borzesti",
            "Boscoteni",
            "Botosani",
            "Bozieni",
            "Brehuiesti",
            "Broscauti",
            "Brosteni",
            "Braesti",
            "Brateni",
            "Bucecea",
            "Buda",
            "Buhaceni",
            "Buimaceni",
            "Burla",
            "Burlesti",
            "Buzeni",
            "Barsanesti",
            "Babiceni",
            "Badarai",
            "Baiceni",
            "Baluseni",
            "Balusenii Noi",
            "Batranesti",
            "Caraiman",
            "Carasa",
            "Cerbu",
            "Cerchejeni",
            "Cernesti",
            "Cervicesti",
            "Cervicesti-Deal",
            "Chelis",
            "Chiscareni",
            "Chitoveni",
            "Cinghiniia",
            "Ciritei",
            "Cismea",
            "Cismanesti",
            "Codreni",
            "Concesti",
            "Copalau",
            "Cordareni",
            "Corjauti",
            "Corlateni",
            "Corni",
            "Costesti",
            "Costinesti",
            "Cotu",
            "Cotu Miculinti",
            "Cotargaci",
            "Costiugeni",
            "Cosula",
            "Cosuleni",
            "Cotusca",
            "Crasnaleuca",
            "Cristesti",
            "Cristinesti",
            "Cucorani",
            "Cucuteni",
            "Curtesti",
            "Cuza Voda",
            "Cuzlau",
            "Campeni",
            "Candesti",
            "Calinesti",
            "Calugarenii Noi",
            "Calugarenii Vechi",
            "Calarasi",
            "Catamaresti",
            "Catamaresti-Deal",
            "Dacia",
            "Darabani",
            "Davidoaia",
            "Dealu Crucii",
            "Dersca",
            "Dimitrie Cantemir",
            "Dimacheni",
            "Dobrinauti-Hapai",
            "Dobarceni",
            "Doina",
            "Dolina",
            "Dorobanti",
            "Dorohoi",
            "Dracsani",
            "Dragalina",
            "Dragalina",
            "Draxini",
            "Drislea",
            "Draguseni",
            "Dumbravita",
            "Dumeni",
            "Durnesti",
            "Durnesti",
            "Durnesti",
            "Dangeni",
            "Damideni",
            "Damileni",
            "Esanca",
            "Flondora",
            "Floresti",
            "Flamanzi",
            "Frumusica",
            "Fundu Hertii",
            "Galbeni",
            "George Cosbuc",
            "George Enescu",
            "Ghireni",
            "Gorbanesti",
            "Gorovei",
            "Grivita",
            "Guranda",
            "Garbeni",
            "Garbesti",
            "Havarna",
            "Hiliseu-Closca",
            "Hiliseu-Crisan",
            "Hiliseu-Horia",
            "Hlipiceni",
            "Horia",
            "Horlaceni",
            "Horodistea",
            "Hriscani",
            "Hudesti",
            "Hudum",
            "Hulub",
            "Hulubesti",
            "Hutani",
            "Hanesti",
            "Iacobeni",
            "Ibaneasa",
            "Ibanesti",
            "Ichimeni",
            "Icuseni",
            "Iezer",
            "Iliseni",
            "Ionaseni",
            "Ionaseni",
            "Iorga",
            "Ipotesti",
            "Iuresti",
            "Izvoare",
            "Jijia",
            "Joldesti",
            "Lehnesti",
            "Leorda",
            "Libertatea",
            "Livada",
            "Liveni",
            "Lismanita",
            "Lisna",
            "Loturi",
            "Lozna",
            "Lunca",
            "Lunca",
            "Luparia",
            "Maghera",
            "Manoleasa",
            "Manoleasa-Prut",
            "Manolesti",
            "Mateieni",
            "Mesteacan",
            "Mihai Eminescu",
            "Mihai Viteazu",
            "Mihail Kogalniceanu",
            "Mihaileni",
            "Mihalaseni",
            "Mileanca",
            "Miletin",
            "Miorcani",
            "Miron Costin",
            "Mitoc",
            "Mitoc",
            "Mlenauti",
            "Moara Jorii",
            "Movila Rupta",
            "Movileni",
            "Murguta",
            "Mandresti",
            "Mandresti",
            "Manastireni",
            "Manastirea Doamnei",
            "Mascateni",
            "Negreni",
            "Negresti",
            "Nichiteni",
            "Nicolae Balcescu",
            "Niculcea",
            "Nicseni",
            "Nastase",
            "Oneaga",
            "Oroftiana",
            "Oraseni-Deal",
            "Oraseni-Vale",
            "Panaitoaia",
            "Petricani",
            "Plevna",
            "Plesani",
            "Plopenii Mari",
            "Plopenii Mici",
            "Podeni",
            "Podriga",
            "Pogorasti",
            "Poiana",
            "Poiana",
            "Poiana",
            "Pomarla",
            "Popeni",
            "Popeni",
            "Popoaia",
            "Prisacani",
            "Prajeni",
            "Pustoaia",
            "Putureni",
            "Parau Negru",
            "Padureni",
            "Padureni",
            "Paltinis",
            "Pasateni",
            "Paun",
            "Racovat",
            "Recia-Verbia",
            "Rediu",
            "Rediu",
            "Ripiceni",
            "Ripicenii Vechi",
            "Rogojesti",
            "Roma",
            "Romanesti",
            "Romanesti-Vale",
            "Rosiori",
            "Ranghilesti",
            "Ranghilesti-Deal",
            "Rasca",
            "Rachiti",
            "Radeni",
            "Radauti-Prut",
            "Rauseni",
            "Sadoveni",
            "Santa Mare",
            "Sarafinesti",
            "Sarata-Draguseni",
            "Sat Nou",
            "Saucenita",
            "Schit-Oraseni",
            "Scutari",
            "Selistea",
            "Siliscani",
            "Silistea",
            "Slobozia",
            "Slobozia",
            "Slobozia",
            "Slobozia Hanesti",
            "Slobozia Siliscani",
            "Smardan",
            "Socrujeni",
            "Soroceni",
            "Stolniceni",
            "Storesti",
            "Strahotin",
            "Stroiesti",
            "Strateni",
            "Stanca",
            "Stancesti",
            "Stauceni",
            "Suharau",
            "Sulita",
            "Sarbi",
            "Sarata",
            "Sarata",
            "Sarata-Basarab",
            "Saveni",
            "Talpa",
            "Timus",
            "Tocileni",
            "Todireni",
            "Trusesti",
            "Tudor Vladimirescu",
            "Tudor Vladimirescu",
            "Tudora",
            "Tataraseni",
            "Tautesti",
            "Ungureni",
            "Unguroaia",
            "Unteni",
            "Valea Grajdului",
            "Vatra",
            "Vicoleni",
            "Victoria",
            "Victoria",
            "Viforeni",
            "Viisoara",
            "Viisoara Mica",
            "Vitcani",
            "Vladeni",
            "Vladeni",
            "Vladeni-Deal",
            "Vlasinesti",
            "Vorniceni",
            "Vorona",
            "Vorona Mare",
            "Vorona-Teodoru",
            "Vultureni",
            "Valcelele",
            "Vanatori",
            "Varfu Campului",
            "Vaculesti",
            "Zahoreni",
            "Zlatunoaia",
            "Zoitani",
            "Zaicesti",
            "Sendreni",
            "Sendriceni",
            "Serpenita",
            "Soldanesti",
            "Stefanesti",
            "Stiubieni",
            "Supitca"
          ]
        },
        {
          name: "Brasov",
          cities: [
            "Apata",
            "Arini",
            "Augustin",
            "Beclean",
            "Beia",
            "Berivoi",
            "Bod",
            "Bogata Olteana",
            "Boholt",
            "Bran",
            "Brasov",
            "Breaza",
            "Bucium",
            "Budila",
            "Bunesti",
            "Buzaiel",
            "Barcut",
            "Calbor",
            "Cata",
            "Cheia",
            "Cincu",
            "Cincsor",
            "Cobor",
            "Codlea",
            "Colonia 1 Mai",
            "Colonia Bod",
            "Colonia Reconstructia",
            "Comana de Jos",
            "Comana de Sus",
            "Copacel",
            "Corbi",
            "Crihalma",
            "Cristian",
            "Crizbav",
            "Crit",
            "Cuciulata",
            "Cutus",
            "Carpinis",
            "Dacia",
            "Dejani",
            "Dopca",
            "Dridif",
            "Drumul Carului",
            "Dragus",
            "Drauseni",
            "Dumbravita",
            "Daisoara",
            "Dalghiu",
            "Feldioara",
            "Feldioara",
            "Felmer",
            "Fundata",
            "Fundatica",
            "Fantana",
            "Fagaras",
            "Ghimbav",
            "Grid",
            "Granari",
            "Gura Vaii",
            "Hoghiz",
            "Holbav",
            "Homorod",
            "Hurez",
            "Harseni",
            "Halchiu",
            "Halmeag",
            "Harman",
            "Iasi",
            "Ileni",
            "Ionesti",
            "Jibert",
            "Jimbor",
            "Lisa",
            "Lovnic",
            "Ludisor",
            "Lunca Calniculuiiii",
            "Lupsa",
            "Luta",
            "Mateias",
            "Mercheasa",
            "Mesendorf",
            "Moieciu de Jos",
            "Moieciu de Sus",
            "Mandra",
            "Magura",
            "Maierus",
            "Malinis",
            "Margineni",
            "Ohaba",
            "Oltet",
            "Ormenis",
            "Palos",
            "Paltin",
            "Persani",
            "Pestera",
            "Podu Oltului",
            "Poiana Marului",
            "Pojorta",
            "Predeal",
            "Predelut",
            "Prejmer",
            "Purcareni",
            "Parau",
            "Racos",
            "Recea",
            "Roades",
            "Rodbav",
            "Rotbav",
            "Rucar",
            "Rupea",
            "Rausor",
            "Rasnov",
            "Satu Nou",
            "Sebes",
            "Selistat",
            "Sohodol",
            "Statiunea Climaterica Sambata",
            "Stupinii Prejmerului",
            "Sambata de Jos",
            "Sambata de Sus",
            "Sanpetru",
            "Sacele",
            "Sasciori",
            "Savastreni",
            "Teliu",
            "Ticusu Nou",
            "Ticusu Vechi",
            "Toarcla",
            "Toderita",
            "Tarlungeni",
            "Ucea de Jos",
            "Ucea de Sus",
            "Ungra",
            "Vad",
            "Vama Buzaului",
            "Venetia de Jos",
            "Venetia de Sus",
            "Victoria",
            "Viscri",
            "Vistea de Jos",
            "Vistea de Sus",
            "Vistisoara",
            "Vladeni",
            "Voila",
            "Voivodeni",
            "Vulcan",
            "Valcea",
            "Valeni",
            "Zizin",
            "Zarnesti",
            "Sercaia",
            "Sercaita",
            "Simon",
            "Sinca Noua",
            "Sinca Veche",
            "Sirnea",
            "Soars",
            "Sona"
          ]
        },
        {
          name: "Braila",
          cities: [
            "Agaua",
            "Albina",
            "Ariciu",
            "Baldovinesti",
            "Batogu",
            "Berlesti",
            "Bertestii de Jos",
            "Bertestii de Sus",
            "Boarca",
            "Bordei Verde",
            "Bratesu Vechi",
            "Bradeanca",
            "Braila",
            "Bumbacari",
            "Bandoiu",
            "Baraganul",
            "Cazasu",
            "Chichinetu",
            "Chioibasesti",
            "Chiscani",
            "Ciocile",
            "Ciresu",
            "Cistia",
            "Coltea",
            "Comaneasca",
            "Constantin Gabrielescu",
            "Constantinesti",
            "Corbeni",
            "Corbu Nou",
            "Corbu Vechi",
            "Cotu Lung",
            "Cotu Mihalea",
            "Custura",
            "Cuza Voda",
            "Cuza Voda",
            "Caineni-Bai",
            "Caldarusa",
            "Dedulesti",
            "Desirati",
            "Drogu",
            "Dudescu",
            "Dudesti",
            "Esna",
            "Filipesti",
            "Filiu",
            "Florica",
            "Frecatei",
            "Faurei",
            "Faurei-Sat",
            "Galbenu",
            "Gara Ianca",
            "Gemenele",
            "Gropeni",
            "Gradistea",
            "Gulianca",
            "Gura Calmatui",
            "Gura Garlutei",
            "Gurguieti",
            "Gavani",
            "Horia",
            "Ianca",
            "Ibrianu",
            "Ionesti",
            "Jirlau",
            "Jugureanu",
            "Lacu Rezii",
            "Lacu Sarat",
            "Lanurile",
            "Latinu",
            "Liscoteanca",
            "Maraloiu",
            "Mihai Bravu",
            "Mihail Kogalniceanu",
            "Mihail Kogalniceanu",
            "Mircea Voda",
            "Morotesti",
            "Movila Miresii",
            "Muchea",
            "Magureni",
            "Marasu",
            "Martacesti",
            "Maru Rosu",
            "Maxineni",
            "Nedelcu",
            "Nicolae Balcescu",
            "Nicolesti",
            "Oancea",
            "Odaieni",
            "Olaneasca",
            "Oprisenesti",
            "Perisoru",
            "Pietroiu",
            "Pitulatii Noi",
            "Plopi",
            "Plopu",
            "Plasoiu",
            "Polizesti",
            "Pribeagu",
            "Pantecani",
            "Racovita",
            "Romanu",
            "Rosiori",
            "Ramnicelu",
            "Salcia",
            "Salcia Tudor",
            "Scortaru Nou",
            "Scortaru Vechi",
            "Scarlatesti",
            "Sihleanu",
            "Silistraru",
            "Silistea",
            "Spiru Haret",
            "Stanca",
            "Stoienesti",
            "Stancuta",
            "Surdila-Greci",
            "Surdila-Gaiseanca",
            "Satuc",
            "Tichilesti",
            "Titcov",
            "Traian",
            "Tudor Vladimirescu",
            "Tufesti",
            "Tarlele Filiu",
            "Tataru",
            "Ulmu",
            "Unirea",
            "Urleasca",
            "Valea Canepii",
            "Valea Calmatuiului",
            "Vamesu",
            "Victoria",
            "Viziru",
            "Visani",
            "Voinesti",
            "Vultureni",
            "Vadeni",
            "Varsatura",
            "Zamfiresti",
            "Zavoaia",
            "Insuratei",
            "Sutesti",
            "Tepes Voda",
            "Tacau"
          ]
        },
        {
          name: "Buzau",
          cities: [
            "Albesti",
            "Aldeni",
            "Alexandru Odobescu",
            "Aliceni",
            "Alunis",
            "Amara",
            "Amaru",
            "Anini",
            "Arbanasi",
            "Arcanu",
            "Balta Alba",
            "Balta Tocila",
            "Banita",
            "Batogu",
            "Beceni",
            "Beciu",
            "Begu",
            "Beilic",
            "Bentu",
            "Berca",
            "Bercesti",
            "Beslii",
            "Bisoca",
            "Blajani",
            "Boboc",
            "Bodinesti",
            "Boldu",
            "Bordusani",
            "Bozioru",
            "Breaza",
            "Brebu",
            "Bradeanca",
            "Bradeanu",
            "Braesti",
            "Bragareasa",
            "Bratilesti",
            "Buda",
            "Buda Craciunesti",
            "Budesti",
            "Budisteni",
            "Budrea",
            "Buduile",
            "Buzau",
            "Bustea",
            "Balhacu",
            "Basca Chiojdului",
            "Basca Rozilei",
            "Bascenii de Jos",
            "Bascenii de Sus",
            "Babeni",
            "Baceni",
            "Badeni",
            "Badila",
            "Baesti",
            "Baile",
            "Bajani",
            "Balaia",
            "Balteni",
            "Baltagari",
            "Baltareti",
            "Balaceanu",
            "Balanesti",
            "Barbuncesti",
            "Barasti",
            "C.A. Rosetti",
            "Calea Chiojdului",
            "Calvini",
            "Capu Satului",
            "Caragele",
            "Casota",
            "Casoca",
            "Ceairu",
            "Cernatesti",
            "Chiliile",
            "Chiojdu",
            "Chiperu",
            "Chirlesti",
            "Cilibia",
            "Ciobanoaia",
            "Ciocanesti",
            "Cioranca",
            "Ciorasti",
            "Ciresu",
            "Cislau",
            "Ciuta",
            "Clondiru",
            "Clondiru de Sus",
            "Coca-Antimiresti",
            "Coca-Niculesti",
            "Cochirleanca",
            "Coconari",
            "Cocarceni",
            "Codresti",
            "Cojanu",
            "Colibasi",
            "Colteni",
            "Colti",
            "Coltii de Jos",
            "Coltu Pietrii",
            "Coltaneni",
            "Comisoaia",
            "Corbu",
            "Corbu",
            "Corneanu",
            "Costesti",
            "Costieni",
            "Costomiru",
            "Cotorca",
            "Cotu Ciorii",
            "Cozieni",
            "Cotatcu",
            "Crevelesti",
            "Crang",
            "Cuculeasa",
            "Curcanesti",
            "Curmatura",
            "Caltesti",
            "Campeni",
            "Campulungeanca",
            "Candesti",
            "Carligu Mare",
            "Carligu Mic",
            "Carlomanesti",
            "Caldarusa",
            "Caldarusanca",
            "Caltuna",
            "Canesti",
            "Capatanesti",
            "Carpinistea",
            "Caratnau de Jos",
            "Caratnau de Sus",
            "Catiasu",
            "Catina",
            "Dara",
            "Dealul Viei",
            "Dedulesti",
            "Deleni",
            "Dobrilesti",
            "Dogari",
            "Dulbanu",
            "Dalma",
            "Dambroca",
            "Danulesti",
            "Dascalesti",
            "Fata lui Nan",
            "Fintesti",
            "Fisici",
            "Floresti",
            "Florica",
            "Focsanei",
            "Fotin",
            "Frasinet",
            "Fulga",
            "Fundata",
            "Fundeni",
            "Fundaturile",
            "Furtunesti",
            "Fantanele",
            "Fantanele",
            "Gara Bobocu",
            "Gara Cilibia",
            "Ghergheasa",
            "Gheraseni",
            "Ghiocari",
            "Ghizdita",
            "Glodeanu Sarat",
            "Glodeanu-Silistea",
            "Glodu-Petcari",
            "Glodurile",
            "Goicelu",
            "Goidesti",
            "Golu Grabicina",
            "Gomoesti",
            "Gontesti",
            "Gornet",
            "Gorani",
            "Grabicina de Jos",
            "Grabicina de Sus",
            "Grebanu",
            "Greceanca",
            "Gresia",
            "Grosani",
            "Grajdana",
            "Gura Bascei",
            "Gura Badicului",
            "Gura Calnaului",
            "Gura Dimienii",
            "Gura Fagetului",
            "Gura Siriului",
            "Gura Saratii",
            "Gura Teghii",
            "Gura Vaii",
            "Gageni",
            "Galbinasi",
            "Gavanele",
            "Gavanesti",
            "Hales",
            "Heliade Radulescu",
            "Homesti",
            "Ileana",
            "Istrita de Jos",
            "Ivanetu",
            "Izvoarele",
            "Izvoranu",
            "Izvoru",
            "Izvoru",
            "Izvoru Dulce",
            "Izvoru Dulce",
            "Jghiab",
            "Joseni",
            "Lacu",
            "Lacu Sinaia",
            "Lacu cu Anini",
            "Lacurile",
            "Lanurile",
            "Largu",
            "Leiculesti",
            "Lera",
            "Limpezis",
            "Lipia",
            "Lipanescu",
            "Livada",
            "Livada Mica",
            "Lopatari",
            "Lopatareasa",
            "Luciu",
            "Lunca",
            "Lunca",
            "Lunca",
            "Lunca",
            "Lunca Frumoasa",
            "Lunca Jaristei",
            "Lunca Priporului",
            "Luncile",
            "Lungesti",
            "Manasia",
            "Maxenu",
            "Merei",
            "Mierea",
            "Mihailesti",
            "Mihalceni",
            "Mitropolia",
            "Mlajet",
            "Modreni",
            "Moisica",
            "Movila Banului",
            "Movila Oii",
            "Movilita",
            "Mosesti",
            "Mucesti-Danulesti",
            "Murgesti",
            "Muscel",
            "Muscelu Caramanesti",
            "Muscelusa",
            "Manzu",
            "Manzalesti",
            "Macrina",
            "Magura",
            "Maguricea",
            "Manastirea",
            "Manastirea Ratesti",
            "Margineanu",
            "Margaritesti",
            "Margariti",
            "Maruntisu",
            "Maracineni",
            "Matesti",
            "Negosina",
            "Nehoiasu",
            "Nehoiu",
            "Nemertea",
            "Nenciu",
            "Nenciulesti",
            "Nicolesti",
            "Niculesti",
            "Nistoresti",
            "Niscov",
            "Nucu",
            "Naeni",
            "Odaia Banului",
            "Odaile",
            "Ograzile",
            "Ojasca",
            "Olari",
            "Olesesti",
            "Oratia",
            "Oreavu",
            "Padina",
            "Pardosi",
            "Pestritu",
            "Petrisoru",
            "Petrachesti",
            "Piatra Alba",
            "Pietraru",
            "Pietroasa Mica",
            "Pietroasele",
            "Pietrosu",
            "Pinu",
            "Pitulicea",
            "Plaiu Nucului",
            "Plavatu",
            "Plescioara",
            "Plevna",
            "Plescoi",
            "Plesesti",
            "Plesesti",
            "Plesi",
            "Plopeasa",
            "Plopi",
            "Plostina",
            "Plaisor",
            "Podgoria",
            "Podu Muncii",
            "Poenitele",
            "Pogoanele",
            "Pogonele",
            "Poiana Pletari",
            "Poiana Valcului",
            "Policiori",
            "Posobesti",
            "Potecu",
            "Potoceni",
            "Potarnichesti",
            "Posta",
            "Posta",
            "Posta Calnau",
            "Prosca",
            "Pruneni",
            "Puiestii de Jos",
            "Puiestii de Sus",
            "Punga",
            "Paclele",
            "Parjolesti",
            "Parscov",
            "Parscovelu",
            "Pacurile",
            "Padurenii",
            "Palici",
            "Paltineni",
            "Paltinis",
            "Panatau",
            "Patarlagele",
            "Racoviteni",
            "Recea",
            "Robeasca",
            "Robesti",
            "Rosioru",
            "Rubla",
            "Ruginoasa",
            "Runcu",
            "Rusavat",
            "Rusetu",
            "Ramnicelu",
            "Ramnicu Sarat",
            "Rapile",
            "Raducesti",
            "Ratesti",
            "Salcia",
            "Salcia Noua",
            "Salcia Veche",
            "Satu Nou",
            "Satu Nou",
            "Satu Nou",
            "Satu Vechi",
            "Scorosesti",
            "Scorteanca",
            "Scortoasa",
            "Scurtesti",
            "Scutelnici",
            "Scaeni",
            "Scarisoara",
            "Scarlatesti",
            "Secuiu",
            "Sergent Ionel Stefan",
            "Sibiciu de Jos",
            "Slobozia",
            "Smeeni",
            "Smeesti",
            "Smardan",
            "Soresti",
            "Spidele",
            "Spataru",
            "Spatareasa",
            "Strezeni",
            "Stalpu",
            "Stancesti",
            "Stanila",
            "Stavarasti",
            "Suditi",
            "Suditi",
            "Sarbesti",
            "Sageata",
            "Sahateni",
            "Salcioara",
            "Sapoca",
            "Sarata",
            "Sarata-Monteoru",
            "Sareni",
            "Sarile",
            "Sarile-Catun",
            "Sarulesti",
            "Sasenii Noi",
            "Sasenii Vechi",
            "Sasenii pe Vale",
            "Satuc",
            "Tega",
            "Teisu",
            "Terca",
            "Tisau",
            "Tocileni",
            "Topliceni",
            "Toropalesti",
            "Trestia",
            "Trestieni",
            "Trestioara",
            "Trestioara",
            "Tronari",
            "Tulburea",
            "Tarcov",
            "Tarlele",
            "Tatarligu",
            "Tabacari",
            "Tabarasti",
            "Tatulesti",
            "Udati-Lucieni",
            "Udati-Manzu",
            "Ulmeni",
            "Ulmet",
            "Unguriu",
            "Ursoaia",
            "Vadu Oii",
            "Vadu Pasii",
            "Vadu Soresti",
            "Valea Banului",
            "Valea Cotoarei",
            "Valea Catinei",
            "Valea Fantanei",
            "Valea Larga",
            "Valea Larga-Sarulesti",
            "Valea Nucului",
            "Valea Purcarului",
            "Valea Putului Merei",
            "Valea Parului",
            "Valea Ratei",
            "Valea Roatei",
            "Valea Ramnicului",
            "Valea Salciei",
            "Valea Salciei-Catun",
            "Valea Stanei",
            "Valea Salciilor",
            "Valea Ursului",
            "Valea Verzei",
            "Valea lui Lalu",
            "Valea Schiopului",
            "Valea Stefanului",
            "Varlaam",
            "Vernesti",
            "Viforata",
            "Vinetisu",
            "Vintileanca",
            "Vintila Voda",
            "Viperesti",
            "Vispesti",
            "Vizireni",
            "Vladeni",
            "Valcele",
            "Valcelele",
            "Varf",
            "Varteju",
            "Vacareasca",
            "Valeanca-Vilanesti",
            "Vavalucile",
            "Zaharesti",
            "Zeletin",
            "Ziduri",
            "Zilisteanca",
            "Zoita",
            "Zoresti",
            "Zaplazi",
            "Zapodia",
            "Zarnesti",
            "Zarnestii de Slanic",
            "Saranga",
            "Sindrila",
            "Stiubei",
            "Suchea",
            "Tintesti"
          ]
        },
        {
          name: "Caras-Severin",
          cities: [
            "23 August",
            "Agadici",
            "Anina",
            "Apadia",
            "Armenis",
            "Arsuri",
            "Bazias",
            "Belobresca",
            "Berliste",
            "Berzasca",
            "Berzovia",
            "Bigar",
            "Binis",
            "Bocsa",
            "Bogodint",
            "Bogaltin",
            "Boina",
            "Boinita",
            "Bojia",
            "Bolvasnita",
            "Borlova",
            "Borlovenii Noi",
            "Borlovenii Vechi",
            "Borugi",
            "Bozovici",
            "Bratova",
            "Brebu",
            "Brebu Nou",
            "Brestelnic",
            "Brezon",
            "Brosteni",
            "Bradisoru de Jos",
            "Buchin",
            "Bucova",
            "Bucosnita",
            "Barz",
            "Barza",
            "Baile Herculane",
            "Bania",
            "Barbosu",
            "Bautar",
            "Calina",
            "Camena",
            "Camenita",
            "Caransebes",
            "Carasova",
            "Cicleni",
            "Ciclova Romana",
            "Ciortea",
            "Ciresel",
            "Ciuchici",
            "Ciudanovita",
            "Ciuta",
            "Clocotici",
            "Comoraste",
            "Constantin Daicoviciu",
            "Copacele",
            "Cornea",
            "Cornereva",
            "Cornisoru",
            "Cornutel",
            "Coronini",
            "Costis",
            "Cozia",
            "Cozla",
            "Cracu Almaj",
            "Cracu Mare",
            "Cracu Teiului",
            "Crusovita",
            "Crusovat",
            "Cuptoare",
            "Curmatura",
            "Campia",
            "Carnecea",
            "Carsa Rosie",
            "Carsie",
            "Canicea",
            "Carbunari",
            "Dalboset",
            "Dalci",
            "Delinesti",
            "Dezesti",
            "Divici",
            "Dobraia",
            "Doclin",
            "Dognecea",
            "Dolina",
            "Domasnea",
            "Drencova",
            "Dristie",
            "Duleu",
            "Eftimie Murgu",
            "Ersig",
            "Ezeris",
            "Fenes",
            "Fizes",
            "Forotic",
            "Frasinis",
            "Farliug",
            "Ghertenis",
            "Giurgiova",
            "Glimboca",
            "Globu Craiovei",
            "Globurau",
            "Golet",
            "Gornea",
            "Goruia",
            "Greoni",
            "Gruni",
            "Gradinari",
            "Garbovat",
            "Garliste",
            "Garnic",
            "Garana",
            "Hora Mare",
            "Hora Mica",
            "Iabalcea",
            "Iablanita",
            "Iam",
            "Iaz",
            "Iertof",
            "Ilidia",
            "Ilova",
            "Inelet",
            "Izgar",
            "Izvor",
            "Jitin",
            "Jupa",
            "Lescovita",
            "Liborajdea",
            "Lindenfeld",
            "Liubcova",
            "Lucacevat",
            "Lunca Florii",
            "Lunca Zaicii",
            "Luncavita",
            "Lupac",
            "Lapusnicel",
            "Lapusnicu Mare",
            "Maciova",
            "Macoviste",
            "Macoviste",
            "Mal",
            "Marga",
            "Martinovat",
            "Mehadia",
            "Mehadica",
            "Mercina",
            "Mesteacan",
            "Milcoveni",
            "Moceris",
            "Moldova Noua",
            "Moniom",
            "Matnicu Mare",
            "Magura",
            "Maru",
            "Maureni",
            "Naidas",
            "Negiudin",
            "Nermed",
            "Nicolint",
            "Obita",
            "Obreja",
            "Ocna de Fier",
            "Ogasu Podului",
            "Ohaba-Matnic",
            "Ohabita",
            "Oravita",
            "Otelu Rosu",
            "Padina Matei",
            "Petnic",
            "Petrilova",
            "Petrosnita",
            "Pestere",
            "Plopu",
            "Plugova",
            "Pogara",
            "Pogara de Sus",
            "Poiana",
            "Poiana Lunga",
            "Poiana Marului",
            "Poienile Boinei",
            "Pojejena",
            "Poneasca",
            "Potoc",
            "Preveciori",
            "Prigor",
            "Prilipet",
            "Prisaca",
            "Prisian",
            "Prislop",
            "Prislop",
            "Prisacina",
            "Putna",
            "Parneaura",
            "Parvova",
            "Paltinis",
            "Patas",
            "Radimna",
            "Rafnic",
            "Ramna",
            "Ravensca",
            "Remetea-Poganici",
            "Resita",
            "Resita Mica",
            "Rugi",
            "Ruginosu",
            "Rusca",
            "Rusca Montana",
            "Rusova Noua",
            "Rusova Veche",
            "Ruschita",
            "Rustin",
            "Rachita",
            "Rachitova",
            "Racasdia",
            "Sacu",
            "Sadova Noua",
            "Sadova Veche",
            "Sasca Montana",
            "Sasca Romana",
            "Sat Batran",
            "Scaius",
            "Scarisoara",
            "Secaseni",
            "Sfanta Elena",
            "Sichevita",
            "Slatina-Nera",
            "Slatina-Timis",
            "Soceni",
            "Socol",
            "Socolari",
            "Streneac",
            "Strugasca",
            "Studena",
            "Stancilova",
            "Sub Crang",
            "Sub Margine",
            "Sub Plai",
            "Surducu Mare",
            "Salbagelu Nou",
            "Teregova",
            "Ticvaniu Mare",
            "Ticvaniu Mic",
            "Tincova",
            "Tirol",
            "Topla",
            "Toplet",
            "Turnu Ruieni",
            "Tarnova",
            "Urcu",
            "Valea Bistrei",
            "Valea Bolvasnita",
            "Valea Mare",
            "Valea Minisului",
            "Valea Orevita",
            "Valea Ravensca",
            "Valea Rosie",
            "Valea Rachitei",
            "Valea Sichevitei",
            "Valea Timisului",
            "Valeadeni",
            "Valeapai",
            "Vama Marga",
            "Var",
            "Verendin",
            "Vermes",
            "Vodnic",
            "Voislova",
            "Vrani",
            "Vraniut",
            "Varciorova",
            "Valiug",
            "Valisoara",
            "Varadia",
            "Zbegu",
            "Zervesti",
            "Zlagna",
            "Zlatita",
            "Zmogotin",
            "Zoina",
            "Zorile",
            "Zorlencior",
            "Zorlentu Mare",
            "Zagujeni",
            "Zanogi",
            "Zanou",
            "Zasloane",
            "Zavoi",
            "Sopotu Nou",
            "Sopotu Vechi",
            "Sosdea",
            "Stinapari",
            "Sumita",
            "Susca",
            "Tatu"
          ]
        },
        {
          name: "Calarasi",
          cities: [
            "Alexandru I. Cuza",
            "Alexandru Odobescu",
            "Aprozi",
            "Artari",
            "Belciugatele",
            "Bogata",
            "Bogdana",
            "Borcea",
            "Bosneagu",
            "Buciumeni",
            "Budesti",
            "Buzoeni",
            "Ceacu",
            "Cetatea Veche",
            "Chirnogi",
            "Chirnogi",
            "Chiselet",
            "Ciocanesti",
            "Clatesti",
            "Coconi",
            "Codreni",
            "Cojesti",
            "Constantin Brancoveanu",
            "Coslogeni",
            "Cotofanca",
            "Crivat",
            "Cucuieti",
            "Cunesti",
            "Curcani",
            "Curatesti",
            "Cuza Voda",
            "Candeasca",
            "Calarasi",
            "Calarasii Vechi",
            "Calareti",
            "Cascioarele",
            "Dichiseni",
            "Dor Marunt",
            "Dorobantu",
            "Dorobantu",
            "Dragalina",
            "Dragos Voda",
            "Drajna Noua",
            "Dalga",
            "Dalga-Gara",
            "Darvari",
            "Danesti",
            "Florica",
            "Floroaica",
            "Frumusani",
            "Frasinet",
            "Frasinetu de Jos",
            "Fundeni",
            "Fundulea",
            "Fantana Doamnei",
            "Faurei",
            "Gostilele",
            "Gruiu",
            "Gradistea",
            "Gurbanesti",
            "Galdau",
            "Galbinasi",
            "Galatui",
            "Iezeru",
            "Ileana",
            "Independenta",
            "Jegalia",
            "Lehliu",
            "Lehliu Gara",
            "Libertatea",
            "Luica",
            "Lunca",
            "Luptatori",
            "Lupsanu",
            "Mataraua",
            "Mihai Viteazu",
            "Mitreni",
            "Modelu",
            "Manastirea",
            "Magureni",
            "Marculesti-Gara",
            "Mariuta",
            "Nana",
            "Negoesti",
            "Nicolae Balcescu",
            "Nicolae Balcescu",
            "Nucetu",
            "Nuci",
            "Ogoru",
            "Oltenita",
            "Oltina",
            "Orasti",
            "Ostrovu",
            "Paicu",
            "Pasarea",
            "Pelinu",
            "Perisoru",
            "Pitigaia",
            "Plevna",
            "Plumbuita",
            "Plataresti",
            "Podari",
            "Podu Pitarului",
            "Polcesti",
            "Popesti",
            "Postavari",
            "Potcoava",
            "Preasna",
            "Preasna Veche",
            "Progresu",
            "Padurisu",
            "Radovanu",
            "Radu Negru",
            "Radu Voda",
            "Rasa",
            "Roseti",
            "Rasurile",
            "Razoarele",
            "Razvani",
            "Satnoeni",
            "Satu Nou",
            "Silistea",
            "Socoalele",
            "Sohatu",
            "Solacolu",
            "Spantov",
            "Stancea",
            "Stoenesti",
            "Sultana",
            "Sacele",
            "Salcioara",
            "Sandulita",
            "Sapunari",
            "Sarulesti-Gara",
            "Sarulesti-Sat",
            "Satucu",
            "Tonea",
            "Tudor Vladimirescu",
            "Tamadau Mare",
            "Tamadau Mic",
            "Tariceni",
            "Ulmeni",
            "Ulmu",
            "Unirea",
            "Valea Argovei",
            "Valea Popii",
            "Valea Presnei",
            "Valea Rosie",
            "Valea Rusului",
            "Valea Seaca",
            "Valea Stanii",
            "Vasilati",
            "Visinii",
            "Vlad Tepes",
            "Vladiceasca",
            "Vlaiculesti",
            "Valcelele",
            "Varasti",
            "Zimbru",
            "Infratirea",
            "Seinoiu",
            "Soldanu",
            "Stefan Voda",
            "Stefan cel Mare",
            "Stefanesti"
          ]
        },
        {
          name: "Cluj",
          cities: [
            "Aghiresu",
            "Aghiresu-Fabrici",
            "Agris",
            "Agarbiciu",
            "Aiton",
            "Alunis",
            "Alunisu",
            "Andici",
            "Antas",
            "Apahida",
            "Ardeova",
            "Arghisu",
            "Aruncuta",
            "Aschileu Mare",
            "Aschileu Mic",
            "Baciu",
            "Batin",
            "Bedeciu",
            "Belis",
            "Berchiesu",
            "Berindu",
            "Bica",
            "Blidaresti",
            "Bobalna",
            "Bociu",
            "Bodrog",
            "Bogata",
            "Bogata de Jos",
            "Bogata de Sus",
            "Boian",
            "Boj-Catun",
            "Boju",
            "Boldut",
            "Bologa",
            "Bont",
            "Bontida",
            "Borzesti",
            "Borsa",
            "Borsa-Crestaia",
            "Borsa-Catun",
            "Boteni",
            "Braisoru",
            "Bucea",
            "Bunesti",
            "Buru",
            "Buteni",
            "Buza",
            "Barlea",
            "Babdiu",
            "Babutiu",
            "Badeni",
            "Badesti",
            "Bagaciu",
            "Bagara",
            "Baisoara",
            "Balcesti",
            "Balcesti",
            "Barai",
            "Cacova Ierii",
            "Calna",
            "Cara",
            "Casele Micesti",
            "Ceaba",
            "Ceanu Mare",
            "Ceanu Mic",
            "Cerbesti",
            "Cerc",
            "Cetan",
            "Cheia",
            "Chesau",
            "Chidea",
            "Chinteni",
            "Chiris",
            "Chiuiesti",
            "Ciubanca",
            "Ciubancuta",
            "Ciucea",
            "Ciuleni",
            "Ciumafaia",
            "Ciurgau",
            "Ciurila",
            "Clapa",
            "Cluj-Napoca",
            "Coasta",
            "Codor",
            "Cojocna",
            "Colonia",
            "Comorata",
            "Comsesti",
            "Coplean",
            "Copru",
            "Copaceni",
            "Corneni",
            "Cornesti",
            "Cornesti",
            "Cornesti",
            "Corpadea",
            "Corusu",
            "Crairat",
            "Cremenea",
            "Cristorel",
            "Criseni",
            "Craesti",
            "Cublesu Somesan",
            "Curtuiusu Dejului",
            "Custura",
            "Cutca",
            "Cuzdrioara",
            "Campenesti",
            "Campia Turzii",
            "Catcau",
            "Caianu",
            "Caianu Mic",
            "Caianu-Vama",
            "Calata",
            "Calarasi",
            "Calarasi-Gara",
            "Calatele",
            "Camarasu",
            "Caprioara",
            "Capusu Mare",
            "Capusu Mic",
            "Catina",
            "Catalina",
            "Caseiu",
            "Darot",
            "Dealu Botii",
            "Dealu Mare",
            "Dealu Negru",
            "Dej",
            "Deleni",
            "Deusu",
            "Dezmir",
            "Diviciorii Mari",
            "Diviciorii Mici",
            "Domosu",
            "Dorna",
            "Doroltu",
            "Dosu Bricii",
            "Dosu Napului",
            "Dretea",
            "Dumbrava",
            "Dambu Mare",
            "Damburile",
            "Dancu",
            "Dangau Mare",
            "Dangau Mic",
            "Darja",
            "Dabaca",
            "Elciu",
            "Escu",
            "Falca",
            "Feiurdeni",
            "Feldioara",
            "Feleacu",
            "Filea de Jos",
            "Filea de Sus",
            "Finciu",
            "Finisel",
            "Fizesu Gherlii",
            "Floresti",
            "Fodora",
            "Frata",
            "Frasinet",
            "Fundatura",
            "Fanate",
            "Fagetu Ierii",
            "Faureni",
            "Geaca",
            "Gheorghieni",
            "Gherla",
            "Ghirisu Roman",
            "Ghirolt",
            "Gilau",
            "Giula",
            "Giurcuta de Jos",
            "Giurcuta de Sus",
            "Gligoresti",
            "Guga",
            "Garbau",
            "Garbau Dejului",
            "Gadalin",
            "Hagau",
            "Hodaie",
            "Hodisu",
            "Hodai-Boian",
            "Horlacea",
            "Huci",
            "Huedin",
            "Huta",
            "Hasdate",
            "Iacobeni",
            "Iara",
            "Iclod",
            "Iclozel",
            "Igritia",
            "Inucu",
            "Iuriu de Campie",
            "Izvoru Crisului",
            "Jichisu de Jos",
            "Jichisu de Sus",
            "Juc-Herghelie",
            "Jucu de Mijloc",
            "Jucu de Sus",
            "Jurca",
            "Lacu",
            "Leghia",
            "Legii",
            "Leurda",
            "Lita",
            "Liteni",
            "Livada",
            "Livada",
            "Lobodas",
            "Lujerdiu",
            "Luna",
            "Luna de Jos",
            "Luna de Sus",
            "Lunca Bontului",
            "Lunca Visagului",
            "Luncani",
            "Lungesti",
            "Lapustesti",
            "Macau",
            "Maia",
            "Masca",
            "Mera",
            "Mica",
            "Micesti",
            "Mihai Viteazu",
            "Mihaiesti",
            "Mintiu Gherlii",
            "Moara de Padure",
            "Mociu",
            "Moldovenesti",
            "Moristi",
            "Morlaca",
            "Morau",
            "Mortesti",
            "Muncel",
            "Muntele Bocului",
            "Muntele Baisorii",
            "Muntele Cacovei",
            "Muntele Filii",
            "Muntele Rece",
            "Muntele Sacelului",
            "Muresenii de Campie",
            "Macicasu",
            "Magoaja",
            "Magura Ierii",
            "Maguri",
            "Maguri-Racatau",
            "Mahal",
            "Manastirea",
            "Manastireni",
            "Manasturel",
            "Manasturu Romanesc",
            "Marcesti",
            "Margau",
            "Marisel",
            "Martinesti",
            "Nadasu",
            "Nearsova",
            "Negreni",
            "Nicula",
            "Nima",
            "Nires",
            "Nadaselu",
            "Naoiu",
            "Nasal",
            "Oas",
            "Ocolisel",
            "Olariu",
            "Orman",
            "Osoi",
            "Osorhel",
            "Panticeu",
            "Pata",
            "Petea",
            "Petresti",
            "Petrestii de Jos",
            "Petrestii de Mijloc",
            "Petrestii de Sus",
            "Pietroasa",
            "Plaiuri",
            "Plopi",
            "Ploscos",
            "Plaiesti",
            "Podeni",
            "Poiana Fratii",
            "Poiana Horea",
            "Poieni",
            "Popesti",
            "Prelucele",
            "Pruneni",
            "Pruni",
            "Prunis",
            "Puini",
            "Pustuta",
            "Paglisa",
            "Padurea Iacobeni",
            "Padureni",
            "Padureni",
            "Padureni",
            "Padurenii",
            "Palatca",
            "Paniceni",
            "Recea-Cristur",
            "Rediu",
            "Risca",
            "Rogojel",
            "Rotunda",
            "Rosieni",
            "Rugasesti",
            "Rachitele",
            "Radaia",
            "Rascruci",
            "Razbuneni",
            "Razoare",
            "Salatiu",
            "Satu Lung",
            "Sava",
            "Scrind-Frasinet",
            "Sic",
            "Sicfa",
            "Smida",
            "Somesu Cald",
            "Somesu Rece",
            "Soporu de Campie",
            "Stejeris",
            "Stoiana",
            "Stolna",
            "Straja",
            "Straja",
            "Strucut",
            "Strambu",
            "Starcu",
            "Suaras",
            "Suatu",
            "Sub Coasta",
            "Suceagu",
            "Sucutard",
            "Sumurducu",
            "Surduc",
            "Samboieni",
            "Samboleni",
            "Sancraiu",
            "Sanmarghita",
            "Sanmartin",
            "Sanmartin",
            "Sannicoara",
            "Sanpaul",
            "Santejude",
            "Santejude-Vale",
            "Santioana",
            "Sacel",
            "Sacuieu",
            "Sacalaia",
            "Salicea",
            "Salisca",
            "Saliste",
            "Salistea Noua",
            "Salistea Veche",
            "Salatruc",
            "Sandulesti",
            "Sarata",
            "Saradis",
            "Savadisla",
            "Tarnita, Cluj",
            "Ticu",
            "Ticu-Colonie",
            "Tiocu de Jos",
            "Tiocu de Sus",
            "Tioltiur",
            "Topa Mica",
            "Tranisu",
            "Tritenii de Jos",
            "Tritenii de Sus",
            "Tritenii-Hotar",
            "Turda",
            "Turea",
            "Tureni",
            "Turmasi",
            "Targusor",
            "Tarpiu",
            "Tauseni",
            "Tauti",
            "Unguras",
            "Urca",
            "Urisor",
            "Vad",
            "Vaida-Camaras",
            "Vale",
            "Valea Agrisului",
            "Valea Calda",
            "Valea Ciresoii",
            "Valea Caseielului",
            "Valea Draganului",
            "Valea Florilor",
            "Valea Grosilor",
            "Valea Garboului",
            "Valea Ierii",
            "Valea Luncii",
            "Valea Ungurasului",
            "Valea Vadului",
            "Valea lui Cati",
            "Valea lui Opris",
            "Vechea",
            "Viisoara",
            "Visagu",
            "Visea",
            "Vistea",
            "Vlaha",
            "Vultureni",
            "Valcele",
            "Valcelele",
            "Vanatori",
            "Valeni",
            "Valeni",
            "Valisoara",
            "Zorenii de Vale",
            "Sardu",
            "Saula",
            "Sigau",
            "Soimeni",
            "Sutu",
            "Taga"
          ]
        },
        {
          name: "Constanta",
          cities: [
            "2 Mai",
            "23 August",
            "Abrud",
            "Adamclisi",
            "Agigea",
            "Albesti",
            "Aliman",
            "Almalau",
            "Amzacea",
            "Arsa",
            "Biruinta",
            "Brebeni",
            "Bugeac",
            "Baltagesti",
            "Baneasa",
            "Baraganu",
            "Canlia",
            "Capidava",
            "Carvan",
            "Casian",
            "Casicea",
            "Cerchezu",
            "Cernavoda",
            "Cetatea",
            "Cheia",
            "Chirnogeni",
            "Ciobanu",
            "Ciobanita",
            "Ciocarlia",
            "Ciocarlia de Sus",
            "Closca",
            "Cobadin",
            "Cochirleni",
            "Cogealac",
            "Comana",
            "Conacu",
            "Constanta",
            "Corbu",
            "Coroana",
            "Coslugea",
            "Costinesti",
            "Cotu Vaii",
            "Credinta",
            "Crisan",
            "Crucea",
            "Crangu",
            "Cuiugiuc",
            "Culmea",
            "Cumpana",
            "Curcani",
            "Cuza Voda",
            "Calugareni",
            "Cascioarele",
            "Darabani",
            "Deleni",
            "Dobromir",
            "Dobromiru din Deal",
            "Dorobantu",
            "Dropia",
            "Dulcesti",
            "Dulgheru",
            "Dumbraveni",
            "Dunarea",
            "Dunareni",
            "Eforie",
            "Esechioi",
            "Floriile",
            "Furnica",
            "Fantana Mare",
            "Fantanele",
            "Faclia",
            "Faurei",
            "Galita",
            "General Scarisoreanu",
            "Gherghina",
            "Ghindaresti",
            "Goruni",
            "Gradina",
            "Graniceru",
            "Gura Dobrogei",
            "Garliciu",
            "Garlita",
            "Galbiori",
            "Hagieni",
            "Hateg",
            "Horia",
            "Harsova",
            "Independenta",
            "Ion Corvin",
            "Istria",
            "Ivrinezu Mare",
            "Ivrinezu Mic",
            "Izvoarele",
            "Izvoru Mare",
            "Lanurile",
            "Lazu",
            "Lespezi",
            "Limanu",
            "Lipnita",
            "Lumina",
            "Luminita",
            "Mangalia",
            "Medgidia",
            "Mereni",
            "Mihai Viteazu",
            "Mihail Kogalniceanu",
            "Miorita",
            "Mircea Voda",
            "Mireasa",
            "Miristea",
            "Movila Verde",
            "Movilita",
            "Mosneni",
            "Murfatlar",
            "Magura",
            "Nazarcea",
            "Negresti",
            "Negru Voda",
            "Negureni",
            "Nicolae Balcescu",
            "Nisipari",
            "Nistoresti",
            "Nuntasi",
            "Navodari",
            "Oituz",
            "Olteni",
            "Oltina",
            "Osmancea",
            "Ostrov",
            "Ovidiu",
            "Palazu Mic",
            "Pantelimon",
            "Pantelimon de Jos",
            "Pecineaga",
            "Pelinu",
            "Petrosani",
            "Pestera",
            "Piatra",
            "Pietreni",
            "Plopeni",
            "Poarta Alba",
            "Poiana",
            "Potarnichea",
            "Padureni",
            "Raristea",
            "Rasova",
            "Runcu",
            "Ramnicu de Jos",
            "Ramnicu de Sus",
            "Razoarele",
            "Saligny",
            "Sanatoriul Agigea",
            "Saraiu",
            "Satu Nou",
            "Satu Nou",
            "Schitu",
            "Seimeni",
            "Seimenii Mici",
            "Sibioara",
            "Silistea",
            "Siminoc",
            "Sinoe",
            "Statiunea Zoologica Marina Agigea",
            "Stejaru",
            "Straja",
            "Strunga",
            "Stupina",
            "Sacele",
            "Tariverde",
            "Techirghiol",
            "Tichilesti",
            "Topalu",
            "Topraisar",
            "Tortoman",
            "Traian",
            "Tudor Vladimirescu",
            "Tufani",
            "Tuzla",
            "Targusor",
            "Tataru",
            "Urluia",
            "Vadu",
            "Valu lui Traian",
            "Vama Veche",
            "Veteranu",
            "Viile",
            "Viisoara",
            "Viroaga",
            "Vlahii",
            "Vulturu",
            "Valcelele",
            "Vanatori",
            "Vartop",
            "Valeni",
            "Zorile",
            "Sipotele",
            "Siriu",
            "Stefan cel Mare",
            "Tepes Voda",
            "Tibrinu"
          ]
        },
        {
          name: "Covasna",
          cities: [
            "Aita Mare",
            "Aita Medie",
            "Aita Seaca",
            "Albis",
            "Alungeni",
            "Anghelus",
            "Aninoasa",
            "Araci",
            "Arcus",
            "Ariusd",
            "Baraolt",
            "Barcani",
            "Belani",
            "Belin",
            "Belin-Vale",
            "Biborteni",
            "Bicfalau",
            "Bita",
            "Bixad",
            "Bodoc",
            "Bodos",
            "Borosneu Mare",
            "Borosneu Mic",
            "Brates",
            "Bretcu",
            "Bradet",
            "Bradut",
            "Bacel",
            "Batanii Mari",
            "Batanii Mici",
            "Calnic",
            "Catalina",
            "Casinu Mic",
            "Cernat",
            "Chichis",
            "Chilieni",
            "Comandau",
            "Covasna",
            "Coseni",
            "Crasna",
            "Capeni",
            "Carpinenii",
            "Dalnic",
            "Dobolii de Jos",
            "Dobolii de Sus",
            "Doboseni",
            "Dobarlau",
            "Eresteghin",
            "Estelnic",
            "Filia",
            "Floroaia",
            "Fotos",
            "Ghelinta",
            "Ghidfalau",
            "Harale",
            "Herculian",
            "Hetea",
            "Hilib",
            "Haghig",
            "Hatuica",
            "Iaras",
            "Icafalau",
            "Ilieni",
            "Imeni",
            "Lemnia",
            "Let",
            "Lisnau",
            "Lisnau-Vale",
            "Lunca Marcusului",
            "Lunca Ozunului",
            "Lunga",
            "Lutoasa",
            "Ladauti",
            "Malnas",
            "Malnas-Bai",
            "Mereni",
            "Merisor",
            "Micfalau",
            "Miclosoara",
            "Moacsa",
            "Magherus",
            "Marcus",
            "Marcusa",
            "Martineni",
            "Martanus",
            "Oituz",
            "Ojdula",
            "Olteni",
            "Ozun",
            "Ozunca-Bai",
            "Pachia",
            "Pava",
            "Peteni",
            "Petriceni",
            "Poian",
            "Padureni",
            "Papauti",
            "Racosul de Sus",
            "Reci",
            "Saciova",
            "Scradoasa",
            "Sfantu Gheorghe",
            "Sita Buzaului",
            "Surcea",
            "Sancraiu",
            "Santionlunca",
            "Sanzieni",
            "Saramas",
            "Tamasfalau",
            "Telechia",
            "Turia",
            "Targu Secuiesc",
            "Talisoara",
            "Valea Crisului",
            "Valea Dobarlaului",
            "Valea Mare",
            "Valea Mica",
            "Valea Scurta",
            "Valea Seaca",
            "Valea Zalanului",
            "Valcele",
            "Varghis",
            "Zagon",
            "Zoltan",
            "Zabala",
            "Zabratau",
            "Zalan",
            "Intorsura Buzaului",
            "Tufalau"
          ]
        },
        {
          name: "Dambovita",
          cities: [
            "Adanca",
            "Alunis",
            "Alunisu",
            "Aninoasa",
            "Aninosani",
            "Bechinesti",
            "Berevoesti",
            "Bezdead",
            "Bilciuresti",
            "Blidari",
            "Boboci",
            "Bolovani",
            "Boteni",
            "Branistea",
            "Brebu",
            "Brezoaele",
            "Brezoaia",
            "Brosteni",
            "Brosteni",
            "Brosteni",
            "Brancoveanu",
            "Bradatel",
            "Branesti",
            "Bratestii de Jos",
            "Buciumeni",
            "Bucsani",
            "Bujoreanca",
            "Bumbuia",
            "Bungetu",
            "Burduca",
            "Butimanu",
            "Butoiu de Jos",
            "Butoiu de Sus",
            "Baldana",
            "Bacesti",
            "Badeni",
            "Badulesti",
            "Baleni-Romani",
            "Baleni-Sarbi",
            "Balteni",
            "Banesti",
            "Barbuceanu",
            "Barbuletu",
            "Baraceni",
            "Capu Coastei",
            "Catanele",
            "Cazaci",
            "Cetatuia",
            "Chirca",
            "Ciocanari",
            "Ciocanesti",
            "Coada Izvorului",
            "Cobiuta",
            "Cocani",
            "Cojasca",
            "Cojocaru",
            "Cojoiu",
            "Colanu",
            "Colibasi",
            "Comisani",
            "Contesti",
            "Copaceni",
            "Corbii Mari",
            "Cornesti",
            "Corni",
            "Cornatelu",
            "Costesti",
            "Costestii din Deal",
            "Costestii din Vale",
            "Costisata",
            "Crevedia",
            "Cretu",
            "Cretulesti",
            "Cricovu Dulce",
            "Cristeasca",
            "Crivatu",
            "Croitori",
            "Crovu",
            "Crangasi",
            "Crangurile de Jos",
            "Crangurile de Sus",
            "Craciunesti",
            "Cucuteni",
            "Cuparu",
            "Cuza Voda",
            "Candesti-Deal",
            "Candesti-Vale",
            "Carlanesti",
            "Calugareni",
            "Calugareni",
            "Caprioru",
            "Capsuna",
            "Catunu",
            "Catunu",
            "Dealu Frumos",
            "Dealu Mare",
            "Decindea",
            "Decindeni",
            "Dimoiu",
            "Dobra",
            "Dobresti",
            "Doicesti",
            "Dospinesti",
            "Dragodana",
            "Dragodanesti",
            "Dragomiresti",
            "Dragaesti-Pamanteni",
            "Dragaesti-Ungureni",
            "Dumbrava",
            "Dupa Deal",
            "Dambovicioara",
            "Darza",
            "Darmanesti",
            "Ferestre",
            "Feteni",
            "Fieni",
            "Fierbinti",
            "Finta Mare",
            "Finta Veche",
            "Frasin-Deal",
            "Frasin-Vale",
            "Frasinu",
            "Fusea",
            "Fantanele",
            "Fagetu",
            "Geangoesti",
            "Gemenea-Bratulesti",
            "Gheboaia",
            "Gheboieni",
            "Gherghesti",
            "Gherghitesti",
            "Ghinesti",
            "Ghirdoveni",
            "Glod",
            "Glodeni",
            "Glogoveanu",
            "Gorgota",
            "Greci",
            "Grozavesti",
            "Gulia",
            "Gura Barbuletului",
            "Gura Foii",
            "Gura Ocnitei",
            "Gura Vulcanei",
            "Gura Sutii",
            "Gusoiu",
            "Garleni",
            "Gaesti",
            "Gamanesti",
            "Hagioaica",
            "Hanu lui Pala",
            "Helesteu",
            "Hodarasti",
            "Hulubesti",
            "Habeni",
            "I.L. Caragiale",
            "Iazu",
            "Ibrianu",
            "Iedera de Jos",
            "Iedera de Sus",
            "Ilfoveni",
            "Ionesti",
            "Izvoarele",
            "Izvoru",
            "Izvoru",
            "Jugureni",
            "Lazuri",
            "Livezile",
            "Livezile",
            "Lucianca",
            "Lucieni",
            "Ludesti",
            "Lunca",
            "Lunca",
            "Lunguletu",
            "Laculete",
            "Laculete-Gara",
            "Malu Mierii",
            "Malu cu Flori",
            "Manga",
            "Matraca",
            "Meisoare",
            "Mereni",
            "Mereni",
            "Merii",
            "Merisoru",
            "Mesteacan",
            "Miclosanii Mari",
            "Miclosanii Mici",
            "Mija",
            "Milosari",
            "Mircea Voda",
            "Mislea",
            "Miulesti",
            "Moara Noua",
            "Moara din Groapa",
            "Mogosani",
            "Mogosesti",
            "Moreni",
            "Moroeni",
            "Morteni",
            "Movila",
            "Movila",
            "Mosia Mica",
            "Motaieni",
            "Muscel",
            "Manjina",
            "Manastioara",
            "Manastirea",
            "Magura",
            "Magura",
            "Manesti",
            "Manastirea",
            "Marcesti",
            "Marginenii de Sus",
            "Maruntisu",
            "Matasaru",
            "Neajlovu",
            "Nicolaesti",
            "Niculesti",
            "Nisipurile",
            "Nucet",
            "Ochiuri",
            "Ocnita",
            "Odaia Turcului",
            "Odobesti",
            "Olteni",
            "Olteni",
            "Oncesti",
            "Oreasca",
            "Persinari",
            "Petresti",
            "Petresti",
            "Piatra",
            "Picior de Munte",
            "Pietrari",
            "Pietrosita",
            "Pitaru",
            "Plopu",
            "Podu Corbencii",
            "Podu Cristinii",
            "Podu Rizii",
            "Poiana",
            "Poienita",
            "Poroinica",
            "Postarnacu",
            "Potlogeni-Deal",
            "Potlogeni-Vale",
            "Potlogi",
            "Potocelu",
            "Priboiu",
            "Priboiu",
            "Produlesti",
            "Pucheni",
            "Pucheni",
            "Pucioasa",
            "Puntea de Greci",
            "Putu cu Salcie",
            "Padureni",
            "Patroaia-Deal",
            "Patroaia-Vale",
            "Raciu",
            "Racovita",
            "Ragu",
            "Romanesti",
            "Runcu",
            "Rancaciov",
            "Rau Alb de Jos",
            "Rau Alb de Sus",
            "Racari",
            "Rascaeti",
            "Razvad",
            "Ratesti",
            "Ratoaia",
            "Samurcasi",
            "Saru",
            "Satu Nou",
            "Scheiu de Jos",
            "Scheiu de Sus",
            "Schela",
            "Serdanu",
            "Silistea",
            "Silistea",
            "Slobozia",
            "Slobozia Moara",
            "Sperieteni",
            "Stavropolia",
            "Stratonesti",
            "Straosti",
            "Statesti",
            "Suduleni",
            "Sultanu",
            "Suseni-Socetu",
            "Sacueni",
            "Salcioara",
            "Salcioara",
            "Salcuta",
            "Sateni",
            "Savesti",
            "Teis",
            "Telesti",
            "Tetcoiu",
            "Titu",
            "Toculesti",
            "Tomsani",
            "Tunari",
            "Targoviste",
            "Tartasesti",
            "Tatarani",
            "Udresti",
            "Uliesti",
            "Ulmetu",
            "Ulmi",
            "Ungureni",
            "Ungureni",
            "Ungureni",
            "Ungureni",
            "Urseiu",
            "Urziceanca",
            "Vadu Stanchii",
            "Valea",
            "Valea Caselor",
            "Valea Dadei",
            "Valea Larga",
            "Valea Leurzii",
            "Valea Lunga-Cricov",
            "Valea Lunga-Gorgota",
            "Valea Lunga-Ogrea",
            "Valea Mare",
            "Valea Mare",
            "Valea Mare",
            "Valea Morii",
            "Valea Voievozilor",
            "Valea lui Dan",
            "Viforata",
            "Viisoara",
            "Vizuresti",
            "Visina",
            "Visinesti",
            "Vladeni",
            "Vlasceni",
            "Voia",
            "Voinesti",
            "Vulcana de Sus",
            "Vulcana-Bai",
            "Vulcana-Pandele",
            "Vultureanca",
            "Varfureni",
            "Varfuri",
            "Vacaresti",
            "Valeni-Dambovita",
            "Zidurile",
            "Zavoiu",
            "Selaru",
            "Serbaneasa",
            "Sipot",
            "Sotanga",
            "Stubeie Tisa",
            "Suvita",
            "Suta Seaca"
          ]
        },
        {
          name: "Dolj",
          cities: [
            "Adancata",
            "Afumati",
            "Albesti",
            "Almaj",
            "Almajel",
            "Amarasti",
            "Amarastii de Jos",
            "Amarastii de Sus",
            "Apele Vii",
            "Argetoaia",
            "Balota de Jos",
            "Balota de Sus",
            "Balta Verde",
            "Basarabi",
            "Bascov",
            "Bechet",
            "Bechet",
            "Beharca",
            "Belcinu",
            "Belot",
            "Benesti",
            "Berbesu",
            "Bistret",
            "Bistretu Nou",
            "Bobeanu",
            "Bodaiesti",
            "Bodaiestii de Sus",
            "Bogea",
            "Bojoiu",
            "Booveni",
            "Botosesti-Paia",
            "Boureni",
            "Brabeti",
            "Brabova",
            "Bralostita",
            "Braniste",
            "Braniste",
            "Braniste",
            "Bratovoesti",
            "Breasta",
            "Brandusa",
            "Bradesti",
            "Bradestii Batrani",
            "Bucicani",
            "Bucovicior",
            "Bucovat",
            "Bujor",
            "Bulzesti",
            "Busu",
            "Busuletu",
            "Buzduc",
            "Busteni",
            "Balta",
            "Barca",
            "Bazdana",
            "Badosi",
            "Bailesti",
            "Baranu",
            "Barboi",
            "Calafat",
            "Calopar",
            "Caraiman",
            "Caraula",
            "Carpen",
            "Castranova",
            "Castrele Traiane",
            "Catane",
            "Catanele Noi",
            "Celaru",
            "Cernat",
            "Cernele",
            "Cernelele de Sus",
            "Cernatesti",
            "Cerat",
            "Cetate",
            "Cetatuia",
            "Cetatuia",
            "Chiasu",
            "Ciocanele",
            "Ciocanesti",
            "Cioroiasi",
            "Cioroiu Nou",
            "Ciupercenii Noi",
            "Ciupercenii Vechi",
            "Ciutura",
            "Cleanov",
            "Comosteni",
            "Comanicea",
            "Corlate",
            "Cornetu",
            "Cornita",
            "Cornu",
            "Cotu",
            "Covei",
            "Cosereni",
            "Cosoveni",
            "Cotofenii din Dos",
            "Cotofenii din Fata",
            "Craiova",
            "Criva",
            "Crovna",
            "Curmatura",
            "Campeni",
            "Carcea",
            "Carligei",
            "Carna",
            "Carstovani",
            "Caciulatu",
            "Caciulatesti",
            "Calinesti",
            "Calugarei",
            "Calarasi",
            "Caruia",
            "Daneti",
            "Deleni",
            "Desa",
            "Desnatui",
            "Diosti",
            "Dobresti",
            "Dobridor",
            "Dobromira",
            "Dobrotesti",
            "Domnu Tudor",
            "Dragoaia",
            "Dragotesti",
            "Dranic",
            "Dudovicesti",
            "Dutulesti",
            "Dabuleni",
            "Filaret",
            "Filiasi",
            "Floran",
            "Floresti",
            "Foisor",
            "Frasin",
            "Fratostita",
            "Fratila",
            "Fantanele",
            "Fantanele",
            "Fantani",
            "Faget",
            "Farcas",
            "Gabru",
            "Gaia",
            "Galicea Mare",
            "Galiciuica",
            "Geblesti",
            "Georocel",
            "Georocu Mare",
            "Ghercesti",
            "Ghidici",
            "Ghindeni",
            "Ghizdavesti",
            "Gighera",
            "Giubega",
            "Giurgita",
            "Godeni",
            "Gogosesti",
            "Gogosita",
            "Gogosu",
            "Goicea",
            "Goiesti",
            "Golenti",
            "Golfin",
            "Golumbelu",
            "Golumbu",
            "Grecesti",
            "Gropanele",
            "Gruita",
            "Gradistea",
            "Gubaucea",
            "Gura Racului",
            "Gura Vaii",
            "Gangiova",
            "Garlesti",
            "Horezu-Poenari",
            "Hunia",
            "Iordachesti",
            "Italieni",
            "Izvoare",
            "Izvor",
            "Izvorul Rece",
            "Isalnita",
            "Jieni",
            "Jiul",
            "Lazu",
            "Leamna de Jos",
            "Leamna de Sus",
            "Leordoasa",
            "Leu",
            "Lesile",
            "Lipovu",
            "Lipovu de Sus",
            "Livezi",
            "Listeava",
            "Locusteni",
            "Luncsoru",
            "Langa",
            "Lacrita Mare",
            "Lacrita Mica",
            "Maglavit",
            "Malaica",
            "Malu Mare",
            "Malumnic",
            "Marotinu de Jos",
            "Marotinu de Sus",
            "Melinesti",
            "Meteu",
            "Mihaita",
            "Milesti",
            "Milovan",
            "Mischii",
            "Mlecanesti",
            "Moflesti",
            "Mogosesti",
            "Moreni",
            "Mosna",
            "Motoci",
            "Mosneni",
            "Motatei",
            "Motatei-Gara",
            "Muereni",
            "Muierusu",
            "Murgasi",
            "Murta",
            "Marza",
            "Marsani",
            "Macesu de Jos",
            "Macesu de Sus",
            "Malaesti",
            "Maracinele",
            "Nedeia",
            "Negoi",
            "Negoiesti",
            "Nisipuri",
            "Nistoi",
            "Novac",
            "Obedin",
            "Ocolna",
            "Odoleni",
            "Ohaba",
            "Orodel",
            "Ostroveni",
            "Padea",
            "Palilula",
            "Panaghia",
            "Pereni",
            "Perisor",
            "Picaturile",
            "Pielesti",
            "Pietroaia",
            "Pioresti",
            "Piria",
            "Piscani",
            "Piscu Lung",
            "Piscu Nou",
            "Piscu Sadovei",
            "Piscu Vechi",
            "Pisculet",
            "Plenita",
            "Plesoi",
            "Plopu-Amarasti",
            "Plopsor",
            "Plosca",
            "Plostina",
            "Podari",
            "Poiana Fantanii",
            "Poiana Mare",
            "Poienile",
            "Pometesti",
            "Popeasa",
            "Popesti",
            "Popanzalesti",
            "Potmeltu",
            "Prapor",
            "Preajba",
            "Preajba de Jos",
            "Preajba de Padure",
            "Predesti",
            "Predestii Mici",
            "Prejoi",
            "Prunet",
            "Putinei",
            "Puturi",
            "Racovita",
            "Radomir",
            "Radovan",
            "Rasnicu Batran",
            "Rasnicu Oghian",
            "Rast",
            "Robanestii de Jos",
            "Robanestii de Sus",
            "Rojiste",
            "Romanesti",
            "Rovine",
            "Rosieni",
            "Rupturile",
            "Racari",
            "Racarii de Sus",
            "Rachita de Jos",
            "Rachita de Sus",
            "Sadova",
            "Salcia",
            "Schitu",
            "Scaesti",
            "Seaca de Camp",
            "Seaca de Padure",
            "Secu",
            "Secui",
            "Seculesti",
            "Segarcea",
            "Seglet",
            "Sfarcea",
            "Silistea Crucii",
            "Smadovicioara de Secu",
            "Smardan",
            "Soceni",
            "Sopot",
            "Soreni",
            "Spineni",
            "Stoicesti",
            "Suharu",
            "Sarsca",
            "Salcuta",
            "Salcuta",
            "Saliste",
            "Sapata",
            "Sarata",
            "Sarbatoarea",
            "Tatomiresti",
            "Teasc",
            "Teascu din Deal",
            "Teiu",
            "Tencanau",
            "Terpezita",
            "Teslui",
            "Toceni",
            "Tunarii Noi",
            "Tunarii Vechi",
            "Tamburesti",
            "Tarnava",
            "Talpas",
            "Ungureni",
            "Ungurenii Mici",
            "Unirea",
            "Urdinita",
            "Urechesti",
            "Urieni",
            "Ursoaia",
            "Urzica Mare",
            "Urzicuta",
            "Uscaci",
            "Valea Fantanilor",
            "Valea Lungului",
            "Valea Mare",
            "Valea Muierii de Jos",
            "Valea Stanciului",
            "Valea lui Patru",
            "Vela",
            "Veleni",
            "Velesti",
            "Verbicioara",
            "Verbita",
            "Viisoara",
            "Viisoara-Mosneni",
            "Vladimir",
            "Voita",
            "Vartop",
            "Varvor",
            "Varvoru de Jos",
            "Zlatari",
            "Zvorsca",
            "Zanoaga",
            "Zaval",
            "Infratirea",
            "Intorsura",
            "Simnicu de Sus",
            "Sitoaia",
            "Stefanel",
            "Stiubei",
            "Sumandra",
            "Tandara",
            "Tiu",
            "Tuglui",
            "Tartal"
          ]
        },
        {
          name: "Galati",
          cities: [
            "Adam",
            "Aldesti",
            "Balintesti",
            "Barcea",
            "Beresti",
            "Beresti-Meria",
            "Blanzi",
            "Branistea",
            "Branistea",
            "Brahasesti",
            "Branesti",
            "Bratulesti",
            "Bucesti",
            "Buciumeni",
            "Bursucani",
            "Baleni",
            "Baltareti",
            "Balabanesti",
            "Balasesti",
            "Baneasa",
            "Cavadinesti",
            "Certesti",
            "Chiraftei",
            "Ciorasti",
            "Ciuresti",
            "Ciurestii Noi",
            "Cismele",
            "Coasta Lupei",
            "Comanesti",
            "Condrea",
            "Corcioveni",
            "Corni",
            "Corod",
            "Cositeni",
            "Cosmesti",
            "Cosmestii-Vale",
            "Costache Negri",
            "Costi",
            "Cotoroaia",
            "Cruceanu",
            "Crangeni",
            "Craiesti",
            "Cuca",
            "Cudalbi",
            "Cuza Voda",
            "Carlomanesti",
            "Calmatui",
            "Carapcesti",
            "Cauiesti",
            "Dobrinesti",
            "Draguseni",
            "Draganesti",
            "Foltesti",
            "Frumusita",
            "Frunzeasca",
            "Fundeanu",
            "Fundeni",
            "Fundenii Noi",
            "Furcenii Noi",
            "Furcenii Vechi",
            "Fantanele",
            "Fantani",
            "Fartanesti",
            "Galati",
            "Gara Berheci",
            "Gara Ghidigeni",
            "Gefu",
            "Ghidigeni",
            "Ghinghesti",
            "Gohor",
            "Grivita",
            "Grozavesti",
            "Gura Garbovatului",
            "Garbovat",
            "Ganesti",
            "Hanu Conachi",
            "Hustiu",
            "Hantesti",
            "Ijdileni",
            "Independenta",
            "Ionasesti",
            "Ireasca",
            "Ivesti",
            "Izvoarele",
            "Jorasti",
            "Liesti",
            "Liesti",
            "Lozova",
            "Lunca",
            "Lungesti",
            "Lungoci",
            "Lupele",
            "Malu Alb",
            "Matca",
            "Mihail Kogalniceanu",
            "Moscu",
            "Movileni",
            "Movileni",
            "Munteni",
            "Mandresti",
            "Maciseni",
            "Malureni",
            "Mastacani",
            "Negrea",
            "Negrilesti",
            "Nicopole",
            "Nicoresti",
            "Namoloasa",
            "Namoloasa-Sat",
            "Nartesti",
            "Oancea",
            "Odaia Manolache",
            "Onciu",
            "Pechea",
            "Piscu",
            "Piscu Corbului",
            "Plevna",
            "Plesa",
            "Podoleni",
            "Poiana",
            "Posta",
            "Priponesti",
            "Priponestii de Jos",
            "Prodanesti",
            "Pupezeni",
            "Puricani",
            "Rediu",
            "Rogojeni",
            "Roscani",
            "Radesti",
            "Salcia",
            "Satu Nou",
            "Schela",
            "Scanteiesti",
            "Silistea",
            "Slivna",
            "Slobozia Blaneasa",
            "Slobozia Conachi",
            "Slobozia Corni",
            "Slobozia Oancea",
            "Smulti",
            "Smardan",
            "Stoicani",
            "Suceveni",
            "Suhurlui",
            "Sarbi",
            "Saseni",
            "Tecucelu Sec",
            "Tecuci",
            "Toflea",
            "Torcesti",
            "Traian",
            "Tudor Vladimirescu",
            "Tulucesti",
            "Targu Bujor",
            "Talpigi",
            "Tamaoani",
            "Taplau",
            "Tatarca",
            "Umbraresti",
            "Umbraresti",
            "Umbraresti-Deal",
            "Ungureni",
            "Urlesti",
            "Valea Marului",
            "Vames",
            "Vasile Alecsandri",
            "Viile",
            "Vizuresti",
            "Visina",
            "Vladesti",
            "Vanatori",
            "Varlezi",
            "Vadeni",
            "Zimbru",
            "Zarnesti",
            "Sendreni",
            "Serbestii Vechi",
            "Sipote",
            "Sivita",
            "Stietesti",
            "Tepu",
            "Tepu de Sus",
            "Tiganesti"
          ]
        },
        {
          name: "Giurgiu",
          cities: [
            "Adunatii-Copaceni",
            "Anghelesti",
            "Bila",
            "Bolintin-Deal",
            "Bolintin-Vale",
            "Branistea",
            "Branistari",
            "Bucsani",
            "Budeni",
            "Bulbucata",
            "Buturugeni",
            "Bacu",
            "Balanu",
            "Baneasa",
            "Banesti",
            "Carapancea",
            "Cartojani",
            "Cetatea",
            "Cetatuia",
            "Chirculesti",
            "Chiriacu",
            "Clejani",
            "Colibasi",
            "Comana",
            "Comasca",
            "Copaciu",
            "Corbeanca",
            "Cosoba",
            "Coteni",
            "Crevedia Mare",
            "Crevedia Mica",
            "Crivina",
            "Crucea de Piatra",
            "Cranguri",
            "Cucuruzu",
            "Cupele",
            "Campurelu",
            "Calugareni",
            "Camineasca",
            "Carpenisu",
            "Cascioarele",
            "Cascioarele",
            "Daia",
            "Dealu",
            "Dimitrie Cantemir",
            "Dobreni",
            "Draghiceanu",
            "Draganeasca",
            "Draganescu",
            "Darasti-Vlasca",
            "Falastoaca",
            "Floresti",
            "Frasinu",
            "Fratesti",
            "Facau",
            "Ghimpati",
            "Ghionea",
            "Ghizdaru",
            "Giurgiu",
            "Gogosari",
            "Goleasca",
            "Gorneni",
            "Gostinari",
            "Gostinu",
            "Greaca",
            "Gradinari",
            "Gradistea",
            "Gaiseanca",
            "Gaiseni",
            "Gaujani",
            "Herasti",
            "Hobaia",
            "Hodivoaia",
            "Hotarele",
            "Hulubesti",
            "Ianculesti",
            "Icoana",
            "Iepuresti",
            "Izvoarele",
            "Izvoarele",
            "Izvoru",
            "Izvoru",
            "Joita",
            "Letca Noua",
            "Letca Veche",
            "Malu",
            "Malu Spart",
            "Mihai Bravu",
            "Mihai Voda",
            "Mihailesti",
            "Milcovatu",
            "Milosesti",
            "Mironesti",
            "Mirau",
            "Mogosesti",
            "Mosteni",
            "Marsa",
            "Naipu",
            "Neajlovu",
            "Novaci",
            "Obedeni",
            "Ogrezeni",
            "Oinacu",
            "Oncesti",
            "Palanca",
            "Petru Rares",
            "Pietrele",
            "Pietrisu",
            "Plopsoru",
            "Podisor",
            "Podu Doamnei",
            "Podu Ilfovatului",
            "Podu Popa Nae",
            "Poenari",
            "Poiana lui Stanga",
            "Popesti",
            "Posta",
            "Priboiu",
            "Prundu",
            "Puieni",
            "Putineiu",
            "Putu Greci",
            "Padureni",
            "Radu Voda",
            "Remus",
            "Roata Mica",
            "Roata de Jos",
            "Ralesti",
            "Rasuceni",
            "Sadina",
            "Satu Nou",
            "Schitu",
            "Sfantu Gheorghe",
            "Sfantu Gheorghe",
            "Singureni",
            "Slobozia",
            "Stejaru",
            "Sterea",
            "Stoenesti",
            "Stoenesti",
            "Stalpu",
            "Stanesti",
            "Suseni",
            "Sabareni",
            "Teiusu",
            "Teisori",
            "Tomulesti",
            "Toporu",
            "Trestieni",
            "Tantava",
            "Uiesti",
            "Ulmi",
            "Uzunu",
            "Vadu Lat",
            "Valea Bujorului",
            "Valea Dragului",
            "Valea Plopilor",
            "Valter Maracineanu",
            "Varlaam",
            "Vedea",
            "Vieru",
            "Vlad Tepes",
            "Vlasin",
            "Valcelele",
            "Vanatorii Mari",
            "Vanatorii Mici",
            "Varasti",
            "Zboiu",
            "Zorile",
            "Zadariciu"
          ]
        },
        {
          name: "Gorj",
          cities: [
            "Albeni",
            "Alexeni",
            "Alimpesti",
            "Alunis",
            "Andreesti",
            "Aninisu din Deal",
            "Aninisu din Vale",
            "Aninoasa",
            "Apa Neagra",
            "Arcani",
            "Arjoci",
            "Arpadia",
            "Arsuri",
            "Artanu",
            "Arseni",
            "Baia de Fier",
            "Balosani",
            "Baniu",
            "Barza",
            "Becheni",
            "Bengesti",
            "Bercesti",
            "Berlesti",
            "Bibesti",
            "Bibulesti",
            "Bircii",
            "Blahnita de Jos",
            "Blahnita de Sus",
            "Blidari",
            "Bobaia",
            "Boboiesti",
            "Bobu",
            "Boca",
            "Bohorel",
            "Boia",
            "Bojinu",
            "Bolboasa",
            "Bolbocesti",
            "Bolbosi",
            "Borosteni",
            "Borascu",
            "Botorogi",
            "Brebenei",
            "Brosteni",
            "Brostenii de Sus",
            "Bradet",
            "Bradetel",
            "Bradiceni",
            "Branesti",
            "Bratesti",
            "Bratuia",
            "Bucureasa",
            "Bucsana",
            "Budieni",
            "Buduhala",
            "Bulbuceni",
            "Bumbesti-Jiu",
            "Bumbesti-Pitic",
            "Burlani",
            "Bustuchin",
            "Busuioci",
            "Buzesti",
            "Balta",
            "Balteni",
            "Baltisoara",
            "Barcaciu",
            "Barzeiu",
            "Barzeiu de Gilort",
            "Bacesti",
            "Badesti",
            "Balani",
            "Balcesti",
            "Balesti",
            "Balacesti",
            "Balanesti",
            "Barbatesti",
            "Bazavani",
            "Calaparu",
            "Capu Dealului",
            "Cartiu",
            "Ceauru",
            "Celei",
            "Ceplea",
            "Cerna-Sat",
            "Cernadia",
            "Ceratu de Copacioasa",
            "Cetatea",
            "Chiciora",
            "Chiliu",
            "Ciocadia",
            "Cionti",
            "Ciorari",
            "Ciuperceni",
            "Ciupercenii de Oltet",
            "Clesnesti",
            "Closani",
            "Cocoreni",
            "Cocorova",
            "Cojani",
            "Cojmanesti",
            "Colibasi",
            "Coltesti",
            "Condeiesti",
            "Copacioasa",
            "Cornetu",
            "Cornesti",
            "Corobai",
            "Corsoru",
            "Costeni",
            "Costesti",
            "Covrigi",
            "Crasna",
            "Crasna din Deal",
            "Cretesti",
            "Croici",
            "Cruset",
            "Curpen",
            "Cursaru",
            "Curteana",
            "Curtisoara",
            "Calcesti",
            "Calnic",
            "Calnicu de Sus",
            "Campofeni",
            "Campu Mare",
            "Canepesti",
            "Carbesti",
            "Carciu",
            "Carligei",
            "Calesti",
            "Calugareasa",
            "Calugareni",
            "Camuiesti",
            "Capreni",
            "Carbunesti-Sat",
            "Carpinis",
            "Catunele",
            "Dealu Leului",
            "Dealu Spirei",
            "Dealu Viei",
            "Dealu Viilor",
            "Deleni",
            "Didilesti",
            "Dobrana",
            "Dobrita",
            "Dolcesti",
            "Doseni",
            "Dragoiesti",
            "Dragotesti",
            "Dragutesti",
            "Duculesti",
            "Dumbraveni",
            "Dambova",
            "Danciulesti",
            "Danesti",
            "Floresteni",
            "Floresti",
            "Frasin",
            "Frumusei",
            "Frunza",
            "Francesti",
            "Fratesti",
            "Fantanele",
            "Farcasesti",
            "Farcasesti-Mosneni",
            "Gilortu",
            "Glodeni",
            "Glogova",
            "Godinesti",
            "Gornovita",
            "Gornacel",
            "Groserea",
            "Grui",
            "Gura Susitei",
            "Gura-Menti",
            "Gureni",
            "Galcesti",
            "Garbovu",
            "Galesoaia",
            "Gamani",
            "Gavanesti",
            "Hirisesti",
            "Hobita",
            "Hodoreasca",
            "Horezu",
            "Hotaroasa",
            "Hurezani",
            "Haiesti",
            "Halangesti",
            "Iasi-Gorj",
            "Igirosu",
            "Iliesti",
            "Ionesti",
            "Iormanesti",
            "Isvarna",
            "Izvoarele",
            "Jeristea",
            "Jupanesti",
            "Larga",
            "Lazuri",
            "Lelesti",
            "Licurici",
            "Lihulesti",
            "Lintea",
            "Logresti-Mosteni",
            "Lupoaia",
            "Lupoita",
            "Lazaresti",
            "Magheresti",
            "Marinesti",
            "Mentii din Dos",
            "Merfulesti",
            "Miclosu",
            "Miculesti",
            "Mielusei",
            "Mierea",
            "Miericeaua",
            "Miluta",
            "Mirosloveni",
            "Mogosani",
            "Moi",
            "Motorgi",
            "Motru",
            "Motru Sec",
            "Murgesti",
            "Murgilesti",
            "Musculesti",
            "Musetesti",
            "Macesu",
            "Maiag",
            "Maru",
            "Matasari",
            "Mazaroi",
            "Negoiesti",
            "Negomir",
            "Negreni",
            "Nistoresti",
            "Novaci",
            "Nucetu",
            "Namete",
            "Obreja",
            "Obarsia",
            "Ohaba",
            "Ohaba-Jiu",
            "Olari",
            "Olteanu",
            "Orzesti",
            "Orzu",
            "Pades",
            "Paltinu",
            "Pegeni",
            "Petresti",
            "Petrachei",
            "Pesteana de Jos",
            "Pesteana-Jiu",
            "Pesteana-Vulcan",
            "Pestisani",
            "Picu",
            "Pieptani",
            "Pinoasa",
            "Piscoiu",
            "Piscuri",
            "Pistestii din Deal",
            "Plesa",
            "Plopu",
            "Plopsoru",
            "Pociovalistea",
            "Pocruia",
            "Poiana",
            "Poiana-Seciuri",
            "Poienari",
            "Poienita",
            "Pojaru",
            "Pojogeni",
            "Polovragi",
            "Popesti",
            "Popesti-Stejari",
            "Prigoria",
            "Priporu",
            "Prunesti",
            "Purcaru",
            "Parvulesti",
            "Parau",
            "Parau Boia",
            "Parau Viu",
            "Parau de Pripor",
            "Parau de Vale",
            "Paisani",
            "Pajistele",
            "Raci",
            "Racovita",
            "Racoti",
            "Radosi",
            "Rasova",
            "Rasovita",
            "Rogojel",
            "Rogojeni",
            "Rovinari",
            "Rosia de Amaradia",
            "Rosia-Jiu",
            "Rosiuta",
            "Ruget",
            "Rugi",
            "Runcu",
            "Runcurel",
            "Rapa",
            "Rachiti",
            "Radinesti",
            "Ratez",
            "Samarinesti",
            "Satu Nou",
            "Schela",
            "Scoarta",
            "Scorusu",
            "Scrada",
            "Scurtu",
            "Seaca",
            "Seciurile",
            "Seuca",
            "Sitesti",
            "Slivilesti",
            "Slamnesti",
            "Slavuta",
            "Socu",
            "Sohodol",
            "Spahii",
            "Steic",
            "Stejari",
            "Stejaru",
            "Stejerei",
            "Sterpoaia",
            "Stoina",
            "Stolojani",
            "Stroiesti",
            "Stramba-Jiu",
            "Stramba-Vulcan",
            "Stramtu",
            "Stancesti",
            "Stancesti-Larga",
            "Stanesti",
            "Sura",
            "Suseni",
            "Sambotin",
            "Sarbesti",
            "Sacelu",
            "Sanatesti",
            "Sardanesti",
            "Saulesti",
            "Tehomir",
            "Telesti",
            "Tetila",
            "Timiseni",
            "Tismana",
            "Toiaga",
            "Topesti",
            "Totea",
            "Totea de Hurezani",
            "Trestioara",
            "Trocani",
            "Turburea",
            "Turceni",
            "Turcinesti",
            "Talvesti",
            "Targu Carbunesti",
            "Targu Jiu",
            "Targu Logresti",
            "Talpasesti",
            "Tamasesti",
            "Ulmet",
            "Ungureni",
            "Urda de Jos",
            "Urda de Sus",
            "Urdari",
            "Urechesti",
            "Ursoaia",
            "Vaidei",
            "Valea",
            "Valea Bisericii",
            "Valea Desului",
            "Valea Mare",
            "Valea Mica",
            "Valea Motrului",
            "Valea Manastirii",
            "Valea Perilor",
            "Valea Poienii",
            "Valea Pojarului",
            "Valea Racilor",
            "Valea Viei",
            "Valea cu Apa",
            "Vidin",
            "Viersani",
            "Vladimir",
            "Vladuleni",
            "Voinigesti",
            "Voitestii din Deal",
            "Voitestii din Vale",
            "Valceaua",
            "Valcele",
            "Vanata",
            "Vartopu",
            "Vacarea",
            "Vagiulesti",
            "Vaieni",
            "Valari",
            "Valeni",
            "Valuta",
            "Zorlesti",
            "Zorzila",
            "Zaicoiu",
            "Sasa",
            "Siacu",
            "Sipotu",
            "Sitoaia",
            "Somanesti",
            "Stefanesti",
            "Stiucani",
            "Ticleni",
            "Tirioi",
            "Tantareni",
            "Tarculesti"
          ]
        },
        {
          name: "Harghita",
          cities: [
            "Aldea",
            "Alexandrita",
            "Alunis",
            "Andreeni",
            "Armaseni",
            "Armasenii Noi",
            "Arvateni",
            "Atia",
            "Atid",
            "Avramesti",
            "Bancu",
            "Baratcos",
            "Becas",
            "Bentid",
            "Beta",
            "Bilbor",
            "Bisericani",
            "Bodogaia",
            "Borsec",
            "Borzont",
            "Bradesti",
            "Bucin",
            "Bucin",
            "Bulgareni",
            "Barzava",
            "Badeni",
            "Baile Chirui",
            "Baile Tusnad",
            "Balan",
            "Calonda",
            "Capu Corbului",
            "Casinu Nou",
            "Cechesti",
            "Cehetel",
            "Cetatuia",
            "Chedia Mare",
            "Chedia Mica",
            "Chileni",
            "Chinusu",
            "Ciaracio",
            "Ciceu",
            "Cinod",
            "Ciobanis",
            "Cireseni",
            "Ciucani",
            "Ciucsangeorgiu",
            "Ciumani",
            "Cobatesti",
            "Comiat",
            "Comanesti",
            "Corbu",
            "Corund",
            "Cotormani",
            "Cozmeni",
            "Cristuru Secuiesc",
            "Criseni",
            "Craciunel",
            "Cusmed",
            "Carta",
            "Cadaciu Mare",
            "Cadaciu Mic",
            "Calnaci",
            "Calugareni",
            "Capalnita",
            "Daia",
            "Dealu",
            "Dealu Armanului",
            "Dejutiu",
            "Delnita",
            "Desag",
            "Ditrau",
            "Dobeni",
            "Duda",
            "Darjiu",
            "Danesti",
            "Eghersec",
            "Eliseni",
            "Feliceni",
            "Filpea",
            "Firtusu",
            "Firtanus",
            "Fitod",
            "Forteni",
            "Frumoasa",
            "Fundoaia",
            "Fancel",
            "Fantana Brazilor",
            "Fagetel",
            "Fagetel",
            "Gheorgheni",
            "Ghidut",
            "Ghipes",
            "Ghiurche",
            "Goagiu",
            "Garciu",
            "Galautas",
            "Galautas-Parau",
            "Hagota",
            "Hodosa",
            "Hoghia",
            "Hosasau",
            "Iacobeni",
            "Iasu",
            "Ighiu",
            "Imper",
            "Ineu",
            "Inlaceni",
            "Izvoare",
            "Izvoru Muresului",
            "Izvorul Trotusului",
            "Jolotca",
            "Joseni",
            "Laz-Firtanus",
            "Laz-Soimus",
            "Leliceni",
            "Liban",
            "Livezi",
            "Locodeni",
            "Lueta",
            "Lunca de Jos",
            "Lunca de Sus",
            "Lupeni",
            "Lutita",
            "Lazarea",
            "Lazaresti",
            "Martonca",
            "Medisoru Mare",
            "Medisoru Mic",
            "Meresti",
            "Miercurea Ciuc",
            "Mihaileni",
            "Mihaileni",
            "Misentea",
            "Morareni",
            "Mugeni",
            "Mujna",
            "Madaras",
            "Martinis",
            "Matiseni",
            "Nicoleni",
            "Nicolesti",
            "Nicolesti",
            "Nuteni",
            "Nadejdea",
            "Obranesti",
            "Ocland",
            "Ocna de Jos",
            "Ocna de Sus",
            "Odorheiu Secuiesc",
            "Oraseni",
            "Oteni",
            "Petecu",
            "Petreni",
            "Pintic",
            "Platonesti",
            "Plopis",
            "Plaiesii de Jos",
            "Plaiesii de Sus",
            "Poiana Fagului",
            "Poiana Tarnavei",
            "Polonita",
            "Porumbenii Mari",
            "Porumbenii Mici",
            "Potiond",
            "Praid",
            "Preluca",
            "Puntea Lupului",
            "Paltinis",
            "Paltinis-Ciuc",
            "Pauleni",
            "Pauleni-Ciuc",
            "Racu",
            "Rares",
            "Recea",
            "Remetea",
            "Ruganesti",
            "Runc",
            "Rachitis",
            "Satu Mare",
            "Satu Mic",
            "Satu Nou",
            "Secuieni",
            "Senetea",
            "Siculeni",
            "Sineu",
            "Sub Cetate",
            "Subcetate",
            "Suseni",
            "Sancel",
            "Sancrai",
            "Sancraieni",
            "Sandominic",
            "Sanmartin",
            "Sanpaul",
            "Sansimion",
            "Santimbru",
            "Santimbru-Bai",
            "Sacel",
            "Sarmas",
            "Teleac",
            "Tibod",
            "Toleseni",
            "Tomesti",
            "Toplita",
            "Tulghes",
            "Turdeni",
            "Tusnad",
            "Tusnadu Nou",
            "Tarnovita",
            "Taietura",
            "Tamasu",
            "Tarcesti",
            "Taureni",
            "Uilac",
            "Ulcani",
            "Ulies",
            "Valea Boros",
            "Valea Capelei",
            "Valea Garbea",
            "Valea Rece",
            "Valea Rotunda",
            "Valea Stramba",
            "Valea Ugra",
            "Valea Uzului",
            "Valea lui Antaloc",
            "Valea lui Pavel",
            "Valea Intunecoasa",
            "Vasileni",
            "Vidacut",
            "Vlahita",
            "Voslabeni",
            "Vrabia",
            "Várdotfalva",
            "Vacaresti",
            "Valeni",
            "Varsag",
            "Zetea",
            "Zapodea",
            "Sasveres",
            "Sicasau",
            "Siclod",
            "Simonesti",
            "Soimeni",
            "Soimusu Mare",
            "Soimusu Mic",
            "Tengheler"
          ]
        },
        {
          name: "Hunedoara",
          cities: [
            "Abucea",
            "Almas-Saliste",
            "Almasu Mic",
            "Almasu Mic de Munte",
            "Almasu Sec",
            "Almasel",
            "Alun",
            "Alun",
            "Aninoasa",
            "Archia",
            "Ardeu",
            "Aranies",
            "Aurel Vlaicu",
            "Bacea",
            "Baia de Cris",
            "Baldovin",
            "Balomir",
            "Balsa",
            "Banpotoc",
            "Barbura",
            "Baru",
            "Barza",
            "Basarabasa",
            "Batiz",
            "Bastea",
            "Bejan",
            "Bejan-Tarnavita",
            "Bercu",
            "Beriu",
            "Birtin",
            "Blajeni",
            "Blajeni-Vulcan",
            "Bobaia",
            "Bobalna",
            "Bocsa Mare",
            "Bocsa Mica",
            "Boholt",
            "Boia Barzii",
            "Boiu",
            "Boiu de Jos",
            "Boiu de Sus",
            "Boita",
            "Boz",
            "Bozes",
            "Bos",
            "Bosorod",
            "Brad",
            "Brazi",
            "Breazova",
            "Bretea Muresana",
            "Bretea Romana",
            "Bretea Streiului",
            "Bretelin",
            "Brotuna",
            "Braznic",
            "Bradatel",
            "Branisca",
            "Braseu",
            "Buces",
            "Buces-Vulcan",
            "Bucium",
            "Bucium-Orlea",
            "Bucuresci",
            "Bujoru",
            "Bulzestii de Jos",
            "Bulzestii de Sus",
            "Bunesti",
            "Bunila",
            "Burjuc",
            "Barcea Mare",
            "Barcea Mica",
            "Barsau",
            "Bacia",
            "Bacaia",
            "Baiesti",
            "Baita",
            "Balata",
            "Banita",
            "Barastii Hategului",
            "Barastii Iliei",
            "Batrana",
            "Batalar",
            "Cerbia",
            "Cerbal",
            "Cerisor",
            "Cernisoara Florese",
            "Certeju de Jos",
            "Certeju de Sus",
            "Cherghes",
            "Chimindia",
            "Chitid",
            "Chiscadaga",
            "Cigmau",
            "Cincis-Cerna",
            "Cioclovina",
            "Ciopeia",
            "Ciula Mare",
            "Ciula Mica",
            "Ciulpaz",
            "Ciumita",
            "Ciungani",
            "Ciungu Mare",
            "Clopotiva",
            "Coaja",
            "Copaci",
            "Coroiesti",
            "Cosesti",
            "Costesti",
            "Costesti-Deal",
            "Covragiu",
            "Cozia",
            "Cristur",
            "Criva",
            "Crivadia",
            "Cris",
            "Crisan",
            "Criscior",
            "Craciunesti",
            "Craguis",
            "Cucuis",
            "Cuies",
            "Curechiu",
            "Curpenii Silvasului",
            "Cutin",
            "Campuri de Sus",
            "Campuri-Surduc",
            "Carjiti",
            "Carnesti",
            "Cabesti",
            "Cainelu de Jos",
            "Cainelu de Sus",
            "Calan",
            "Calanu Mic",
            "Caoi",
            "Caraci",
            "Carmazanesti",
            "Carpinis",
            "Carastau",
            "Castau",
            "Cazanesti",
            "Dealu Mare",
            "Dealu Mic",
            "Deleni",
            "Densus",
            "Deva",
            "Dobra",
            "Dobrot",
            "Dragu-Brad",
            "Dudesti",
            "Dumbrava",
            "Dumbrava de Jos",
            "Dumbrava de Sus",
            "Dumbravita",
            "Dumesti",
            "Dupapiatra",
            "Dancu Mare",
            "Dancu Mic",
            "Dabaca",
            "Danulesti",
            "Fata Rosie",
            "Federi",
            "Feregi",
            "Fintoag",
            "Fizes",
            "Fizesti",
            "Folt",
            "Fornadia",
            "Furcsoara",
            "Fantana",
            "Fagetel",
            "Farcadin",
            "Galati",
            "Galbina",
            "Gelmar",
            "General Berthelot",
            "Geoagiu",
            "Geoagiu-Bai",
            "Ghelari",
            "Gialacuta",
            "Giurgesti",
            "Glodghilesti",
            "Godinesti",
            "Goles",
            "Gotesti",
            "Gothatea",
            "Govajdia",
            "Grid",
            "Grind",
            "Grohot",
            "Grohotele",
            "Gros",
            "Grosuri",
            "Gradistea de Munte",
            "Gura Bordului",
            "Gurasada",
            "Gantaga",
            "Hateg",
            "Herepeia",
            "Hobita",
            "Hobita-Gradiste",
            "Holdea",
            "Homorod",
            "Hondol",
            "Hunedoara",
            "Harau",
            "Hartagani",
            "Hasdat",
            "Hasdau",
            "Hatagel",
            "Ilia",
            "Iscroni",
            "Izvoarele",
            "Jeledinti",
            "Josani",
            "Leaut",
            "Lelese",
            "Lesnic",
            "Livada",
            "Livadia",
            "Livezi",
            "Ludestii de Jos",
            "Ludestii de Sus",
            "Lunca",
            "Lunca",
            "Lunca Cernii de Jos",
            "Lunca Cernii de Sus",
            "Luncani",
            "Luncoiu de Jos",
            "Luncoiu de Sus",
            "Luncsoara",
            "Lupeni",
            "Lapugiu de Jos",
            "Lapugiu de Sus",
            "Lapusnic",
            "Lasau",
            "Mada",
            "Meria",
            "Merisor",
            "Merisor",
            "Merisoru de Munte",
            "Mermezeu-Valeni",
            "Mesteacan",
            "Mesteacan",
            "Micanesti",
            "Mihaiesti",
            "Mihaileni",
            "Mintia",
            "Mosoru",
            "Muncelu Mare",
            "Muncelu Mic",
            "Maceu",
            "Magura",
            "Magura-Toplita",
            "Magureni",
            "Malaiesti",
            "Manerau",
            "Martinesti",
            "Nandru",
            "Negoiu",
            "Nojag",
            "Nucsoara",
            "Nadastia de Jos",
            "Nadastia de Sus",
            "Obarsa",
            "Ociu",
            "Ocisor",
            "Ocolisu Mare",
            "Ocolisu Mic",
            "Ohaba",
            "Ohaba Streiului",
            "Ohaba de sub Piatra",
            "Ohaba-Ponor",
            "Ohaba-Sibisel",
            "Oprisesti",
            "Ormindea",
            "Orastie",
            "Orastioara de Jos",
            "Orastioara de Sus",
            "Ostrov",
            "Ostrovel",
            "Ostrovu Mic",
            "Panc",
            "Panc-Saliste",
            "Paros",
            "Pestisu Mic",
            "Petreni",
            "Petresti",
            "Petrila",
            "Petros",
            "Petrosani",
            "Pesteana",
            "Pestenita",
            "Pestera",
            "Pestera",
            "Pestisu Mare",
            "Piatra",
            "Pischinti",
            "Plai",
            "Plop",
            "Plopi",
            "Podele",
            "Poganesti",
            "Poiana",
            "Poiana Rachitelii",
            "Poieni",
            "Poieni",
            "Poienita",
            "Poienita Tomii",
            "Poienita Voinii",
            "Pojoga",
            "Ponor",
            "Popesti",
            "Potingani",
            "Pricaz",
            "Prihodiste",
            "Prihodiste",
            "Pravaleni",
            "Pui",
            "Paclisa",
            "Paucinesti",
            "Paulesti",
            "Paulis",
            "Rapoltu Mare",
            "Rapoltel",
            "Reea",
            "Renghet",
            "Ret",
            "Ribicioara",
            "Ribita",
            "Risca",
            "Risculita",
            "Romos",
            "Romosel",
            "Rovina",
            "Rovina",
            "Roscani",
            "Rosia",
            "Ruda",
            "Ruda-Brad",
            "Runcu Mare",
            "Runcu Mic",
            "Runcsor",
            "Rusesti",
            "Rusi",
            "Rusor",
            "Rapas",
            "Rau Alb",
            "Rau Barbat",
            "Rau Mic",
            "Rau de Mori",
            "Rachitova",
            "Rachitaua",
            "Radulesti",
            "Sarmizegetusa",
            "Sereca",
            "Sibisel",
            "Sibisel",
            "Silvasu de Jos",
            "Silvasu de Sus",
            "Simeria",
            "Simeria Veche",
            "Socet",
            "Sohodol",
            "Spini",
            "Stejarel",
            "Stoieneasa",
            "Strei",
            "Strei-Sacel",
            "Stretea",
            "Stancesti",
            "Stancesti-Ohaba",
            "Stanculesti",
            "Stanija",
            "Stauini",
            "Subcetate",
            "Sulighete",
            "Suseni",
            "Sancrai",
            "Sanpetru",
            "Santandrei",
            "Santamaria de Piatra",
            "Santamaria-Orlea",
            "Sarbi",
            "Sacel",
            "Sacamas",
            "Sacaramb",
            "Salasu de Jos",
            "Salasu de Sus",
            "Salciva",
            "Saliste",
            "Salistioara",
            "Salatruc",
            "Tarnita",
            "Techereu",
            "Teiu",
            "Teliucu Inferior",
            "Teliucu Superior",
            "Ticera",
            "Tisa",
            "Tiulesti",
            "Tomesti",
            "Tomnatec",
            "Toplita",
            "Toplita Muresului",
            "Totesti",
            "Totia",
            "Trestia",
            "Turdas",
            "Turmas",
            "Tustea",
            "Tampa",
            "Tarnava",
            "Tarnava de Cris",
            "Tarnavita",
            "Tarsa",
            "Tamasasa",
            "Tamasesti",
            "Tatarasti",
            "Tatarastii de Cris",
            "Uibaresti",
            "Ulies",
            "Ulm",
            "Unciuc",
            "Uric",
            "Uricani",
            "Uroi",
            "Ursici",
            "Vadu",
            "Vadu Dobrii",
            "Vaidei",
            "Valea",
            "Valea Arsului",
            "Valea Babii",
            "Valea Bradului",
            "Valea Daljii",
            "Valea Lunga",
            "Valea Lupului",
            "Valea Mare de Cris",
            "Valea Nandrului",
            "Valea Poienii",
            "Valea Sangeorgiului",
            "Vata de Jos",
            "Vata de Sus",
            "Vetel",
            "Vica",
            "Visca",
            "Voia",
            "Vorta",
            "Vulcan",
            "Valcele",
            "Valcelele Bune",
            "Valceluta",
            "Valari",
            "Valeni",
            "Valeni",
            "Valioara",
            "Valisoara",
            "Valisoara",
            "Varmaga",
            "Zam",
            "Zdrapti",
            "Zeicani",
            "Zavoi",
            "Serel",
            "Sesuri",
            "Soimus",
            "Stei",
            "Steia",
            "Saulesti",
            "Tebea",
            "Taratel"
          ]
        },
        {
          name: "Ialomita",
          cities: [
            "Adancata",
            "Albesti",
            "Alexeni",
            "Amara",
            "Amara Noua",
            "Andrasesti",
            "Armasesti",
            "Axintele",
            "Balaciu",
            "Bataluri",
            "Bitina-Pamanteni",
            "Bitina-Ungureni",
            "Bordusani",
            "Borduselu",
            "Boranesti",
            "Boteni",
            "Brosteni",
            "Bucu",
            "Bucsa",
            "Buesti",
            "Butoiu",
            "Barbulesti",
            "Barbatescu",
            "Barcanesti",
            "Cegani",
            "Chiroiu-Pamanteni",
            "Chiroiu-Satu Nou",
            "Chiroiu-Ungureni",
            "Ciochina",
            "Ciocarlia",
            "Ciulnita",
            "Cocora",
            "Colelia",
            "Condeesti",
            "Copuzu",
            "Cosambesti",
            "Cotorca",
            "Cosereni",
            "Crunti",
            "Crasanii de Jos",
            "Crasanii de Sus",
            "Catrunesti",
            "Cazanesti",
            "Dridu",
            "Dridu-Snagov",
            "Dragoesti",
            "Dumitresti",
            "Fetesti",
            "Fierbinti-Targ",
            "Fierbintii de Jos",
            "Fierbintii de Sus",
            "Fratilesti",
            "Fundata",
            "Facaeni",
            "Gheorghe Doja",
            "Gheorghe Lazar",
            "Gimbasani",
            "Giurgeni",
            "Grecii de Jos",
            "Grindasi",
            "Grindu",
            "Grivita",
            "Gura Ialomitei",
            "Gura Vaii",
            "Garbovi",
            "Hagieni",
            "Hagiesti",
            "Horia",
            "Iazu",
            "Ion Ghica",
            "Ion Roata",
            "Ivanesti",
            "Jilavele",
            "Lilieci",
            "Livedea",
            "Luciu",
            "Lacusteni",
            "Maia",
            "Maltezi",
            "Malu",
            "Malu Rosu",
            "Manasia",
            "Marsilieni",
            "Mihail Kogalniceanu",
            "Milosesti",
            "Mircea cel Batran",
            "Misleanu",
            "Moldoveni",
            "Movila",
            "Movileanca",
            "Movilita",
            "Munteni-Buzau",
            "Murgeanca",
            "Marculesti",
            "Nenisori",
            "Nicolesti",
            "Ograda",
            "Orboesti",
            "Orezu",
            "Patru Frati",
            "Perieti",
            "Piersica",
            "Platonesti",
            "Poiana",
            "Progresu",
            "Paltinisu",
            "Rasi",
            "Retezatu",
            "Reviga",
            "Rovine",
            "Rosiori",
            "Radulesti",
            "Rasimnicea",
            "Scanteia",
            "Sfantu Gheorghe",
            "Sinesti",
            "Sintesti",
            "Slobozia",
            "Slatioarele",
            "Smirna",
            "Stejaru",
            "Stelnica",
            "Suditi",
            "Salcioara",
            "Sarateni",
            "Saveni",
            "Tovarasia",
            "Traian",
            "Urziceni",
            "Valea Bisericii",
            "Valea Ciorii",
            "Valea Macrisului",
            "Vladeni",
            "Tandarei"
          ]
        },
        {
          name: "Iasi",
          cities: [
            "Albesti",
            "Alexandru I. Cuza",
            "Alexandru cel Bun",
            "Alexeni",
            "Alexesti",
            "Andrieseni",
            "Arama",
            "Aroneanu",
            "Avantu",
            "Bahluiu",
            "Balciu",
            "Bals",
            "Banu",
            "Belcesti",
            "Berezlogi",
            "Bivolari",
            "Blaga",
            "Boatca",
            "Bocnita",
            "Bodesti",
            "Bogdanesti",
            "Bogonos",
            "Bohotin",
            "Bojila",
            "Boldesti",
            "Borosoaia",
            "Borosesti",
            "Borsa",
            "Bosia",
            "Boureni",
            "Boureni",
            "Bran",
            "Breazu",
            "Brosteni",
            "Bradicesti",
            "Braesti",
            "Bratesti",
            "Bratuleni",
            "Bratulesti",
            "Bucium",
            "Buda",
            "Buda",
            "Budesti",
            "Buhalnita",
            "Buhaeni",
            "Bulbucani",
            "Bursuc-Deal",
            "Bursuc-Vale",
            "Buruienesti",
            "Butea",
            "Buzdug",
            "Buznea",
            "Bacu",
            "Barlesti",
            "Barnova",
            "Badeni",
            "Badarai",
            "Baiceni",
            "Baiceni",
            "Balteni",
            "Balusesti",
            "Baltati",
            "Barbatesti",
            "Ceplenita",
            "Cercu",
            "Chicerea",
            "Chilisoaia",
            "Chiperesti",
            "Chiscareni",
            "Cilibiu",
            "Cioca-Boca",
            "Ciocarlesti",
            "Ciohorani",
            "Ciortesti",
            "Cireseni",
            "Ciurbesti",
            "Ciurea",
            "Coada Stancii",
            "Coarnele Caprei",
            "Coasta Magurii",
            "Cogeasca",
            "Coltu Cornii",
            "Comarna",
            "Contesti",
            "Corcodel",
            "Cornesti",
            "Coropceni",
            "Cositeni",
            "Costesti",
            "Costuleni",
            "Cotnari",
            "Cotu Morii",
            "Cotu lui Ivan",
            "Cotargaci",
            "Covasna",
            "Cozia",
            "Cozmesti",
            "Cozmesti",
            "Cristesti",
            "Cristesti",
            "Cristesti",
            "Crivesti",
            "Crivesti",
            "Crucea",
            "Cucova",
            "Cucuteni",
            "Cucuteni",
            "Curagau",
            "Curaturi",
            "Cuza Voda",
            "Cuza Voda",
            "Carjoaia",
            "Carlig",
            "Carniceni",
            "Carbunari",
            "Cauesti",
            "Dagata",
            "Dancas",
            "Dancu",
            "Deleni",
            "Deleni",
            "Dobrovat",
            "Dolhesti",
            "Domnita",
            "Dorobant",
            "Doroscani",
            "Draguseni",
            "Draganesti",
            "Dumbrava",
            "Dumbrava",
            "Dumbravita",
            "Dumesti",
            "Dumitrestii Galatii",
            "Dadesti",
            "Erbiceni",
            "Fedeleseni",
            "Feredeni",
            "Fetesti",
            "Filiasi",
            "Focuri",
            "Forasti",
            "Frenciugi",
            "Frumusica",
            "Frasuleni",
            "Fantanele",
            "Fantanele",
            "Fagat",
            "Farcaseni",
            "Giurgesti",
            "Glodenii Gandului",
            "Glavanesti",
            "Goesti",
            "Golaiesti",
            "Gorban",
            "Goruni",
            "Grajduri",
            "Griesti",
            "Gropnita",
            "Grozesti",
            "Gradinari",
            "Gura Bohotin",
            "Gura Badilitei",
            "Gura Vaii",
            "Garbesti",
            "Ganesti",
            "Gaureni",
            "Hadambu",
            "Heci",
            "Helesteni",
            "Hermeziu",
            "Hilita",
            "Hlincea",
            "Hodora",
            "Hoisesti",
            "Holboca",
            "Holm",
            "Homita",
            "Horlesti",
            "Horlesti",
            "Horodistea",
            "Horpaz",
            "Humosu",
            "Handresti",
            "Harlau",
            "Hartoape",
            "Habasesti",
            "Halceni",
            "Halaucesti",
            "Harmaneasa",
            "Harmanestii Noi",
            "Harmanestii Vechi",
            "Harpasesti",
            "Iacobeni",
            "Iazu Nou",
            "Iazu Vechi",
            "Iasi",
            "Icuseni",
            "Iepureni",
            "Iepureni",
            "Ion Neculce",
            "Iorcani",
            "Iosupeni",
            "Ipatele",
            "Isaiia",
            "Iugani",
            "Izvoarele",
            "Jigoreni",
            "Kogalniceni",
            "Larga-Jijia",
            "Leahu-Nacu",
            "Lespezi",
            "Letcani",
            "Liteni",
            "Luceni",
            "Lunca",
            "Lunca Cetatuii",
            "Lunca Rates",
            "Luncasi",
            "Lungani",
            "Lungani",
            "Luparia",
            "Maxut",
            "Medeleni",
            "Miclauseni",
            "Mihail Kogalniceanu",
            "Mircesti",
            "Mironeasa",
            "Miroslava",
            "Miroslovesti",
            "Mitesti",
            "Mitoc",
            "Moara Ciornei",
            "Mogosesti",
            "Mogosesti-Siret",
            "Moimesti",
            "Moreni",
            "Movileni",
            "Movileni",
            "Mosna",
            "Motca",
            "Muncelu de Sus",
            "Munteni",
            "Manjesti",
            "Manzatesti",
            "Macaresti",
            "Madarjac",
            "Madarjesti",
            "Malaesti",
            "Manastirea",
            "Oboroceni",
            "Obrijeni",
            "Onesti",
            "Opriseni",
            "Oproaia",
            "Orzeni",
            "Osoi",
            "Osoi",
            "Oteleni",
            "Pascani",
            "Perieni",
            "Petresti",
            "Petrosica",
            "Picioru Lupului",
            "Pietris",
            "Pietrosu",
            "Pietraria",
            "Piscu Rusului",
            "Plugari",
            "Pocreaca",
            "Podisu",
            "Podolenii de Jos",
            "Podolenii de Sus",
            "Podu Hagiului",
            "Podu Iloaiei",
            "Podu Jijiei",
            "Poiana",
            "Poiana",
            "Poiana Manastirii",
            "Poiana Marului",
            "Poiana cu Cetate",
            "Poiana de Sus",
            "Poiana Scheii",
            "Poieni",
            "Poienile",
            "Popesti",
            "Popricani",
            "Potangeni",
            "Prigoreni",
            "Prisacani",
            "Probota",
            "Proselnici",
            "Parcovaci",
            "Padureni",
            "Padureni",
            "Paun",
            "Pausesti",
            "Recea",
            "Rediu",
            "Rediu",
            "Rediu",
            "Rediu",
            "Rediu Aldei",
            "Rediu Mitropoliei",
            "Romanesti",
            "Rotaria",
            "Roscani",
            "Rosu",
            "Ruginoasa",
            "Runcu",
            "Rusenii Noi",
            "Rusenii Vechi",
            "Rachiteni",
            "Radeni",
            "Raducaneni",
            "Rasboieni",
            "Razboieni",
            "Satu Nou",
            "Satu Nou",
            "Satu Nou",
            "Satu Nou",
            "Schitu Duca",
            "Schitu Hadambului",
            "Schitu Stavnic",
            "Scobinti",
            "Scobalteni",
            "Scoposeni",
            "Scoposeni",
            "Sculeni",
            "Scanteia",
            "Sinesti",
            "Siretel",
            "Slobozia",
            "Slobozia",
            "Slobozia",
            "Slobozia",
            "Slobozia",
            "Soci",
            "Solonet",
            "Spineni",
            "Spinoasa",
            "Spranceana",
            "Stejarii",
            "Sticlaria",
            "Stolniceni-Prajescu",
            "Stornesti",
            "Stroesti",
            "Strunga",
            "Stanca",
            "Stanca",
            "Suhulet",
            "Sangeri",
            "Sarca",
            "Sacaresti",
            "Salageni",
            "Saveni",
            "Tabara",
            "Tansa",
            "Tansa",
            "Tarnita",
            "Todirel",
            "Todiresti",
            "Tomesti",
            "Topile",
            "Totoesti",
            "Traian",
            "Trifesti",
            "Tudor Vladimirescu",
            "Tufestii de Sus",
            "Tungujei",
            "Targu Frumos",
            "Tatarusi",
            "Tautesti",
            "Uda",
            "Ulmi",
            "Ungheni",
            "Uricani",
            "Ursoaia",
            "Ursaresti",
            "Ursita",
            "Vadu Vejei",
            "Valea Adanca",
            "Valea Lunga",
            "Valea Lupului",
            "Valea Oilor",
            "Valea Racului",
            "Valea Satului",
            "Valea Seaca",
            "Valea Ursului",
            "Vama",
            "Vascani",
            "Verseni",
            "Victoria",
            "Visan",
            "Vladomira",
            "Vladeni",
            "Vladiceni",
            "Vladnicut",
            "Vocotesti",
            "Voinesti",
            "Volintiresti",
            "Vorovesti",
            "Vulturi",
            "Valcelele",
            "Valcica",
            "Vanatori",
            "Vanatori",
            "Valenii",
            "Zaboloteni",
            "Zagavia",
            "Zbereni",
            "Zberoaia",
            "Zece Prajini",
            "Zlodica",
            "Zmeu",
            "Scheia",
            "Scheia",
            "Sendreni",
            "Serbesti",
            "Sipote",
            "Sorogari",
            "Tibana",
            "Tibanesti",
            "Tiganasi",
            "Tipilesti",
            "Tutora"
          ]
        },
        {
          name: "Ilfov",
          cities: [
            "1 Decembrie",
            "Afumati",
            "Balotesti",
            "Balta Neagra",
            "Berceni",
            "Bragadiru",
            "Branesti",
            "Buciumeni",
            "Buda",
            "Buftea",
            "Burias",
            "Balteni",
            "Balaceanca",
            "Cernica",
            "Chiajna",
            "Chitila",
            "Ciofliceni",
            "Ciolpani",
            "Ciorogarla",
            "Clinceni",
            "Copaceni",
            "Corbeanca",
            "Cornetu",
            "Cozieni",
            "Creata",
            "Cretesti",
            "Cretuleasca",
            "Caciulati",
            "Caldararu",
            "Catelu",
            "Dascalu",
            "Dimieni",
            "Dobroesti",
            "Domnesti",
            "Dragomiresti-Deal",
            "Dragomiresti-Vale",
            "Dudu",
            "Dumbraveni",
            "Darvari",
            "Darasti-Ilfov",
            "Fundeni",
            "Gagu",
            "Ghermanesti",
            "Glina",
            "Gruiu",
            "Gradistea",
            "Ganeasa",
            "Islaz",
            "Izvorani",
            "Jilava",
            "Lipia",
            "Luparia",
            "Manolache",
            "Merii Petchii",
            "Micsunesti-Moara",
            "Micsunestii Mari",
            "Moara Domneasca",
            "Moara Vlasiei",
            "Mogosoaia",
            "Magurele",
            "Maineasca",
            "Nuci",
            "Odaile",
            "Olteni",
            "Ordoreanu",
            "Ostratu",
            "Otopeni",
            "Pantelimon",
            "Pasarea",
            "Peris",
            "Petresti",
            "Petrachioaia",
            "Piscu",
            "Piteasca",
            "Popesti-Leordeni",
            "Posta",
            "Rosu",
            "Runcu",
            "Silistea Snagovului",
            "Sintesti",
            "Sitaru",
            "Snagov",
            "Surlari",
            "Saftica",
            "Tamasi",
            "Tunari",
            "Tancabesti",
            "Tanganu",
            "Vadu Anei",
            "Vidra",
            "Vladiceasca",
            "Voluntari",
            "Vanatori",
            "Zurbaua",
            "Santu-Floresti",
            "Sindrilita",
            "Stefanestii de Jos",
            "Stefanestii de Sus",
            "Teghes"
          ]
        },
        {
          name: "Maramures",
          cities: [
            "Ardusat",
            "Arduzel",
            "Ariesu de Camp",
            "Ariesu de Padure",
            "Arinis",
            "Aspra",
            "Asuaju de Jos",
            "Asuaju de Sus",
            "Baba",
            "Baia Mare",
            "Baia Sprie",
            "Berbesti",
            "Berchez",
            "Berchezoaia",
            "Berinta",
            "Bicaz",
            "Bistra",
            "Bocicoel",
            "Bocicoiu Mare",
            "Bogdan Voda",
            "Boiereni",
            "Boiu Mare",
            "Bontaieni",
            "Borcut",
            "Borsa",
            "Botiza",
            "Bozanta Mare",
            "Bozanta Mica",
            "Breb",
            "Brebeni",
            "Budesti",
            "Buteasa",
            "Buzesti",
            "Bargau",
            "Barsana",
            "Baiut",
            "Baita de sub Codru",
            "Basesti",
            "Cavnic",
            "Cernesti",
            "Cetatele",
            "Chechis",
            "Chelinta",
            "Cicarlau",
            "Ciocotis",
            "Ciuta",
            "Coas",
            "Codru Butesii",
            "Coltau",
            "Coltirea",
            "Copalnic",
            "Copalnic-Deal",
            "Copalnic-Manastur",
            "Cornesti",
            "Corni",
            "Coroieni",
            "Coruia",
            "Costeni",
            "Costiui",
            "Crasna Viseului",
            "Craciunesti",
            "Cufoaia",
            "Culcea",
            "Cupseni",
            "Curtuiusu Mare",
            "Curtuiusu Mic",
            "Campulung la Tisa",
            "Calinesti",
            "Carbunari",
            "Carpinis",
            "Catalina",
            "Dealu Corbului",
            "Dealu Mare",
            "Desesti",
            "Dobricu Lapusului",
            "Dragomiresti",
            "Draghia",
            "Dumbrava",
            "Dumbravita",
            "Durusa",
            "Damacuseni",
            "Danesti",
            "Danestii Chioarului",
            "Feresti",
            "Fericea",
            "Fersig",
            "Finteusu Mare",
            "Finteusu Mic",
            "Francenii Boiului",
            "Fanate",
            "Fantanele",
            "Farcasa",
            "Fauresti",
            "Giulesti",
            "Glod",
            "Groape",
            "Grosi",
            "Grosii Tiblesului",
            "Gardani",
            "Handalu Ilbei",
            "Hideaga",
            "Hoteni",
            "Harnicesti",
            "Iadara",
            "Ieud",
            "Ilba",
            "Inau",
            "Izvoarele",
            "Jugastreni",
            "Larga",
            "Leordina",
            "Libotin",
            "Lucacesti",
            "Lunca la Tisa",
            "Lapus",
            "Lapusel",
            "Laschia",
            "Mara",
            "Merisor",
            "Mesteacan",
            "Miresu Mare",
            "Mocira",
            "Mogosesti",
            "Moisei",
            "Manau",
            "Magureni",
            "Manastirea",
            "Negreia",
            "Nanesti",
            "Oarta de Jos",
            "Oarta de Sus",
            "Ocna Sugatag",
            "Ocolis",
            "Odesti",
            "Oncesti",
            "Ortita",
            "Peteritea",
            "Petrova",
            "Piatra",
            "Plopis",
            "Poiana Botizii",
            "Poienile Izei",
            "Poienile de sub Munte",
            "Posta",
            "Preluca Noua",
            "Preluca Veche",
            "Pribilesti",
            "Prislop",
            "Recea",
            "Remecioara",
            "Remetea Chioarului",
            "Remeti",
            "Remeti pe Somes",
            "Repedea",
            "Rodina",
            "Rogoz",
            "Rohia",
            "Romanesti",
            "Rona de Jos",
            "Rona de Sus",
            "Rozavlea",
            "Rus",
            "Ruscova",
            "Rusor",
            "Razoare",
            "Sarasau",
            "Sat-Sugatag",
            "Satu Nou de Jos",
            "Satu Nou de Sus",
            "Satulung",
            "Seini",
            "Sighetu Marmatiei",
            "Slatioara",
            "Somes-Uileac",
            "Stejera",
            "Stoiceni",
            "Stremt",
            "Strambu-Baiut",
            "Stramtura",
            "Suciu de Jos",
            "Suciu de Sus",
            "Salta",
            "Sarbi",
            "Sarbi",
            "Sabisa",
            "Sacel",
            "Sacalaseni",
            "Saliste",
            "Salistea de Sus",
            "Salnita",
            "Salsig",
            "Sapanta",
            "Sasar",
            "Teceu Mic",
            "Tisa",
            "Trestia",
            "Tulghies",
            "Targu Lapus",
            "Tamaia",
            "Tamasesti",
            "Tautii-Magheraus",
            "Ulmeni",
            "Ulmoasa",
            "Unguras",
            "Ungureni",
            "Urmenis",
            "Vad",
            "Vadu Izei",
            "Valea Chioarului",
            "Valea Stejarului",
            "Valea Viseului",
            "Vicea",
            "Viile Apei",
            "Vima Mare",
            "Vima Mica",
            "Viseu de Jos",
            "Viseu de Sus",
            "Valeni",
            "Valenii Lapusului",
            "Varai",
            "Intrerauri",
            "Sieu",
            "Sindresti",
            "Sisesti",
            "Somcuta Mare",
            "Surdesti",
            "Ticau"
          ]
        },
        {
          name: "Mehedinti",
          cities: [
            "23 August",
            "Adunatii Teiului",
            "Albulesti",
            "Almajel",
            "Alunisul",
            "Arginesti",
            "Arvatesti",
            "Aurora",
            "Bahna",
            "Baia Noua",
            "Baia de Arama",
            "Bala",
            "Bala de Sus",
            "Balota",
            "Balotesti",
            "Balta",
            "Balta Verde",
            "Batoti",
            "Biban",
            "Bistretu",
            "Bistrita",
            "Blidaru",
            "Bobaita",
            "Boceni",
            "Borogea",
            "Branistea",
            "Bratesul",
            "Bratilovu",
            "Brativoesti",
            "Brebina",
            "Breznicioara",
            "Breznita-Motru",
            "Breznita-Ocol",
            "Breta",
            "Brosteni",
            "Bragleasa",
            "Branzeni",
            "Bucura",
            "Budanesti",
            "Buicani",
            "Buicesti",
            "Bunoaica",
            "Burila Mare",
            "Burila Mica",
            "Busesti",
            "Butoiesti",
            "Bacles",
            "Baltanele",
            "Baltanele",
            "Balvanesti",
            "Balvanestii de Jos",
            "Barda",
            "Barlogeni",
            "Baraiacu",
            "Baditesti",
            "Baluta",
            "Balacita",
            "Cearangu",
            "Celnata",
            "Ceptureni",
            "Cerna-Varf",
            "Cernaia",
            "Cerneti",
            "Cervenita",
            "Ceranganul",
            "Cioroboreni",
            "Ciovarnasani",
            "Ciresu",
            "Coada Cornetului",
            "Cocorova",
            "Colaret",
            "Colibasi",
            "Comanesti",
            "Copacioasa",
            "Corcova",
            "Cordun",
            "Corlatel",
            "Corzu",
            "Cosovat",
            "Costesti",
            "Cotoroaia",
            "Cozia",
            "Cracu Lung",
            "Cracu Muntelui",
            "Crainici",
            "Cremenea",
            "Crivina",
            "Croica",
            "Craguesti",
            "Cujmir",
            "Cujmiru Mic",
            "Campu Mare",
            "Carceni",
            "Carjei",
            "Carsu",
            "Calinestii de Jos",
            "Calinestii de Sus",
            "Capatanesti",
            "Caramidaru",
            "Cazanesti",
            "Dealu Mare",
            "Dedovita Noua",
            "Dedovita Veche",
            "Deleni",
            "Delureni",
            "Devesel",
            "Dobra",
            "Dragotesti",
            "Drincea",
            "Drobeta-Turnu Severin",
            "Draghesti",
            "Dubova",
            "Dudasu",
            "Dumbrava de Jos",
            "Dumbrava de Mijloc",
            "Dumbrava de Sus",
            "Dumbravita",
            "Dunarea Mica",
            "Dalbocita",
            "Dalma",
            "Darvari",
            "Danceu",
            "Eibenthal",
            "Ercea",
            "Erghevita",
            "Eselnita",
            "Fata Cremenii",
            "Fata Motrului",
            "Firizu",
            "Floresti",
            "Fantana Domneasca",
            "Fantanile Negre",
            "Fauroaia",
            "Gemeni",
            "Ghelmegioaia",
            "Gheorghesti",
            "Giura",
            "Giurgiani",
            "Goanta",
            "Godeanu",
            "Godeanu",
            "Gogosu",
            "Golineasa",
            "Gornenti",
            "Gornovita",
            "Govodarva",
            "Greci",
            "Grozesti",
            "Gruia",
            "Gura Motrului",
            "Gutu",
            "Gvardinita",
            "Garbovatu de Jos",
            "Garbovatu de Sus",
            "Gardoaia",
            "Garla Mare",
            "Garnita",
            "Gardaneasa",
            "Halanga",
            "Higiu",
            "Hinova",
            "Hotarani",
            "Husnicioara",
            "Iablanita",
            "Igiroasa",
            "Ilovita",
            "Ilovu",
            "Ilovat",
            "Imoasa",
            "Isverna",
            "Iupca",
            "Izimsa",
            "Izvoarele",
            "Izvoru Anestilor",
            "Izvoru Barzii",
            "Izvoru Frumos",
            "Izvoralu",
            "Izvoralu de Jos",
            "Jiana",
            "Jiana Mare",
            "Jiana Veche",
            "Jidostita",
            "Jignita",
            "Jirov",
            "Jugastru",
            "Jupanesti",
            "Lac",
            "Lazu",
            "Livezi",
            "Livezile",
            "Ludu",
            "Lumnic",
            "Luncsoara",
            "Lupsa de Jos",
            "Lupsa de Sus",
            "Magheru",
            "Malovat",
            "Manu",
            "Marga",
            "Marmanu",
            "Menti",
            "Meris",
            "Mijarca",
            "Moisesti",
            "Molani",
            "Motruleni",
            "Mosneni",
            "Magurele",
            "Malarisca",
            "Maru Rosu",
            "Marasesti",
            "Nadanova",
            "Negoesti",
            "Negresti",
            "Negrusa",
            "Nevatu",
            "Nicolae Balcescu",
            "Noaptesa",
            "Obarsia de Camp",
            "Obarsia-Closani",
            "Ohaba",
            "Olteanca",
            "Oprisor",
            "Opranesti",
            "Orevita Mare",
            "Orsova",
            "Ostrovu Corbului",
            "Ostrovu Mare",
            "Pavat",
            "Peri",
            "Petra",
            "Petris",
            "Pesteana",
            "Pestenuta",
            "Pistrita",
            "Plai",
            "Plopi",
            "Pluta",
            "Podeni",
            "Podu Grosului",
            "Poiana",
            "Poiana Gruii",
            "Ponoarele",
            "Poroina",
            "Poroina Mare",
            "Poroinita",
            "Portile de Fier II",
            "Posta Veche",
            "Prejna",
            "Priboiesti",
            "Pristol",
            "Prisaceaua",
            "Proitesti",
            "Prunaru",
            "Prunisor",
            "Punghina",
            "Puscasu",
            "Putinei",
            "Parlagele",
            "Parvulesti",
            "Padina Mare",
            "Padina Mica",
            "Paltinisu",
            "Pasarani",
            "Patulele",
            "Paunesti",
            "Racova",
            "Recea",
            "Rocsoreni",
            "Rogova",
            "Rosia",
            "Rosiori",
            "Rudina",
            "Runcusoru",
            "Ruptura",
            "Radutesti",
            "Raiculesti",
            "Rascolesti",
            "Salcia",
            "Satu Mare",
            "Satu Nou",
            "Schinteiesti",
            "Schitu Topolnitei",
            "Scorila",
            "Scapau",
            "Selistea",
            "Selisteni",
            "Selistiuta",
            "Severinesti",
            "Sfodea",
            "Sisesti",
            "Slasoma",
            "Smadovita",
            "Sperlesti",
            "Stejaru",
            "Stignita",
            "Strehaia",
            "Stroesti",
            "Studina",
            "Stangaceaua",
            "Stancesti",
            "Stanesti",
            "Suharu",
            "Svinita",
            "Salatruc",
            "Sardanesti",
            "Tismana",
            "Titerlesti",
            "Traian",
            "Turtaba",
            "Tamna",
            "Tarsa",
            "Talapanu",
            "Valea Anilor",
            "Valea Buna",
            "Valea Copcii",
            "Valea Cosustei",
            "Valea Marcului",
            "Valea Petrii",
            "Valea Teiului",
            "Valea Ursului",
            "Valea Ursului",
            "Varodia",
            "Viasu",
            "Vidimiresti",
            "Visina",
            "Vladaia",
            "Vladica",
            "Vladasesti",
            "Voloiac",
            "Voloicel",
            "Vrancea",
            "Vrata",
            "Vanju Mare",
            "Vanjulet",
            "Vanatori",
            "Zegaia",
            "Zegujani",
            "Simian",
            "Sipotu",
            "Sipotu",
            "Siroca",
            "Sovarna",
            "Stefan Odobleja",
            "Stircovita",
            "Susita",
            "Susita",
            "Tiganasi",
            "Titirigi",
            "Tantaru"
          ]
        },
        {
          name: "Mures",
          cities: [
            "Abud",
            "Abus",
            "Acatari",
            "Adrian",
            "Adrianu Mare",
            "Adrianu Mic",
            "Adamus",
            "Agristeu",
            "Albesti",
            "Alunis",
            "Andreneasa",
            "Apold",
            "Archita",
            "Arsita",
            "Atintis",
            "Bahnea",
            "Band",
            "Batos",
            "Bedeni",
            "Beica de Jos",
            "Beica de Sus",
            "Bereni",
            "Berghia",
            "Bernadea",
            "Bicasu",
            "Bichis",
            "Bistra Muresului",
            "Blidireasa",
            "Bobohalma",
            "Bogata",
            "Boiu",
            "Bolintineni",
            "Bologaia",
            "Bord",
            "Bordosiu",
            "Borzia",
            "Botei",
            "Botez",
            "Bozed",
            "Bozeni",
            "Breaza",
            "Brancovenesti",
            "Bradetelu",
            "Budiu Mic",
            "Bujor",
            "Bujor-Hodaie",
            "Bara",
            "Barlibas",
            "Barlibasoaia",
            "Barza",
            "Bagaciu",
            "Baita",
            "Bala",
            "Balauseri",
            "Barbosi",
            "Bardesti",
            "Casva",
            "Cecalaca",
            "Ceie",
            "Ceuas",
            "Ceuasu de Campie",
            "Chendu",
            "Chetani",
            "Chibed",
            "Chiheru de Jos",
            "Chiheru de Sus",
            "Chinari",
            "Chincius",
            "Chirileu",
            "Chisalita",
            "Ciba",
            "Cibu",
            "Cinta",
            "Ciobotani",
            "Cipaieni",
            "Cipau",
            "Ciretea",
            "Cirhagau",
            "Ciulea",
            "Cloasterf",
            "Coasta Grindului",
            "Coasta Mare",
            "Comori",
            "Corbesti",
            "Cordos",
            "Cornesti",
            "Cornesti",
            "Coroi",
            "Coroisanmartin",
            "Corunca",
            "Cotorinau",
            "Cotus",
            "Cozma",
            "Cristesti",
            "Cris",
            "Craciunesti",
            "Craiesti",
            "Craiesti",
            "Cucerdea",
            "Cuci",
            "Cuiesd",
            "Culpiu",
            "Cund",
            "Curete",
            "Curteni",
            "Custelnic",
            "Campenita",
            "Campu Cetatii",
            "Candu",
            "Caciulata",
            "Cacuciu",
            "Calimanesti",
            "Calugareni",
            "Caluseri",
            "Capusu de Campie",
            "Capalna de Sus",
            "Daia",
            "Daia",
            "Dalu",
            "Danes",
            "Deag",
            "Deaj",
            "Dealu Frumos",
            "Deda",
            "Dedrad",
            "Deleni",
            "Deleni",
            "Deleni",
            "Dileu Nou",
            "Dileu Vechi",
            "Dobra",
            "Drojdii",
            "Draculea Bandului",
            "Dubistea de Padure",
            "Dulcea",
            "Dumbrava",
            "Dumbravioara",
            "Dumitreni",
            "Dupa Deal",
            "Dupa Deal",
            "Dambu",
            "Dambau",
            "Damieni",
            "Dataseni",
            "Ercea",
            "Eremieni",
            "Eremitu",
            "Ernei",
            "Feleag",
            "Filea",
            "Filitelnic",
            "Filpisu Mare",
            "Filpisu Mic",
            "Fitcau",
            "Foi",
            "Frunzeni",
            "Fundoaia",
            "Fanate",
            "Fanate",
            "Fanate",
            "Fanate",
            "Fanatele Capusului",
            "Fanatele Madarasului",
            "Fanatele Socolului",
            "Fantana Babii",
            "Fantanele",
            "Faragau",
            "Gaura Sangerului",
            "Gheorghe Doja",
            "Ghidasteu",
            "Ghindari",
            "Ghinesti",
            "Giulus",
            "Giurgis",
            "Glodeni",
            "Glajarie",
            "Gogan",
            "Goreni",
            "Gornesti",
            "Grebenisu de Campie",
            "Grindeni",
            "Groapa Radaii",
            "Gruisor",
            "Grausorul",
            "Gradini",
            "Gurghiu",
            "Gambut",
            "Gaiesti",
            "Galesti",
            "Galaoaia",
            "Galateni",
            "Ganesti",
            "Habic",
            "Hagau",
            "Herepea",
            "Herghelia",
            "Hetiur",
            "Hodac",
            "Hodaia",
            "Hodosa",
            "Hadareni",
            "Haranglab",
            "Hartau",
            "Iara de Mures",
            "Ibanesti",
            "Ibanesti-Padure",
            "Icland",
            "Iclandu Mare",
            "Iclanzel",
            "Ideciu de Jos",
            "Ideciu de Sus",
            "Idicel",
            "Idicel-Padure",
            "Idiciu",
            "Idrifaia",
            "Iernut",
            "Ihod",
            "Ilieni",
            "Ilioara",
            "Iod",
            "Isla",
            "Ivanesti",
            "Istan-Tau",
            "Istihaza",
            "Jabenita",
            "Jacodu",
            "Jacu",
            "Larga",
            "Laslau Mare",
            "Laslau Mic",
            "Lechincioara",
            "Lechinta",
            "Lefaia",
            "Lenis",
            "Leordeni",
            "Leorinta",
            "Leorinta-Saulia",
            "Lepindea",
            "Lint",
            "Livezeni",
            "Logig",
            "Ludus",
            "Luieriu",
            "Lunca",
            "Lunca Bradului",
            "Lunca Muresului",
            "Lapusna",
            "Lascud",
            "Maia",
            "Maiad",
            "Maioresti",
            "Maldaoci",
            "Malea",
            "Merisor",
            "Merisoru",
            "Mestera",
            "Mica",
            "Miercurea Nirajului",
            "Mihai Viteazu",
            "Mihesu de Campie",
            "Milasel",
            "Mirigioaia",
            "Mitresti",
            "Moara de Jos",
            "Mogoaia",
            "Moisa",
            "Morareni",
            "Mura Mare",
            "Mura Mica",
            "Mureni",
            "Murgesti",
            "Macicasesti",
            "Madaras",
            "Madaraseni",
            "Magherani",
            "Magherus",
            "Malaesti",
            "Marculeni",
            "Marasesti",
            "Matrici",
            "Nades",
            "Nadasa",
            "Nandra",
            "Nazna",
            "Neagra",
            "Neaua",
            "Negrenii de Campie",
            "Nicolesti",
            "Nima Milaselului",
            "Nima Raciului",
            "Oarba de Mures",
            "Obarsie",
            "Odrihei",
            "Ogra",
            "Onuca",
            "Ormenis",
            "Oroiu",
            "Orosia",
            "Orsova",
            "Orsova-Padure",
            "Ozd",
            "Papiu Ilarian",
            "Peris",
            "Petea",
            "Petelea",
            "Petrilaca",
            "Petrilaca de Mures",
            "Pietris",
            "Pipea",
            "Poarta",
            "Poduri",
            "Pogaceaua",
            "Poienita",
            "Porumbac",
            "Porumbeni",
            "Pripoare",
            "Pusta",
            "Parau Crucii",
            "Parau Crucii",
            "Parau Mare",
            "Pacureni",
            "Padurea",
            "Padureni",
            "Paingeni",
            "Panet",
            "Pasareni",
            "Paucisoara",
            "Pauloaia",
            "Racamet",
            "Ranta",
            "Reghin",
            "Rigmani",
            "Roteni",
            "Roua",
            "Rusii-Munti",
            "Raciu",
            "Rapa de Jos",
            "Rastolita",
            "Razoare",
            "Saschiz",
            "Satu Nou",
            "Satu Nou",
            "Scurta",
            "Sebes",
            "Seleus",
            "Seleus",
            "Senereus",
            "Seuca",
            "Sfantu Gheorghe",
            "Sicele",
            "Sighisoara",
            "Socolu de Campie",
            "Solocma",
            "Solovastru",
            "Sovata",
            "Stejeris",
            "Stejarenii",
            "Stanceni",
            "Sub Padure",
            "Suplac",
            "Suseni",
            "Suveica",
            "Sambrias",
            "Sancraiu de Mures",
            "Sangeorgiu de Campie",
            "Sangeorgiu de Mures",
            "Sangeorgiu de Padure",
            "Sanger",
            "Sangeru de Padure",
            "Saniacob",
            "Sanisor",
            "Sanmihai de Padure",
            "Sanmarghita",
            "Sanmartinu de Campie",
            "Sanpaul",
            "Sanpetru de Campie",
            "Sansimion",
            "Santana de Mures",
            "Santioana",
            "Santioana de Mures",
            "Santu",
            "Sanvasii",
            "Sabed",
            "Sacalu de Padure",
            "Sacareni",
            "Salard",
            "Salasuri",
            "Salcud",
            "Sarmasu",
            "Sarateni",
            "Teleac",
            "Tireu",
            "Tirimia",
            "Tirimioara",
            "Tisieu",
            "Toaca",
            "Tofalau",
            "Toldal",
            "Tonciu",
            "Torba",
            "Trei Sate",
            "Troita",
            "Tusinu",
            "Targu Mures",
            "Tarnaveni",
            "Tablaseni",
            "Tau",
            "Taureni",
            "Uila",
            "Ulies",
            "Ungheni",
            "Uricea",
            "Urisiu de Jos",
            "Urisiu de Sus",
            "Ursoaia",
            "Vadu",
            "Vaidacuta",
            "Vaideiu",
            "Valea",
            "Valea Albestiului",
            "Valea Daii",
            "Valea Fratiei",
            "Valea Glodului",
            "Valea Iclandului",
            "Valea Izvoarelor",
            "Valea Larga",
            "Valea Mare",
            "Valea Padurii",
            "Valea Rece",
            "Valea Sasului",
            "Valea Seaca",
            "Valea Sanmartinului",
            "Valea Sanpetrului",
            "Valea Sanpetrului",
            "Valea Uliesului",
            "Valea Ungurului",
            "Valea Uriesului",
            "Valea Sapartocului",
            "Valea Surii",
            "Vetca",
            "Viforoasa",
            "Viisoara",
            "Voiniceni",
            "Voivodeni",
            "Vulcan",
            "Vanatori",
            "Vadas",
            "Valeni",
            "Valenii",
            "Valenii de Mures",
            "Valisoara",
            "Valureni",
            "Vargata",
            "Vatava",
            "Zagar",
            "Zau de Campie",
            "Zimti",
            "Zapodea",
            "Saes",
            "Sandru",
            "Sapartoc",
            "Serbeni",
            "Seulia de Mures",
            "Silea Nirajului",
            "Sincai",
            "Sincai-Fanate",
            "Soard",
            "Soimus",
            "Somostelnic",
            "Stefanca",
            "Stefaneaca",
            "Saulia",
            "Saulita",
            "Tigmandru",
            "Tiptelnic",
            "Topa"
          ]
        },
        {
          name: "Neamt",
          cities: [
            "Adjudeni",
            "Agapia",
            "Agarcia",
            "Alexandru I. Cuza",
            "Almas",
            "Ardeluta",
            "Aramesti",
            "Aramoaia",
            "Averesti",
            "Bahna",
            "Bahna Mare",
            "Baratca",
            "Barticesti",
            "Basta",
            "Betesti",
            "Bicaz",
            "Bicaz-Chei",
            "Bicazu Ardelean",
            "Bisericani",
            "Bistricioara",
            "Bistrita",
            "Boboiesti",
            "Bodesti",
            "Bodestii de Jos",
            "Boghicea",
            "Bogzesti",
            "Boistea",
            "Borca",
            "Bordea",
            "Borlesti",
            "Bornis",
            "Borseni",
            "Botesti",
            "Bozieni",
            "Bozienii de Sus",
            "Botesti",
            "Bradu",
            "Brates",
            "Breaza",
            "Britcani",
            "Brosteni",
            "Brusturi",
            "Brasauti",
            "Bucium",
            "Budesti",
            "Buhalnita",
            "Buhonca",
            "Bunghi",
            "Buruienesti",
            "Butnaresti",
            "Busmei",
            "Bara",
            "Bargauani",
            "Barjoveni",
            "Barnadu",
            "Bahnisoara",
            "Balusesti",
            "Balusesti",
            "Balanesti",
            "Baltatesti",
            "Baneasa",
            "Barcanesti",
            "Batranesti",
            "Cazaci",
            "Ceahlau",
            "Certieni",
            "Chicerea",
            "Chilia",
            "Chilii",
            "Chiriteni",
            "Ciornei",
            "Ciurea",
            "Climesti",
            "Cordun",
            "Corhana",
            "Corni",
            "Costisa",
            "Cotu Vames",
            "Cracaul Negru",
            "Cracaoani",
            "Craiesti",
            "Cuci",
            "Cuejdiu",
            "Curechistea",
            "Cut",
            "Candesti",
            "Carlig",
            "Carligi",
            "Caciulesti",
            "Calugareni",
            "Causeni",
            "Casaria",
            "David",
            "Davideni",
            "Deleni",
            "Dobreni",
            "Dochia",
            "Doina",
            "Dolhesti",
            "Doljesti",
            "Dornesti",
            "Dragomiresti",
            "Dragova",
            "Dreptu",
            "Draganesti",
            "Dulcesti",
            "Dumbrava",
            "Dumbrava Rosie",
            "Dumbrava-Deal",
            "Dusesti",
            "Darloaia",
            "Damuc",
            "Danesti",
            "Farcasa",
            "Filioara",
            "Frumosu",
            "Frunzeni",
            "Faurei",
            "Galu",
            "Ghelaiesti",
            "Gherman",
            "Gheraesti",
            "Gheraestii Noi",
            "Ghidion",
            "Ghigoiesti",
            "Ghindaoani",
            "Girov",
            "Giulesti",
            "Giurgeni",
            "Gorun",
            "Gosmani",
            "Grinties",
            "Grozavesti",
            "Grosi",
            "Grumazesti",
            "Gura Vaii",
            "Gadinti",
            "Garcina",
            "Hamzoaia",
            "Hangu",
            "Hanul Ancutei",
            "Hlapesti",
            "Hociungi",
            "Hoisesti",
            "Holm",
            "Homiceni",
            "Horia",
            "Huisurez",
            "Hartop",
            "Hartesti",
            "Icusesti",
            "Ingaresti",
            "Ion Creanga",
            "Itrinesti",
            "Iucsa",
            "Ivanes",
            "Izvoare",
            "Izvoare",
            "Izvoru",
            "Izvoru Alb",
            "Kogalniceni",
            "Leghin",
            "Liliac",
            "Linsesti",
            "Luminis",
            "Lunca",
            "Lunca",
            "Lunca",
            "Lunca Moldovei",
            "Lutca",
            "Magazia",
            "Mastacan",
            "Mastacan",
            "Mesteacan",
            "Micsunesti",
            "Miron Costin",
            "Mitocu Balan",
            "Moldoveni",
            "Moreni",
            "Muncelu",
            "Muncelu de Jos",
            "Munteni",
            "Manastirea Neamt",
            "Madei",
            "Manoaia",
            "Margineni",
            "Marmureni",
            "Neagra",
            "Nechit",
            "Negresti",
            "Negresti",
            "Negritesti",
            "Negulesti",
            "Nemtisor",
            "Netezi",
            "Nisiporesti",
            "Nistria",
            "Oantu",
            "Oglinzi",
            "Oniceni",
            "Ortasti",
            "Oslobeni",
            "Patricheni",
            "Petricani",
            "Petru Voda",
            "Piatra Neamt",
            "Piatra Soimului",
            "Pietrosu",
            "Pildesti",
            "Pipirig",
            "Plugari",
            "Pluton",
            "Plaiesu",
            "Podoleni",
            "Poiana",
            "Poiana",
            "Poiana",
            "Poiana",
            "Poiana",
            "Poiana Cracaoani",
            "Poiana Humei",
            "Poiana Largului",
            "Poiana Teiului",
            "Poienari",
            "Poieni",
            "Poienile Oancei",
            "Poloboc",
            "Popesti",
            "Popesti",
            "Potoci",
            "Preluca",
            "Preutesti",
            "Prajesti",
            "Pustieta",
            "Pancesti",
            "Pangarati",
            "Pangaracior",
            "Paraul Carjei",
            "Paraul Fagului",
            "Paraul Mare",
            "Paraul Pantei",
            "Pataligeni",
            "Padureni",
            "Pastraveni",
            "Recea",
            "Rediu",
            "Rediu",
            "Rocna",
            "Roman",
            "Romani",
            "Rotunda",
            "Roznov",
            "Roseni",
            "Rosiori",
            "Ruginesti",
            "Ruginoasa",
            "Ruseni",
            "Ruseni",
            "Rasca",
            "Radeni",
            "Raucesti",
            "Razboieni",
            "Razboienii de Jos",
            "Sabasa",
            "Sagna",
            "Schitu Tarcau",
            "Scaricica",
            "Secu",
            "Secuieni",
            "Secuienii Noi",
            "Silistea",
            "Simionesti",
            "Slobozia",
            "Socea",
            "Soci",
            "Soci",
            "Solca",
            "Spiesti",
            "Spiridonesti",
            "Stejaru",
            "Stejaru",
            "Stejaru",
            "Straja",
            "Stanca",
            "Stanita",
            "Sabaoani",
            "Sacaleni",
            "Sacalusesti",
            "Sarata",
            "Savesti",
            "Savinesti",
            "Savinesti",
            "Tabara",
            "Talpa",
            "Tarcau",
            "Tazlau",
            "Tasca",
            "Telec",
            "Tetcani",
            "Ticos",
            "Ticos-Floarea",
            "Timisesti",
            "Todireni",
            "Topoliceni",
            "Topolita",
            "Totoiesti",
            "Traian",
            "Traian",
            "Trei Fantani",
            "Trifesti",
            "Tupilati",
            "Turturesti",
            "Targu Neamt",
            "Tarpesti",
            "Tarzia",
            "Talpalai",
            "Tamaseni",
            "Uncesti",
            "Ungheni",
            "Unghi",
            "Urecheni",
            "Vad",
            "Vaduri",
            "Valea Alba",
            "Valea Arini",
            "Valea Enei",
            "Valea Mare",
            "Valea Seaca",
            "Valea Ursului",
            "Veja",
            "Versesti",
            "Viisoara",
            "Vladiceni",
            "Vladnicele",
            "Volintiresti",
            "Vulpasesti",
            "Vanatori-Neamt",
            "Vadurele",
            "Vadurele",
            "Valeni",
            "Varatec",
            "Zvoranesti",
            "Zanesti",
            "Scheia",
            "Soimaresti",
            "Sovoaia",
            "Stefan cel Mare",
            "Tibucani",
            "Tibucanii de Jos",
            "Tolici",
            "Tutcanii din Deal",
            "Tutcanii din Vale",
            "Tardenii Mici"
          ]
        },
        {
          name: "Olt",
          cities: [
            "Afumati",
            "Albesti",
            "Alimanesti",
            "Alunisu",
            "Arcesti",
            "Arcesti-Cot",
            "Arvateasca",
            "Bacea",
            "Baldovinesti",
            "Bals",
            "Barza",
            "Batia",
            "Bechet",
            "Beculesti",
            "Belgun",
            "Beria de Jos",
            "Beria de Sus",
            "Berindei",
            "Bircii",
            "Bistrita Noua",
            "Blaj",
            "Bobicesti",
            "Bobu",
            "Bondrea",
            "Boroesti",
            "Branet",
            "Brastavatu",
            "Brebeni",
            "Brosteni",
            "Brancoveni",
            "Bucinisu",
            "Bucinisu Mic",
            "Buicesti",
            "Bulimanu",
            "Burdulesti",
            "Buta",
            "Butoi",
            "Buzesti",
            "Busca",
            "Bagesti",
            "Barca",
            "Barsestii de Sus",
            "Barza",
            "Babiciu",
            "Baleasa",
            "Balteni",
            "Balanesti",
            "Baltati",
            "Barbalai",
            "Barcanesti",
            "Barasti",
            "Barasti",
            "Barastii de Cepturi",
            "Barastii de Vede",
            "Batareni",
            "Caracal",
            "Catanele",
            "Cepari",
            "Cepesti",
            "Cerbeni",
            "Cezieni",
            "Chelbesti",
            "Cherlestii Mosteni",
            "Cherlestii din Deal",
            "Chilia",
            "Chilii",
            "Chintesti",
            "Chiteasca",
            "Cilieni",
            "Ciocanesti",
            "Cioflanu",
            "Cioroiasu",
            "Cioroiu",
            "Cioraca",
            "Ciuresti",
            "Cocorasti",
            "Cojgarei",
            "Colibasi",
            "Colonesti",
            "Comanca",
            "Comani",
            "Comanesti",
            "Comanita",
            "Constantinesti",
            "Corabia",
            "Corbu",
            "Corbu",
            "Corlatesti",
            "Cornatelu",
            "Coteana",
            "Coteni",
            "Cotorbesti",
            "Creti",
            "Criva de Jos",
            "Criva de Sus",
            "Crusovu",
            "Crampoia",
            "Craciunei",
            "Cucueti",
            "Cungrea",
            "Curtisoara",
            "Curtisoara",
            "Cuza Voda",
            "Campu Mare",
            "Campu Parului",
            "Candelesti",
            "Carlogani",
            "Carstani",
            "Calinesti",
            "Calui",
            "Cazanesti",
            "Davidesti",
            "Dejesti",
            "Deleni",
            "Deveselu",
            "Dienci",
            "Doanca",
            "Doba",
            "Dobretu",
            "Dobriceni",
            "Dobrosloveni",
            "Dobroteasa",
            "Dobrotinet",
            "Dobrun",
            "Donesti",
            "Dranovatu",
            "Draghiceni",
            "Draganesti-Olt",
            "Dumitresti",
            "Damburile",
            "Daneasa",
            "Enosesti",
            "Floru",
            "Frunzaru",
            "Frasinet-Gara",
            "Frasinetu",
            "Fagetelu",
            "Falcoiu",
            "Farcasele",
            "Farcasu de Jos",
            "Ghimpati",
            "Ghimpeteni",
            "Ghimpetenii Noi",
            "Ghiosani",
            "Giuvarasti",
            "Gostavatu",
            "Govora",
            "Greci",
            "Greci",
            "Greeresti",
            "Grojdibodu",
            "Gropsani",
            "Grozavesti",
            "Gruiu",
            "Gradinari",
            "Gradinile",
            "Gradistea",
            "Gubandru",
            "Guesti",
            "Gura Caluiu",
            "Gura Padinii",
            "Garcov",
            "Ganeasa",
            "Gavanesti",
            "Horezu",
            "Hotaru",
            "Hotarani",
            "Ianca",
            "Ianca Noua",
            "Iancu Jianu",
            "Ibanesti",
            "Icoana",
            "Ionicesti",
            "Ipotesti",
            "Isaci",
            "Izbiceni",
            "Izvoarele",
            "Izvoru",
            "Jieni",
            "Jitaru",
            "Leleasca",
            "Leotesti",
            "Liiceni",
            "Linia din Vale",
            "Lisa",
            "Lunca",
            "Launele",
            "Lazaresti",
            "Malu Rosu",
            "Mamura",
            "Mandra",
            "Mardale",
            "Mereni",
            "Mierlestii de Sus",
            "Mierlicesti",
            "Miesti",
            "Mihaesti",
            "Mihailesti-Popesti",
            "Milcoveni",
            "Milcovu din Deal",
            "Milcovu din Vale",
            "Mircesti",
            "Mirila",
            "Mogosesti",
            "Momaiu",
            "Morunesti",
            "Morunglav",
            "Movileni",
            "Mosteni",
            "Motoesti",
            "Magura",
            "Magura",
            "Manulesti",
            "Margheni",
            "Margineni-Slobozia",
            "Margaritesti",
            "Maruntei",
            "Maruntei",
            "Negreni",
            "Nicolae Titulescu",
            "Navargeni",
            "Oboga",
            "Obarsia",
            "Obarsia Noua",
            "Ociogi",
            "Olari",
            "Oltisoru",
            "Oporelu",
            "Optasi",
            "Optasani",
            "Orlea",
            "Orlea Noua",
            "Osica de Jos",
            "Osica de Sus",
            "Ostrov",
            "Otestii de Jos",
            "Otestii de Sus",
            "Peretu",
            "Perieti",
            "Pescaresti",
            "Pestra",
            "Petculesti",
            "Piatra",
            "Piatra-Olt",
            "Pielcani",
            "Pietris",
            "Pietrisu",
            "Piscani",
            "Plesoiu",
            "Plopsorelu",
            "Plaviceanca",
            "Plaviceni",
            "Poboru",
            "Poganu",
            "Poiana",
            "Poiana Mare",
            "Popesti",
            "Popesti",
            "Potcoava",
            "Potcoava-Falcoeni",
            "Potelu",
            "Potlogeni",
            "Potopinu",
            "Preotesti",
            "Prisaca",
            "Priseaca",
            "Proaspeti",
            "Profa",
            "Parscoveni",
            "Racovita",
            "Radomiresti",
            "Raitiu",
            "Recea",
            "Redea",
            "Redisoara",
            "Resca",
            "Rescuta",
            "Rotunda",
            "Rosienii Mari",
            "Rosienii Mici",
            "Rudari",
            "Runcu Mare",
            "Rusciori",
            "Rusanesti",
            "Rusanestii de Sus",
            "Radesti",
            "Salcia",
            "Satu Nou",
            "Satu Nou",
            "Schitu",
            "Schitu Deleni",
            "Schitu din Deal",
            "Schitu din Vale",
            "Scorbura",
            "Scornicesti",
            "Scarisoara",
            "Seaca",
            "Seaca",
            "Simniceni",
            "Sinesti",
            "Slatina",
            "Slatioara",
            "Slaveni",
            "Spineni",
            "Sprancenata",
            "Spataru",
            "Stejaru",
            "Stoborasti",
            "Stoenesti",
            "Stoicanesti",
            "Strejesti",
            "Strejestii de Sus",
            "Strugurelu",
            "Studina",
            "Studinita",
            "Stupina",
            "Stanuleasa",
            "Stanuleasa",
            "Stavaru",
            "Surpeni",
            "Samburesti",
            "Saltanesti",
            "Tabaci",
            "Tabonu",
            "Teius",
            "Teiusu",
            "Teis",
            "Teslui",
            "Tia Mare",
            "Tirisneag",
            "Tomeni",
            "Tonesti",
            "Tonesti",
            "Topana",
            "Traian",
            "Trepteni",
            "Trufinesti",
            "Tufaru",
            "Tufeni",
            "Turia",
            "Tatulesti",
            "Ulmet",
            "Ulmi",
            "Ungureni",
            "Uria",
            "Ursa",
            "Ursoaia",
            "Urzica",
            "Ursi",
            "Valea Fetei",
            "Valea Mare",
            "Valea Merilor",
            "Valea Satului",
            "Valea Soarelui",
            "Valea lui Alb",
            "Verguleasa",
            "Vineti",
            "Vitomiresti",
            "Vitanesti",
            "Visina",
            "Visina Noua",
            "Vlaici",
            "Vladila",
            "Vladila Noua",
            "Vladuleni",
            "Vlangaresti",
            "Voineasa",
            "Vulpeni",
            "Vulpesti",
            "Vulturesti",
            "Valcele",
            "Valcelele de Sus",
            "Vanesti",
            "Vartopu",
            "Vadastra",
            "Vadastrita",
            "Valeni",
            "Valeni",
            "Zorleasca",
            "Zanoaga",
            "Serbanesti",
            "Serbanestii de Sus",
            "Soparlita",
            "Stefan cel Mare",
            "Suica"
          ]
        },
        {
          name: "Prahova",
          cities: [
            "Adunati",
            "Albesti-Muru",
            "Albesti-Paleologu",
            "Albinari",
            "Alunis",
            "Antofiloaia",
            "Apostolache",
            "Aricestii Rahtivani",
            "Aricestii Zeletin",
            "Arva",
            "Azuga",
            "Baba Ana",
            "Balta Doamnei",
            "Belciug",
            "Berceni",
            "Bertea",
            "Bighilin",
            "Blejoi",
            "Bobicesti",
            "Boboci",
            "Bobolia",
            "Bodesti",
            "Bogdanesti",
            "Boldesti",
            "Boldesti-Scaeni",
            "Bordenii Mari",
            "Bordenii Mici",
            "Bozieni",
            "Bosilcesti",
            "Brazii de Jos",
            "Brazii de Sus",
            "Breaza",
            "Brebu Megiesesc",
            "Brebu Manastirei",
            "Bradet",
            "Bratesti",
            "Bratasanca",
            "Buchilasi",
            "Bucov",
            "Buda",
            "Buda",
            "Bughea de Jos",
            "Bughea de Sus",
            "Butuci",
            "Buzota",
            "Bustenari",
            "Busteni",
            "Bara",
            "Baicoi",
            "Baltita",
            "Baltesti",
            "Banesti",
            "Barcanesti",
            "Barzila",
            "Baraitaru",
            "Batesti",
            "Batrani",
            "Cap Rosu",
            "Cartierul Dambu",
            "Ceptura de Jos",
            "Ceptura de Sus",
            "Cerasu",
            "Cernesti",
            "Cheia",
            "Chesnoiu",
            "Chiciureni",
            "Chiojdeanca",
            "Chiritesti",
            "Chitorani",
            "Cioceni",
            "Ciocrac",
            "Cioranii de Jos",
            "Cioranii de Sus",
            "Ciresanu",
            "Ciupelnita",
            "Coada Izvorului",
            "Coada Malului",
            "Coceana",
            "Cocorastii Caplii",
            "Cocorastii Colt",
            "Cocorastii Grind",
            "Cocorastii Mislii",
            "Cocosesti",
            "Colceag",
            "Coltu de Jos",
            "Comarnic",
            "Conduratu",
            "Corlatesti",
            "Cornu de Jos",
            "Cornu de Jos",
            "Cornu de Sus",
            "Cornu de Sus",
            "Coslegi",
            "Cosmina de Jos",
            "Cosmina de Sus",
            "Costeni",
            "Coserele",
            "Cotofenesti",
            "Crivina",
            "Crangurile",
            "Cuib",
            "Curcubeu",
            "Curmatura",
            "Campina",
            "Carjari",
            "Calinesti",
            "Calugareni",
            "Carbunari",
            "Carbunesti",
            "Catina",
            "Catunu",
            "Catunu",
            "Ditesti",
            "Dobrota",
            "Doftana",
            "Drajna de Jos",
            "Drajna de Sus",
            "Draghicesti",
            "Draganeasa",
            "Draganesti",
            "Dumbrava",
            "Dumbravesti",
            "Darvari",
            "Ezeni",
            "Filipestii de Padure",
            "Filipestii de Targ",
            "Floresti",
            "Fulga de Jos",
            "Fulga de Sus",
            "Fundeni",
            "Fanari",
            "Fanari",
            "Fantanele",
            "Facaieni",
            "Faget",
            "Fagetu",
            "Gheaba",
            "Gherghita",
            "Ghighiu",
            "Ghinoaica",
            "Ghiocel",
            "Ghioldum",
            "Glod",
            "Goga",
            "Gogeasca",
            "Gorgota",
            "Gornet",
            "Gornet-Cricov",
            "Goruna",
            "Gradistea",
            "Gresia",
            "Gura Crivatului",
            "Gura Vadului",
            "Gura Vitioarei",
            "Galmeia",
            "Gageni",
            "Gavanel",
            "Homoraciu",
            "Harsa",
            "Habud",
            "Hatcarau",
            "Iazu",
            "Independenta",
            "Inotesti",
            "Iordacheanu",
            "Izesti",
            "Izvoarele",
            "Izvoru",
            "Jugureni",
            "Lacu Turcului",
            "Lapos",
            "Lipanesti",
            "Livadea",
            "Loloiasca",
            "Lopatnita",
            "Lunca Mare",
            "Lunca Prahovei",
            "Lutu Rosu",
            "Laposel",
            "Malamuc",
            "Malu Rosu",
            "Malu Vanat",
            "Marginea Padurii",
            "Matita",
            "Mehedinta",
            "Melicesti",
            "Merdeala",
            "Meri",
            "Minieri",
            "Miresu Mare",
            "Miresu Mic",
            "Miroslavesti",
            "Mislea",
            "Mizil",
            "Moara",
            "Moara Domneasca",
            "Moara Noua",
            "Mocesti",
            "Manastirea Suzana",
            "Marlogea",
            "Magula",
            "Magura",
            "Magurele",
            "Magureni",
            "Malaestii de Jos",
            "Malaestii de Sus",
            "Malaiesti",
            "Maneciu-Pamanteni",
            "Maneciu-Ungureni",
            "Manesti",
            "Marginenii de Jos",
            "Nedelea",
            "Negoiesti",
            "Nevesteasca",
            "Nisipoasa",
            "Novacesti",
            "Nucet",
            "Nucet",
            "Nucsoara de Jos",
            "Nucsoara de Sus",
            "Ocina de Jos",
            "Ocina de Sus",
            "Odaile",
            "Ogretin",
            "Olari",
            "Olarii Vechi",
            "Ologeni",
            "Olteni",
            "Ostrovu",
            "Palanca",
            "Pantazi",
            "Parepa-Rusani",
            "Persunari",
            "Persunari",
            "Piatra",
            "Piatra",
            "Piatra",
            "Piatra Mica",
            "Pietriceaua",
            "Pietricica",
            "Pietrisu",
            "Pietrosani",
            "Pioresti",
            "Pisculesti",
            "Pitigoi",
            "Plai",
            "Plaiu",
            "Plaiu",
            "Plaiu Cornului",
            "Plaiu Campinei",
            "Plavia",
            "Pleasa",
            "Ploiesti",
            "Ploiestiori",
            "Plopeni",
            "Plopeni",
            "Plopu",
            "Plaietu",
            "Podenii Noi",
            "Podenii Vechi",
            "Podgoria",
            "Podu Cheii",
            "Podu Ursului",
            "Podu Valeni",
            "Podu lui Galben",
            "Podurile",
            "Poiana Copaceni",
            "Poiana Campina",
            "Poiana Mare",
            "Poiana Mierlei",
            "Poiana Trestiei",
            "Poiana Varbilau",
            "Poienarii Apostoli",
            "Poienarii Burchii",
            "Poienarii Vechi",
            "Poienarii-Rali",
            "Poienile",
            "Popesti",
            "Popesti",
            "Posestii-Pamanteni",
            "Posestii-Ungureni",
            "Potigrafu",
            "Predeal",
            "Predesti",
            "Priseaca",
            "Provita de Jos",
            "Provita de Sus",
            "Puchenii Mari",
            "Puchenii Mici",
            "Puchenii-Mosneni",
            "Puscasi",
            "Pacureti",
            "Pacuri",
            "Paulesti",
            "Paulestii Noi",
            "Rachieri",
            "Radila",
            "Rahova",
            "Romanesti",
            "Rotarea",
            "Rotari",
            "Rafov",
            "Ragman",
            "Salcia",
            "Satu Nou",
            "Satu Nou",
            "Satu de Sus",
            "Schiau",
            "Schiulesti",
            "Scorteni",
            "Scurtesti",
            "Seciuri",
            "Secaria",
            "Sfarleanca",
            "Sfacaru",
            "Sicrita",
            "Silistea",
            "Silistea Dealului",
            "Sinaia",
            "Slavu",
            "Slon",
            "Slanic",
            "Starchiojd",
            "Stejaru",
            "Stoenesti",
            "Strejnicu",
            "Straosti",
            "Stancesti",
            "Surani",
            "Sangeru",
            "Sarca",
            "Salciile",
            "Salcioara",
            "Sarari",
            "Saratel",
            "Satucu",
            "Talea",
            "Teisani",
            "Telega",
            "Tesila",
            "Tinosu",
            "Tisa",
            "Tohani",
            "Tomsani",
            "Trenu",
            "Trestienii de Jos",
            "Trestienii de Sus",
            "Trestioara",
            "Traisteni",
            "Tufani",
            "Tulburea",
            "Tulburea-Valeni",
            "Targsoru Nou",
            "Targsoru Vechi",
            "Tarlesti",
            "Tarsoreni",
            "Tariceni",
            "Tataru",
            "Tatarani",
            "Tatarai",
            "Udresti",
            "Ungureni",
            "Ungureni",
            "Ungureni",
            "Urlati",
            "Urleta",
            "Vadu Parului",
            "Vadu Sapat",
            "Valea Anei",
            "Valea Borului",
            "Valea Bradului",
            "Valea Bradetului",
            "Valea Cricovului",
            "Valea Cucului",
            "Valea Calugareasca",
            "Valea Dulce",
            "Valea Larga",
            "Valea Lespezii",
            "Valea Mantei",
            "Valea Nicovani",
            "Valea Oprii",
            "Valea Orlei",
            "Valea Plopului",
            "Valea Poienii",
            "Valea Popii",
            "Valea Scheilor",
            "Valea Screzii",
            "Valea Seaca",
            "Valea Stupinii",
            "Valea Stalpului",
            "Valea Tocii",
            "Valea Unghiului",
            "Valea Ursoii",
            "Varnita",
            "Vistieru",
            "Vitioara de Sus",
            "Valcelele",
            "Valcanesti",
            "Varfurile",
            "Valenii de Munte",
            "Varbila",
            "Varbilau",
            "Zahanaua",
            "Zalhanaua",
            "Zamfira",
            "Zmeuret",
            "Zambroaia",
            "Zanoaga",
            "Sipotu",
            "Sirna",
            "Soimari",
            "Soimesti",
            "Sotrile",
            "Stefesti",
            "Stubeiu",
            "Tiparesti",
            "Tontesti",
            "Tantareni",
            "Tarculesti"
          ]
        },
        {
          name: "Satu Mare",
          cities: [
            "Aciua",
            "Acas",
            "Ady Endre",
            "Agris",
            "Aliceni",
            "Aliza",
            "Amati",
            "Ambud",
            "Andrid",
            "Apa",
            "Apateu",
            "Ardud",
            "Ardud-Vii",
            "Atea",
            "Baba Novac",
            "Babta",
            "Becheni",
            "Beltiug",
            "Bercu",
            "Bercu Nou",
            "Berea",
            "Berindan",
            "Berveni",
            "Bicau",
            "Bixad",
            "Blaja",
            "Bocicau",
            "Bogdand",
            "Boghis",
            "Boinesti",
            "Bolda",
            "Borlesti",
            "Botiz",
            "Barsau de Jos",
            "Barsau de Sus",
            "Babesti",
            "Babasesti",
            "Batarci",
            "Carei",
            "Cean",
            "Cehal",
            "Cehalut",
            "Certeze",
            "Chegea",
            "Chereusa",
            "Chilia",
            "Chisau",
            "Cidreag",
            "Cig",
            "Cionchesti",
            "Ciumesti",
            "Ciuperceni",
            "Coca",
            "Comlausa",
            "Corod",
            "Corund",
            "Craidorolt",
            "Criseni",
            "Crucisor",
            "Cucu",
            "Culciu Mare",
            "Culciu Mic",
            "Cuta",
            "Calinesti-Oas",
            "Camin",
            "Camarzana",
            "Capleni",
            "Caraseu",
            "Cauas",
            "Dacia",
            "Dara",
            "Decebal",
            "Dindesti",
            "Dindestiu Mic",
            "Doba",
            "Dobolt",
            "Dobra",
            "Domanesti",
            "Dorolt",
            "Draguseni",
            "Eriu-Sancrai",
            "Eteni",
            "Foieni",
            "Ganas",
            "Gelu",
            "Gerausa",
            "Ghenci",
            "Gherta Mare",
            "Gherta Mica",
            "Ghilesti",
            "Ghilvaci",
            "Ghirisa",
            "Ghirolt",
            "Giorocuta",
            "Giungi",
            "Giurtelecu Hododului",
            "Halmeu",
            "Halmeu-Vii",
            "Hodisa",
            "Hodod",
            "Homorodu de Jos",
            "Homorodu de Mijloc",
            "Homorodu de Sus",
            "Horea",
            "Hotoan",
            "Hrip",
            "Hurezu Mare",
            "Huta-Certeze",
            "Iegheriste",
            "Iojib",
            "Irina",
            "Istrau",
            "Lazuri",
            "Lechinta",
            "Lelei",
            "Lipau",
            "Livada",
            "Lucaceni",
            "Lunca Apei",
            "Marna Noua",
            "Medies-Raturi",
            "Medies-Vii",
            "Mediesu Aurit",
            "Medisa",
            "Mesteacan",
            "Micula",
            "Micula Noua",
            "Mihaieni",
            "Moftinu Mare",
            "Moftinu Mic",
            "Moiseni",
            "Marius",
            "Martinesti",
            "Nadisu Hododului",
            "Necopoi",
            "Negresti-Oas",
            "Nisipeni",
            "Noroieni",
            "Oar",
            "Odoreu",
            "Orasu Nou",
            "Orasu Nou-Vii",
            "Orbau",
            "Paulian",
            "Peles",
            "Pelisor",
            "Petea",
            "Petin",
            "Petresti",
            "Pir",
            "Piru Nou",
            "Piscari",
            "Piscolt",
            "Poiana Codrului",
            "Pomi",
            "Portita",
            "Porumbesti",
            "Potau",
            "Prilog",
            "Prilog-Vii",
            "Paulesti",
            "Pasunea Mare",
            "Racova",
            "Racsa",
            "Racsa-Vii",
            "Ratiu",
            "Remetea Oasului",
            "Resighea",
            "Romanesti",
            "Rosiori",
            "Ruseni",
            "Radulesti",
            "Ratesti",
            "Sanislau",
            "Santau",
            "Satu Mare",
            "Satu Mic",
            "Scarisoara Noua",
            "Secheresa",
            "Ser",
            "Silvas",
            "Socond",
            "Soconzel",
            "Solduba",
            "Someseni",
            "Stana",
            "Sudurau",
            "Supuru de Jos",
            "Supuru de Sus",
            "Sai",
            "Sanmiclaus",
            "Sacaseni",
            "Sarvazel",
            "Saratura",
            "Sarauad",
            "Sauca",
            "Tarna Mare",
            "Terebesti",
            "Tireac",
            "Tiream",
            "Traian",
            "Trip",
            "Turulung",
            "Turulung-Vii",
            "Turt",
            "Turt-Bai",
            "Tarsolt",
            "Tamaseni",
            "Tataresti",
            "Tasnad",
            "Unimat",
            "Urziceni",
            "Urziceni-Padure",
            "Valea Morii",
            "Valea Seaca",
            "Valea Vinului",
            "Vama",
            "Vetis",
            "Vezendiu",
            "Viile Satu Mare",
            "Viisoara",
            "Vanatoresti",
            "Vagas",
            "Sandra",
            "Sirlau",
            "Teghea"
          ]
        },
        {
          name: "Salaj",
          cities: [
            "Adalin",
            "Aghires",
            "Agrij",
            "Aleus",
            "Almasu",
            "Alunis",
            "Archid",
            "Badon",
            "Baica",
            "Ban",
            "Benesat",
            "Bercea",
            "Bezded",
            "Bilghez",
            "Biusa",
            "Bizusa-Bai",
            "Bobota",
            "Bocsa",
            "Bocsita",
            "Bodia",
            "Bogdana",
            "Boghis",
            "Borla",
            "Borza",
            "Bozies",
            "Bozna",
            "Brebi",
            "Brusturi",
            "Braglez",
            "Buciumi",
            "Bulgari",
            "Buzas",
            "Barsa",
            "Barsau Mare",
            "Barsauta",
            "Babeni",
            "Babiu",
            "Badacin",
            "Balan",
            "Banisor",
            "Camar",
            "Carastelec",
            "Ceaca",
            "Cehu Silvaniei",
            "Cerisa",
            "Cernuc",
            "Chechis",
            "Chendrea",
            "Chendremal",
            "Cheud",
            "Chichisa",
            "Chiesd",
            "Chilioara",
            "Chizeni",
            "Ciglean",
            "Ciocmani",
            "Ciula",
            "Ciumarna",
            "Ciureni",
            "Cizer",
            "Clit",
            "Colonia Sighetu Silvaniei",
            "Cormenis",
            "Cosniciu de Jos",
            "Cosniciu de Sus",
            "Cozla",
            "Coseiu",
            "Crasna",
            "Creaca",
            "Cristolt",
            "Cristoltel",
            "Cristur-Criseni",
            "Criseni",
            "Cristelec",
            "Cublesu",
            "Cuceu",
            "Cuciulat",
            "Cutis",
            "Cuzaplac",
            "Campia",
            "Calacea",
            "Capalna",
            "Deja",
            "Deleni",
            "Dersida",
            "Diosod",
            "Doba",
            "Dobrin",
            "Dobrocina",
            "Doh",
            "Dolheni",
            "Dolu",
            "Domnin",
            "Dragu",
            "Drighiu",
            "Dumuslau",
            "Dabaceni",
            "Fabrica",
            "Fetindia",
            "Fildu de Jos",
            "Fildu de Mijloc",
            "Fildu de Sus",
            "Firminis",
            "Fizes",
            "Fodora",
            "Francenii de Piatra",
            "Fufez",
            "Fantanele",
            "Fantanele-Rus",
            "Fagetu",
            "Falcusa",
            "Giurtelecu Simleului",
            "Glod",
            "Gostila",
            "Gura Vladesei",
            "Guruslau",
            "Galgau",
            "Galgau Almasului",
            "Garbou",
            "Garceiu",
            "Galpaia",
            "Galaseni",
            "Halmasd",
            "Hereclean",
            "Hida",
            "Horoatu Cehului",
            "Horoatu Crasnei",
            "Hurez",
            "Huseni",
            "Husia",
            "Huta",
            "Hasmas",
            "Iaz",
            "Ileanda",
            "Ilisua",
            "Inau",
            "Ip",
            "Jac",
            "Jebucu",
            "Jibou",
            "Lazuri",
            "Lemniu",
            "Letca",
            "Lesmir",
            "Lompirt",
            "Lozna",
            "Luminisu",
            "Lupoaia",
            "Mal",
            "Marca",
            "Marca-Huta",
            "Marin",
            "Mesesenii de Jos",
            "Mesesenii de Sus",
            "Mesteacanu",
            "Mierta",
            "Miluani",
            "Mineu",
            "Mirsid",
            "Moiad",
            "Moigrad-Porolissum",
            "Motis",
            "Muncel",
            "Maeriste",
            "Magura",
            "Maleni",
            "Maladia",
            "Nadis",
            "Naimon",
            "Negreni",
            "Notig",
            "Nusfalau",
            "Napradea",
            "Panic",
            "Peceiu",
            "Pericei",
            "Periceiu Mic",
            "Perii Vadului",
            "Petrindu",
            "Petrinzel",
            "Pirosa",
            "Plesca",
            "Plopis",
            "Poarta Salajului",
            "Podisu",
            "Poiana Blenchii",
            "Poiana Magura",
            "Poiana Ontii",
            "Poienita",
            "Popeni",
            "Popteleac",
            "Port",
            "Preluci",
            "Preoteasa",
            "Pria",
            "Prodanesti",
            "Purcaret",
            "Padureni",
            "Paduris",
            "Pausa",
            "Racas",
            "Ratin",
            "Ratovei",
            "Recea",
            "Recea Mica",
            "Rogna",
            "Romita",
            "Romanasi",
            "Rona",
            "Ruginoasa",
            "Rus",
            "Rastoci",
            "Rastolt",
            "Rastoltu Desert",
            "Sfaras",
            "Sici",
            "Sighetu Silvaniei",
            "Solomon",
            "Solona",
            "Somes-Guruslau",
            "Somes-Odorhei",
            "Stana",
            "Stoboru",
            "Stupini",
            "Starciu",
            "Sub Cetate",
            "Surduc",
            "Sutoru",
            "Sag",
            "Sancraiu Almasului",
            "Sancraiu Silvaniei",
            "Sangeorgiu de Meses",
            "Sanmihaiu Almasului",
            "Sanpetru Almasului",
            "Santa Maria",
            "Sarbi",
            "Salajeni",
            "Salatig",
            "Sarmasag",
            "Tetisu",
            "Testioara",
            "Tihau",
            "Toplita",
            "Tranis",
            "Trestia",
            "Treznea",
            "Turbuta",
            "Tusa",
            "Tamasa",
            "Ugrutiu",
            "Uileacu Simleului",
            "Ulciug",
            "Valcau de Jos",
            "Valcau de Sus",
            "Valea Ciurenilor",
            "Valea Hranei",
            "Valea Lesului",
            "Valea Loznei",
            "Valea Lunga",
            "Valea Pomilor",
            "Var",
            "Verveghiu",
            "Viile Jacului",
            "Voivodeni",
            "Vartesca",
            "Varsolt",
            "Vadurele",
            "Valeni",
            "Valisoara",
            "Zalha",
            "Zalnoc",
            "Zalau",
            "Zimbor",
            "Zauan",
            "Zauan-Bai",
            "Samsud",
            "Sasa",
            "Seredeiu",
            "Simisna",
            "Simleu Silvaniei",
            "Soimus",
            "Soimuseni",
            "Sumal",
            "Tarmure",
            "Taudu"
          ]
        },
        {
          name: "Sibiu",
          cities: [
            "Agnita",
            "Agarbiciu",
            "Albi",
            "Alma",
            "Alma Vii",
            "Alamor",
            "Altina",
            "Apoldu de Jos",
            "Apoldu de Sus",
            "Apos",
            "Armeni",
            "Arpasu de Jos",
            "Arpasu de Sus",
            "Avrig",
            "Axente Sever",
            "Atel",
            "Bazna",
            "Benesti",
            "Biertan",
            "Blajel",
            "Boarta",
            "Bogatu Roman",
            "Boian",
            "Boita",
            "Bradu",
            "Brateiu",
            "Brosteni",
            "Bruiu",
            "Bradeni",
            "Buia",
            "Bungard",
            "Buzd",
            "Barghis",
            "Casolt",
            "Chesler",
            "Chirpar",
            "Cisnadie",
            "Colonia Tarnava",
            "Colonia Talmaciu",
            "Colun",
            "Copsa Mare",
            "Copsa Mica",
            "Cornatel",
            "Cristian",
            "Curciu",
            "Carta",
            "Cartisoara",
            "Daia",
            "Dealu Frumos",
            "Dobarca",
            "Dumbraveni",
            "Dupus",
            "Darlos",
            "Floresti",
            "Fofeldea",
            "Gherdeal",
            "Ghijasa de Jos",
            "Ghijasa de Sus",
            "Giacas",
            "Glamboaca",
            "Gura Raului",
            "Gusu",
            "Hamba",
            "Hasag",
            "Hoghilag",
            "Hosman",
            "Iacobeni",
            "Ighisu Nou",
            "Ighisu Vechi",
            "Ilimbav",
            "Jina",
            "Laslea",
            "Lazaret",
            "Loamnes",
            "Lotrioara",
            "Ludos",
            "Marpod",
            "Medias",
            "Merghindeal",
            "Metis",
            "Micasasa",
            "Miercurea Sibiului",
            "Mighindoala",
            "Mihaileni",
            "Moardas",
            "Mohu",
            "Motis",
            "Movile",
            "Mosna",
            "Mandra",
            "Marsa",
            "Malancrav",
            "Nemsa",
            "Netus",
            "Nocrich",
            "Noistat",
            "Nou",
            "Nou Roman",
            "Nou Sasesc",
            "Nucet",
            "Ocna Sibiului",
            "Orlat",
            "Paltin",
            "Pelisor",
            "Petis",
            "Poiana Sibiului",
            "Poienita",
            "Poplaca",
            "Porumbacu de Jos",
            "Porumbacu de Sus",
            "Presaca",
            "Prislop",
            "Prod",
            "Padureni",
            "Pauca",
            "Paucea",
            "Racovita",
            "Retis",
            "Richis",
            "Roandola",
            "Rod",
            "Romanesti",
            "Rosia",
            "Rusciori",
            "Rusi",
            "Rau Sadului",
            "Ravasel",
            "Rasinari",
            "Sadu",
            "Scoreiu",
            "Sebesu de Jos",
            "Sebesu de Sus",
            "Slimnic",
            "Sorostin",
            "Stejarisu",
            "Sangatin",
            "Sacadate",
            "Sadinca",
            "Saliste",
            "Sarata",
            "Sasaus",
            "Tilisca",
            "Toparcea",
            "Turnu Rosu",
            "Tarnava",
            "Talmaciu",
            "Talmacel",
            "Valchid",
            "Valea Lunga",
            "Valea Viilor",
            "Vecerd",
            "Velt",
            "Veseud",
            "Veseud",
            "Vestem",
            "Vurpar",
            "Valeni",
            "Vard",
            "Zlagna",
            "Salcau",
            "Seica Mare",
            "Seica Mica",
            "Selimbar",
            "Smig",
            "Soala",
            "Somartin",
            "Stenea",
            "Sura Mare",
            "Sura Mica",
            "Tapu",
            "Teline",
            "Tichindeal"
          ]
        },
        {
          name: "Suceava",
          cities: [
            "Adancata",
            "Antoceni",
            "Arbore",
            "Argel",
            "Argestru",
            "Arghira",
            "Artari",
            "Badragi",
            "Bahna Arin",
            "Baia",
            "Bainet",
            "Basarabi",
            "Benia",
            "Berchisesti",
            "Beresti",
            "Bilca",
            "Bivolarie",
            "Bobeica",
            "Bodnareni",
            "Bogata",
            "Bogdanesti",
            "Boroaia",
            "Bosanci",
            "Botesti",
            "Botos",
            "Botosana",
            "Botosanita Mare",
            "Botosanita Mica",
            "Botus",
            "Botusel",
            "Boura",
            "Branistea",
            "Brasca",
            "Breaza",
            "Breaza de Sus",
            "Brodina",
            "Brodina",
            "Brodina de Jos",
            "Brosteni",
            "Brosteni",
            "Bradatel",
            "Braiesti",
            "Bucsoaia",
            "Buda",
            "Buda",
            "Budeni",
            "Bulai",
            "Bunesti",
            "Burla",
            "Bursuceni",
            "Badeuti",
            "Baisesti",
            "Balcauti",
            "Balinesti",
            "Balaceana",
            "Bancesti",
            "Banesti",
            "Barasti",
            "Cacica",
            "Cajvana",
            "Calafindesti",
            "Capu Codrului",
            "Capu Campului",
            "Catrinari",
            "Chiliseni",
            "Chiril",
            "Ciocanesti",
            "Ciomartan",
            "Ciprian Porumbescu",
            "Ciumulesti",
            "Ciumarna",
            "Climauti",
            "Clit",
            "Codru",
            "Cojoci",
            "Cojocareni",
            "Colacu",
            "Comanesti",
            "Corlata",
            "Corni",
            "Cornu Luncii",
            "Corocaiesti",
            "Corpaci",
            "Costileva",
            "Costisa",
            "Costana",
            "Cotu Baii",
            "Cotu Dobei",
            "Cotargasi",
            "Coverca",
            "Cozanesti",
            "Cosna",
            "Crucea",
            "Cumparatura",
            "Cununschi",
            "Campulung Moldovenesc",
            "Carlibaba",
            "Carlibaba Noua",
            "Calinesti",
            "Calinesti",
            "Calinesti-Vasilache",
            "Calugareni",
            "Camarzani",
            "Casoi",
            "Dealu",
            "Dealu Floreni",
            "Deia",
            "Deleni",
            "Delnita",
            "Delut",
            "Demacusa",
            "Dolhasca",
            "Dolhestii Mari",
            "Dolhestii Mici",
            "Dorna Candrenilor",
            "Dorna-Arini",
            "Dornesti",
            "Dornisoara",
            "Doroteia",
            "Dragomirna",
            "Dragosa",
            "Dragoiasa",
            "Dragoiesti",
            "Draguseni",
            "Dubiusca",
            "Dumbrava",
            "Dumbrava",
            "Dumbraveni",
            "Dumbraveni",
            "Dumbravita",
            "Darmoxa",
            "Danila",
            "Darmanesti",
            "Ehreste",
            "Falcau",
            "Fetesti",
            "Florinta",
            "Forasti",
            "Frasin",
            "Frasin",
            "Frumoasa",
            "Frumosu",
            "Fratautii Noi",
            "Fratautii Vechi",
            "Fundu Moldovei",
            "Fantana Mare",
            "Fantanele",
            "Falticeni",
            "Gara",
            "Gara Leu",
            "Gemenea",
            "Gheorghiteni",
            "Giulesti",
            "Giurgesti",
            "Glodu",
            "Grigoresti",
            "Groapa Vladichii",
            "Gropeni",
            "Gramesti",
            "Granicesti",
            "Gulia",
            "Gura Haitii",
            "Gura Humorului",
            "Gura Putnei",
            "Gura Solcii",
            "Gainesti",
            "Galanesti",
            "Hancea",
            "Herla",
            "Holda",
            "Holdita",
            "Horodnic de Jos",
            "Horodnic de Sus",
            "Horodniceni",
            "Hreatca",
            "Humoreni",
            "Hurjuieni",
            "Husi",
            "Hartop",
            "Haleasa",
            "Hantesti",
            "Iacobeni",
            "Iacobesti",
            "Iaslovat",
            "Iaz",
            "Iedu",
            "Iesle",
            "Ilisesti",
            "Ioneasa",
            "Ipotesti",
            "Izvoarele Sucevei",
            "Jacota",
            "Jahalia",
            "Leucusesti",
            "Lipoveni",
            "Lisaura",
            "Liteni",
            "Liteni",
            "Lucacesti",
            "Lunca",
            "Lunca",
            "Luncusoara",
            "Lungeni",
            "Lupcina",
            "Lamaseni",
            "Maidan",
            "Manolea",
            "Marginea",
            "Mereni",
            "Meresti",
            "Mesteceni",
            "Mestecanis",
            "Mihoveni",
            "Mihaiesti",
            "Milisauti",
            "Mironu",
            "Mitocasi",
            "Mitocu Dragomirnei",
            "Moara Carp",
            "Moara Nica",
            "Moisa",
            "Moldova-Sulita",
            "Moldovita",
            "Molid",
            "Movileni",
            "Musenita",
            "Magura",
            "Malini",
            "Maneuti",
            "Manastioara",
            "Manastioara",
            "Manastirea Humorului",
            "Maritei",
            "Mariteia Mica",
            "Mazanaesti",
            "Neagra",
            "Neagra Sarului",
            "Negostina",
            "Negrileasa",
            "Nicani",
            "Nigotesti",
            "Nisipitu",
            "Norocu",
            "Obcina",
            "Oniceni",
            "Ortoaia",
            "Osoi",
            "Ostra",
            "Paltin",
            "Paltinu",
            "Panaci",
            "Petia",
            "Pietroasa",
            "Pilugani",
            "Plai",
            "Plaiu Sarului",
            "Plesa",
            "Plesesti",
            "Plopeni",
            "Plutonita",
            "Plavalari",
            "Pocoleni",
            "Podeni",
            "Podu Cosnei",
            "Poiana",
            "Poiana",
            "Poiana Micului",
            "Poiana Marului",
            "Poiana Negrii",
            "Poiana Stampei",
            "Poienari",
            "Poieni-Solca",
            "Poieni-Suceava",
            "Pojorata",
            "Praxia",
            "Prelipca",
            "Preutesti",
            "Prisaca Dornei",
            "Probota",
            "Praleni",
            "Putna",
            "Paraie",
            "Partestii de Jos",
            "Partestii de Sus",
            "Parau Negrei",
            "Padureni",
            "Paiseni",
            "Paltinis",
            "Paltinoasa",
            "Parhauti",
            "Patrauti",
            "Racova",
            "Rasca",
            "Reuseni",
            "Romanesti",
            "Romanesti",
            "Rotopanesti",
            "Rotunda",
            "Roscani",
            "Rosiori",
            "Rosu",
            "Rudesti",
            "Runcu",
            "Rusca",
            "Rusi",
            "Rusii-Manastioara",
            "Rasca",
            "Radauti",
            "Radaseni",
            "Rauteni",
            "Sadova",
            "Sadau",
            "Salcea",
            "Sasca Mare",
            "Sasca Mica",
            "Sasca Noua",
            "Satu Mare",
            "Satu Mare",
            "Securiceni",
            "Sfantu Ilie",
            "Silistea",
            "Silistea Noua",
            "Siminicea",
            "Siret",
            "Slatina",
            "Slobozia",
            "Slobozia",
            "Slobozia Sucevei",
            "Slatioara",
            "Slatioara",
            "Smida Ungurenilor",
            "Solca",
            "Solonet",
            "Solonetu Nou",
            "Spataresti",
            "Stamate",
            "Straja",
            "Stroiesti",
            "Stramtura",
            "Stulpicani",
            "Stanca",
            "Stancuta",
            "Suceava",
            "Sucevita",
            "Sunatori",
            "Sarghiesti",
            "Sacuta",
            "Salageni",
            "Sarisor",
            "Sarisoru Mare",
            "Tesna",
            "Tesna",
            "Tisauti",
            "Todireni",
            "Todiresti",
            "Trei Movile",
            "Tarnicioara",
            "Tataru",
            "Tautesti",
            "Udesti",
            "Uidesti",
            "Ulma",
            "Uncesti",
            "Vadu Moldovei",
            "Vadu Negrilesei",
            "Valea Bancului",
            "Valea Bourei",
            "Valea Glodului",
            "Valea Moldovei",
            "Valea Poienei",
            "Valea Putnei",
            "Valea Stanei",
            "Vama",
            "Varvata",
            "Vatra Dornei",
            "Vatra Moldovitei",
            "Verbia",
            "Vercicani",
            "Veresti",
            "Vicovu de Jos",
            "Vicovu de Sus",
            "Vicsani",
            "Voievodeasa",
            "Voitinel",
            "Volovat",
            "Vornicenii Mari",
            "Vornicenii Mici",
            "Voronet",
            "Vulturesti",
            "Valcelele",
            "Varfu Dealului",
            "Valeni-Stanisoara",
            "Varatec",
            "Vascauti",
            "Zaharesti",
            "Zalomestra",
            "Zamostea",
            "Zvoristea",
            "Saru Bucovinei",
            "Saru Dornei",
            "Scheia",
            "Serbanesti",
            "Serbauti",
            "Ses",
            "Sesuri",
            "Sinca",
            "Soldanesti",
            "Stirbat",
            "Tarna Mare",
            "Tibeni",
            "Tibau",
            "Tolesti"
          ]
        },
        {
          name: "Teleorman",
          cities: [
            "Albeni",
            "Albesti",
            "Alexandria",
            "Antonesti",
            "Baciu",
            "Balaci",
            "Baldovinesti",
            "Balta Sarata",
            "Banov",
            "Beciu",
            "Beiu",
            "Belciug",
            "Beuca",
            "Blejesti",
            "Bogdana",
            "Botoroaga",
            "Bragadiru",
            "Bratcovu",
            "Brebina",
            "Brosteanca",
            "Branceni",
            "Brancoveanca",
            "Bratesti",
            "Bratasani",
            "Bujoreni",
            "Bujoru",
            "Bujoru",
            "Burdeni",
            "Butculesti",
            "Butesti",
            "Buzescu",
            "Barsestii de Jos",
            "Bascoveni",
            "Babaita",
            "Bacalesti",
            "Baduleasa",
            "Baneasa",
            "Calomfiresti",
            "Caravaneti",
            "Cernetu",
            "Cervenia",
            "Cetatea",
            "Ciolanestii din Deal",
            "Ciolanestii din Vale",
            "Ciuperceni",
            "Ciuperceni",
            "Ciurari",
            "Ciurari-Deal",
            "Clanita",
            "Comoara",
            "Contesti",
            "Copaceanca",
            "Cosmesti",
            "Cosoaia",
            "Cosoteni",
            "Crevenicu",
            "Crangeni",
            "Crangu",
            "Cucueti",
            "Carlomanu",
            "Calinesti",
            "Calmatuiu",
            "Calmatuiu de Sus",
            "Calugaru",
            "Catunu",
            "Deparati",
            "Didesti",
            "Dobreni",
            "Dobrotesti",
            "Dorobantu",
            "Dracea",
            "Dracesti",
            "Dracsani",
            "Dracsenei",
            "Draghinesti",
            "Draganesti de Vede",
            "Draganesti-Vlasca",
            "Dudu",
            "Dulceanca",
            "Dulceni",
            "Darvas",
            "Florica",
            "Frumoasa",
            "Frasinet",
            "Furculesti",
            "Fantanele",
            "Gratia",
            "Gresia",
            "Gradisteanca",
            "Guruieni",
            "Gardesti",
            "Galateni",
            "Garagau",
            "Ionascu",
            "Islaz",
            "Izvoarele",
            "Lada",
            "Licuriciu",
            "Linia Costii",
            "Lisa",
            "Lita",
            "Ludaneasca",
            "Lunca",
            "Laceni",
            "Marita",
            "Mavrodin",
            "Merenii de Jos",
            "Merenii de Sus",
            "Meri",
            "Merisani",
            "Merisani",
            "Moldoveni",
            "Mosteni",
            "Mosteni",
            "Marzanesti",
            "Magura",
            "Magura cu Liliac",
            "Maldaeni",
            "Nanov",
            "Necsesti",
            "Negreni",
            "Negrenii de Sus",
            "Negrenii-Osebiti",
            "Negrilesti",
            "Nenciulesti",
            "Nicolae Balcescu",
            "Nasturelu",
            "Navodari",
            "Obartu",
            "Odobeasca",
            "Olteanca",
            "Olteni",
            "Orbeasca de Jos",
            "Orbeasca de Sus",
            "Peretu",
            "Perii Brosteni",
            "Piatra",
            "Pietrosani",
            "Pleasov",
            "Plopi",
            "Plopii-Slavitesti",
            "Plosca",
            "Poeni",
            "Poiana",
            "Poroschia",
            "Preajba",
            "Prunaru",
            "Prundu",
            "Purani",
            "Purani",
            "Puranii de Sus",
            "Putineiu",
            "Paru Rotund",
            "Pauleasca",
            "Rotaresti",
            "Rosiorii de Vede",
            "Radoiesti-Deal",
            "Radoiesti-Vale",
            "Radulesti",
            "Rasmiresti",
            "Saelele",
            "Salcia",
            "Satu Nou",
            "Satul Vechi",
            "Schitu Poienari",
            "Scrioastea",
            "Scurtu Mare",
            "Scurtu-Slavesti",
            "Seaca",
            "Secara",
            "Segarcea-Deal",
            "Segarcea-Vale",
            "Sericu",
            "Sfintesti",
            "Silistea",
            "Silistea",
            "Silistea Gumesti",
            "Silistea Mica",
            "Slobozia Mandra",
            "Slavesti",
            "Smardan",
            "Smardioasa",
            "Socetu",
            "Spatarei",
            "Stejaru",
            "Stejaru",
            "Suhaia",
            "Sarbeni",
            "Sarbenii de Jos",
            "Saceni",
            "Talpa Postei",
            "Talpa-Bascoveni",
            "Talpa-Ograzile",
            "Tecuci",
            "Teleormanu",
            "Traian",
            "Trivalea-Mosteni",
            "Troianul",
            "Tudor Vladimirescu",
            "Tunari",
            "Turnu Magurele",
            "Tarnava",
            "Tatarastii de Jos",
            "Tatarastii de Sus",
            "Uda-Clocociov",
            "Uda-Paciurea",
            "Udeni",
            "Udupu",
            "Ulmeni",
            "Urluiu",
            "Valea Ciresului",
            "Valea Postei",
            "Valea Parului",
            "Vatra",
            "Vedea",
            "Videle",
            "Viile",
            "Viisoara",
            "Vitanesti",
            "Voievoda",
            "Vanatori",
            "Vartoapele de Jos",
            "Vartoapele de Sus",
            "Vaceni",
            "Vacaresti",
            "Vatasi",
            "Zimnicea",
            "Zimnicele",
            "Zlata",
            "Zambreasca",
            "Insuratei",
            "Soimu",
            "Stefeni",
            "Storobaneasa",
            "Tiganesti",
            "Tavarlau"
          ]
        },
        {
          name: "Timis",
          cities: [
            "Albina",
            "Alios",
            "Altringen",
            "Babsa",
            "Bacova",
            "Balint",
            "Balosesti",
            "Banloc",
            "Bara",
            "Bazos",
            "Bazosu Nou",
            "Beba Veche",
            "Becicherecu Mic",
            "Begheiu Mic",
            "Belint",
            "Bencecu de Jos",
            "Bencecu de Sus",
            "Berecuta",
            "Beregsau Mare",
            "Beregsau Mic",
            "Berini",
            "Bethausen",
            "Bichigi",
            "Biled",
            "Birda",
            "Blajova",
            "Bobda",
            "Bodo",
            "Bogda",
            "Boldur",
            "Botesti",
            "Botinesti",
            "Breazova",
            "Brestovat",
            "Brestea",
            "Branesti",
            "Bucovat",
            "Bucovat",
            "Bulgarus",
            "Bulza",
            "Bunea Mare",
            "Bunea Mica",
            "Butin",
            "Buzad",
            "Buzias",
            "Barna",
            "Barateaz",
            "Batesti",
            "Cadar",
            "Carani",
            "Cebza",
            "Cenad",
            "Cenei",
            "Cerna",
            "Cerneteaz",
            "Charlottenburg",
            "Checea",
            "Cheches",
            "Cheglevici",
            "Cherestur",
            "Cheveresu Mare",
            "Chizatau",
            "Chisoda",
            "Ciacova",
            "Ciresu",
            "Ciresu Mic",
            "Cladova",
            "Cliciova",
            "Clopodia",
            "Colonia Bulgara",
            "Colonia Fabricii",
            "Colonia Mica",
            "Comeat",
            "Comlosu Mare",
            "Comlosu Mic",
            "Cornesti",
            "Covaci",
            "Cosarii",
            "Cosava",
            "Cosevita",
            "Costeiu",
            "Costeiu de Sus",
            "Crai Nou",
            "Cralovat",
            "Criciova",
            "Crivina",
            "Crivina de Sus",
            "Crivobara",
            "Cruceni",
            "Curtea",
            "Cutina",
            "Calacea",
            "Capat",
            "Carpinis",
            "Darova",
            "Dejan",
            "Denta",
            "Deta",
            "Dinias",
            "Dobresti",
            "Dolat",
            "Dragomiresti",
            "Dragsina",
            "Drinova",
            "Dragoiesti",
            "Dragsinesti",
            "Dubesti",
            "Duboz",
            "Dudestii Noi",
            "Dudestii Vechi",
            "Dumbrava",
            "Dumbravita",
            "Ferendia",
            "Fibis",
            "Ficatar",
            "Foeni",
            "Folea",
            "Fardea",
            "Fadimac",
            "Faget",
            "Farasesti",
            "Gad",
            "Gaiu Mic",
            "Gavojdia",
            "Gelu",
            "Gherman",
            "Ghilad",
            "Ghiroda",
            "Ghizela",
            "Giarmata",
            "Giarmata-Vii",
            "Giera",
            "Giroc",
            "Giulvaz",
            "Gladna Montana",
            "Gladna Romana",
            "Gottlob",
            "Grabat",
            "Grosi",
            "Gruni",
            "Graniceri",
            "Gataia",
            "Herendesti",
            "Herneacova",
            "Hezeris",
            "Hisias",
            "Hitias",
            "Hodoni",
            "Hodos",
            "Hodos",
            "Homojdia",
            "Honorici",
            "Hauzesti",
            "Ianova",
            "Icloda",
            "Ictar-Budint",
            "Iecea Mare",
            "Iecea Mica",
            "Iersnic",
            "Igris",
            "Iohanisfeld",
            "Iosif",
            "Iosifalau",
            "Ivanda",
            "Izvin",
            "Jabar",
            "Jamu Mare",
            "Jdioara",
            "Jebel",
            "Jena",
            "Jimbolia",
            "Jupani",
            "Jupanesti",
            "Juresti",
            "Lenauheim",
            "Leucusesti",
            "Liebling",
            "Livezile",
            "Lovrin",
            "Lucaret",
            "Lugoj",
            "Lugojel",
            "Luncanii de Jos",
            "Luncanii de Sus",
            "Lunga",
            "Lapusnic",
            "Latunas",
            "Macedonia",
            "Margina",
            "Masloc",
            "Moravita",
            "Mosnita Noua",
            "Mosnita Veche",
            "Murani",
            "Manastire",
            "Matnicu Mic",
            "Maguri",
            "Manastiur",
            "Nadas",
            "Nemesesti",
            "Nerau",
            "Nevrincea",
            "Nitchidorf",
            "Nadrag",
            "Obad",
            "Ofsenita",
            "Ohaba Lunga",
            "Ohaba Romana",
            "Ohaba-Forgaci",
            "Olosag",
            "Opatita",
            "Ortisoara",
            "Otelec",
            "Otvesti",
            "Paniova",
            "Partos",
            "Parta",
            "Peciu Nou",
            "Percosova",
            "Periam",
            "Pesac",
            "Petroasa Mare",
            "Petroman",
            "Petrovaselo",
            "Pietroasa",
            "Pini",
            "Pischia",
            "Poganesti",
            "Poieni",
            "Pordeanu",
            "Povargina",
            "Pustinis",
            "Padurani",
            "Padureni",
            "Padureni",
            "Paru",
            "Racovita",
            "Recas",
            "Remetea Mare",
            "Remetea Mica",
            "Remetea-Lunca",
            "Romanesti",
            "Rovinita Mare",
            "Rovinita Mica",
            "Rudicica",
            "Rudna",
            "Rachita",
            "Radmanesti",
            "Rauti",
            "Sacosu Mare",
            "Sacosu Turcesc",
            "Saravale",
            "Satchinez",
            "Secas",
            "Seceani",
            "Sinersig",
            "Sintar",
            "Sintesti",
            "Soca",
            "Spata",
            "Stamora Germana",
            "Stamora Romana",
            "Stanciova",
            "Sudrias",
            "Surducu Mic",
            "Susani",
            "Sanandrei",
            "Sangeorge",
            "Sanmartinu Maghiar",
            "Sanmartinu Sarbesc",
            "Sanmihaiu German",
            "Sanmihaiu Roman",
            "Sannicolau Mare",
            "Sanpetru Mare",
            "Sanpetru Mic",
            "Sarbova",
            "Saceni",
            "Sacalaz",
            "Salbagel",
            "Salciua Noua",
            "Sarazani",
            "Tapia",
            "Temeresti",
            "Teremia Mare",
            "Teremia Mica",
            "Tes",
            "Timisoara",
            "Toager",
            "Tomesti",
            "Tomnatic",
            "Topla",
            "Topolovatu Mare",
            "Topolovatu Mic",
            "Tormac",
            "Traian Vuia",
            "Targoviste",
            "Uihei",
            "Uivar",
            "Uliuc",
            "Unip",
            "Urseni",
            "Utvin",
            "Valcani",
            "Valea Lunga Romana",
            "Varias",
            "Victor Vlad Delamarina",
            "Visag",
            "Vizejdia",
            "Vizma",
            "Voiteg",
            "Vucova",
            "Zgribesti",
            "Zolt",
            "Zorani",
            "Sag",
            "Sandra",
            "Sanovita",
            "Semlacu Mare",
            "Semlacu Mic",
            "Sipet",
            "Stiuca",
            "Sustra",
            "Tipari"
          ]
        },
        {
          name: "Tulcea",
          cities: [
            "Agighiol",
            "Alba",
            "Ardealu",
            "Atmagea",
            "Babadag",
            "Baia",
            "Balabancea",
            "Beidaud",
            "Bestepe",
            "Baltenii de Jos",
            "Baltenii de Sus",
            "C.A. Rosetti",
            "Calfa",
            "Camena",
            "Caraorman",
            "Carcaliu",
            "Cardon",
            "Casimcea",
            "Cataloi",
            "Caugagia",
            "Ceamurlia de Jos",
            "Ceamurlia de Sus",
            "Ceatalchioi",
            "Cerbu",
            "Cerna",
            "Chilia Veche",
            "Ciucurova",
            "Cismeaua Noua",
            "Closca",
            "Colina",
            "Corugea",
            "Crisan",
            "Carjelari",
            "Caslita",
            "Caprioara",
            "Dorobantu",
            "Dunavatu de Jos",
            "Dunavatu de Sus",
            "Daeni",
            "Enisala",
            "Floresti",
            "Frecatei",
            "Fantana Mare",
            "Fantana Oilor",
            "Fagarasu Nou",
            "Garvan",
            "General Praporgescu",
            "Gorgova",
            "Greci",
            "Grindu",
            "Haidar",
            "Hamcearca",
            "Horia",
            "I. C. Bratianu",
            "Iazurile",
            "Ilganii de Jos",
            "Ilganii de Sus",
            "Isaccea",
            "Iulia",
            "Izvoarele",
            "Jijila",
            "Jurilovca",
            "Letea",
            "Luminita",
            "Lunca",
            "Luncavita",
            "Lastuni",
            "Mahmudia",
            "Malcoci",
            "Maliuc",
            "Mesteru",
            "Mihai Bravu",
            "Mihail Kogalniceanu",
            "Mila 23",
            "Mina Altan Tepe",
            "Mineri",
            "Mircea Voda",
            "Murighiol",
            "Macin",
            "Magurele",
            "Nalbant",
            "Neatarnarea",
            "Nicolae Balcescu",
            "Niculitel",
            "Nifon",
            "Nufaru",
            "Ostrov",
            "Ostrovu Tataru",
            "Panduru",
            "Parches",
            "Pardina",
            "Partizani",
            "Peceneaga",
            "Periprava",
            "Piatra",
            "Plauru",
            "Plopul",
            "Posta",
            "Patlageanca",
            "Rachelu",
            "Rahman",
            "Randunica",
            "Razboieni",
            "Sabangia",
            "Sarichioi",
            "Sarighiol de Deal",
            "Sarinasuf",
            "Satu Nou",
            "Sfistofca",
            "Sfantu Gheorghe",
            "Slava Cercheza",
            "Slava Rusa",
            "Smardan",
            "Somova",
            "Stejaru",
            "Stanca",
            "Sulina",
            "Sambata Noua",
            "Salceni",
            "Salcioara",
            "Tatanir",
            "Telita",
            "Topolog",
            "Traian",
            "Trestenic",
            "Tulcea",
            "Turcoaia",
            "Turda",
            "Uzlina",
            "Valea Nucarilor",
            "Valea Teilor",
            "Vasile Alecsandri",
            "Victoria",
            "Visterna",
            "Visina",
            "Vulturu",
            "Vacareni",
            "Zebil"
          ]
        },
        {
          name: "Vaslui",
          cities: [
            "1 Decembrie",
            "Albesti",
            "Albesti",
            "Albina",
            "Albita",
            "Alexandru Vlahuta",
            "Armaseni",
            "Armaseni",
            "Armasoaia",
            "Arsura",
            "Arsita",
            "Averesti",
            "Avramesti",
            "Banca",
            "Barbosi",
            "Bejenesti",
            "Belcesti",
            "Belzeni",
            "Benesti",
            "Bereasa",
            "Berezeni",
            "Blesca",
            "Blagesti",
            "Bobesti",
            "Bogdana",
            "Bogdana-Voloseni",
            "Bogdanesti",
            "Bogdanesti",
            "Bogdanita",
            "Bogesti",
            "Bolati",
            "Borodesti",
            "Bousori",
            "Bozia",
            "Botesti",
            "Botoaia",
            "Botoi",
            "Broscosesti",
            "Brosteni",
            "Bradesti",
            "Brahasoaia",
            "Buda",
            "Buda",
            "Buda",
            "Budesti",
            "Budu Cantemir",
            "Buhaiesti",
            "Bulboaca",
            "Bumbata",
            "Bunesti",
            "Bursuci",
            "Buscata",
            "Butucaria",
            "Barlad",
            "Barlalesti",
            "Barzesti",
            "Babusa",
            "Babuta",
            "Bacani",
            "Bacesti",
            "Bacaoani",
            "Badeana",
            "Baile Dranceni",
            "Balesti",
            "Balteni",
            "Balteni-Deal",
            "Baltateni",
            "Baltati",
            "Bancesti",
            "Bartalus-Mocani",
            "Bartalus-Razesi",
            "Cepesti",
            "Cetatuia",
            "Chersacosu",
            "Chetresti",
            "Chetrosu",
            "Chilieni",
            "Chircesti",
            "Chitcani",
            "Chitoc",
            "Cioatele",
            "Ciocani",
            "Ciofeni",
            "Ciortolom",
            "Ciuperca",
            "Codreni",
            "Codaesti",
            "Condrea",
            "Copaceana",
            "Corbu",
            "Corni-Albesti",
            "Corobanesti",
            "Corodesti",
            "Coroiesti",
            "Coroiesti",
            "Coroiestii de Sus",
            "Coroiu",
            "Costesti",
            "Cotic",
            "Cozmesti",
            "Cosca",
            "Cosesti",
            "Crasna",
            "Cretesti",
            "Cretestii de Sus",
            "Cristesti",
            "Crivesti",
            "Crang",
            "Crangu Nou",
            "Craciunesti",
            "Crasnaseni",
            "Cujba",
            "Cursesti-Deal",
            "Cursesti-Vale",
            "Curteni",
            "Carjoani",
            "Cartibasi",
            "Calimanesti",
            "Calugareni",
            "Cantalaresti",
            "Capotesti",
            "Capusneni",
            "Cazanesti",
            "Davidesti",
            "Dealu Mare",
            "Dealu Secarii",
            "Delea",
            "Deleni",
            "Deleni",
            "Delesti",
            "Dinga",
            "Doagele",
            "Dobroslovesti",
            "Docani",
            "Docaneasa",
            "Dodesti",
            "Dragomiresti",
            "Dragomanesti",
            "Draxeni",
            "Drujesti",
            "Dranceni",
            "Dragesti",
            "Draxeni",
            "Duda",
            "Dumasca",
            "Dumbraveni",
            "Dumesti",
            "Dumestii Vechi",
            "Danesti",
            "Emil Racovita",
            "Epureni",
            "Epureni",
            "Fedesti",
            "Feresti",
            "Floresti",
            "Focsa",
            "Focseasca",
            "Frasinu",
            "Fruntiseni",
            "Fulgu",
            "Fundu Vaii",
            "Fundu Vaii",
            "Fundatura",
            "Fundatura",
            "Fundatura Mare",
            "Fundatura Mica",
            "Fantana Blanarului",
            "Fantanele",
            "Fastaci",
            "Falciu",
            "Gara Banca",
            "Gara Docaneasa",
            "Gara Rosiesti",
            "Gara Talasman",
            "Ghergheleu",
            "Gherghesti",
            "Ghermanesti",
            "Ghermanesti",
            "Ghicani",
            "Ghireasca",
            "Giurcani",
            "Giurgesti",
            "Glodeni",
            "Grivita",
            "Grumezoaia",
            "Grajdeni",
            "Gugesti",
            "Gura Albesti",
            "Gura Idrici",
            "Gura Vaii",
            "Gusitei",
            "Galtesti",
            "Garceni",
            "Gardesti",
            "Gagesti",
            "Ganesti",
            "Gavanu",
            "Halta Dodesti",
            "Hoceni",
            "Hordila",
            "Hordilesti",
            "Horga",
            "Horoiata",
            "Hreasca",
            "Huc",
            "Hupca",
            "Hurdugi",
            "Husi",
            "Harsova",
            "Harsoveni",
            "Halaresti",
            "Iana",
            "Iaz",
            "Ibanesti",
            "Idrici",
            "Iezer",
            "Iezerel",
            "Igesti",
            "Ivesti",
            "Ivanesti",
            "Ivanesti",
            "Jigalia",
            "Lacu Babei",
            "Laza",
            "Lazu",
            "Leosti",
            "Leosti",
            "Lipovat",
            "Lunca",
            "Lunca Banului",
            "Lunca Veche",
            "Lupesti",
            "Lalesti",
            "Mantu",
            "Miclesti",
            "Miclesti",
            "Mihail Kogalniceanu",
            "Mircesti",
            "Mireni",
            "Mitoc",
            "Moara Domneasca",
            "Moreni",
            "Morareni",
            "Movileni",
            "Muntenesti",
            "Muntenii de Jos",
            "Muntenii de Sus",
            "Murgeni",
            "Musata",
            "Manjesti",
            "Manzati",
            "Manzatesti",
            "Manastirea",
            "Manastirea",
            "Macresti",
            "Macresti",
            "Malusteni",
            "Malaiesti",
            "Maraseni",
            "Marasesti",
            "Mascurei",
            "Negresti",
            "Obarseni",
            "Obarseni",
            "Obarsenii Lingurari",
            "Odaia Bogdana",
            "Odaia Bursucani",
            "Oltenesti",
            "Oprisita",
            "Orgoiesti",
            "Osesti",
            "Oteleni",
            "Otetoaia",
            "Parpanita",
            "Peicani",
            "Perieni",
            "Plopeni",
            "Plopi",
            "Plopoasa",
            "Plotonesti",
            "Pochidia",
            "Podeni",
            "Podu Oprii",
            "Podu Pietris",
            "Pogana",
            "Pogonesti",
            "Poganesti",
            "Poiana",
            "Poiana Pietrei",
            "Poiana lui Alexa",
            "Poienesti",
            "Poienesti-Deal",
            "Polocin",
            "Popeni",
            "Popeni",
            "Popesti",
            "Popesti",
            "Portari",
            "Posta Elan",
            "Pribesti",
            "Protopopesti",
            "Puiesti",
            "Pungesti",
            "Puntiseni",
            "Puscasi",
            "Putu Olarului",
            "Pahna",
            "Pahnesti",
            "Parvesti",
            "Pacuraresti",
            "Padureni",
            "Padureni",
            "Paltinis",
            "Racova",
            "Racovita",
            "Rafaila",
            "Rapsa",
            "Ratesu Cuzei",
            "Rebricea",
            "Recea",
            "Rediu",
            "Rediu",
            "Rediu Galian",
            "Rotari",
            "Rosiesti",
            "Rosiori",
            "Rugaria",
            "Rusca",
            "Rusi",
            "Ranceni",
            "Ranzesti",
            "Rasesti",
            "Rasnita",
            "Radeni",
            "Radesti",
            "Raducani",
            "Raduiesti",
            "Radaesti",
            "Rascani",
            "Rascani",
            "Sasova",
            "Satu Nou",
            "Satu Nou",
            "Satu Nou",
            "Satu Nou",
            "Satu Nou",
            "Satu Nou",
            "Sauca",
            "Schinetea",
            "Schitu",
            "Secuia",
            "Semenea",
            "Silistea",
            "Silistea",
            "Silistea",
            "Simila",
            "Similisoara",
            "Sipeni",
            "Slobozia",
            "Soci",
            "Sofieni",
            "Sofronesti",
            "Solesti",
            "Stejaru",
            "Stoisesti",
            "Stroiesti",
            "Stramtura-Mitoc",
            "Stuhulet",
            "Stancaseni",
            "Stanilesti",
            "Suceveni",
            "Suseni",
            "Sarbi",
            "Salceni",
            "Salcioara",
            "Saratu",
            "Tanacu",
            "Tatomiresti",
            "Teisoru",
            "Telejna",
            "Todireni",
            "Todiresti",
            "Tomesti",
            "Tomsa",
            "Toporasti",
            "Trestiana",
            "Trohan",
            "Tufestii de Jos",
            "Tulesti",
            "Tunsesti",
            "Tupilati",
            "Tutova",
            "Tarzii",
            "Tabalaiesti",
            "Tacuta",
            "Talpigeni",
            "Tatarani",
            "Tatarani",
            "Ulea",
            "Uncesti",
            "Untesti",
            "Urdesti",
            "Uricari",
            "Urlati",
            "Ursoaia",
            "Vadurile",
            "Valea Grecului",
            "Valea Lunga",
            "Valea Lupului",
            "Valea Mare",
            "Valea Mare",
            "Valea Mare",
            "Valea Oanei",
            "Valea Popii",
            "Valea Seaca",
            "Valea Silistei",
            "Valea Targului",
            "Valea lui Bosie",
            "Valea lui Darie",
            "Vaslui",
            "Verdes",
            "Vetrisoaia",
            "Viisoara",
            "Viisoara",
            "Viltotesti",
            "Vinderei",
            "Vinetesti",
            "Vizureni",
            "Visinari",
            "Vladia",
            "Vladesti",
            "Voinesti",
            "Voinesti",
            "Vovriesti",
            "Vulpaseni",
            "Vulturesti",
            "Vutcani",
            "Valcele",
            "Valeni",
            "Valeni",
            "Valeni",
            "Zgura",
            "Zizinca",
            "Zorleni",
            "Zapodeni",
            "Serbotesti",
            "Siscani",
            "Soparleni",
            "Stefan cel Mare",
            "Stioborani",
            "Suletea",
            "Tibanestii Buhlii",
            "Tifu",
            "Tutcani"
          ]
        },
        {
          name: "Valcea",
          cities: [
            "Afanata",
            "Aldesti",
            "Alunu",
            "Amarasti",
            "Andreiesti",
            "Aninoasa",
            "Aricioaia",
            "Armasesti",
            "Arsanca",
            "Auresti",
            "Avramesti",
            "Balaciu",
            "Balomireasa",
            "Balota",
            "Barcanele",
            "Barza",
            "Becsani",
            "Benesti",
            "Berbesti",
            "Berbesti",
            "Bercioiu",
            "Beresti",
            "Berislavesti",
            "Bistrita",
            "Blejani",
            "Blidari",
            "Blanoiu",
            "Bocsa",
            "Bodesti",
            "Bodesti",
            "Bogdanesti",
            "Bogdanesti",
            "Bogdanesti",
            "Boisoara",
            "Bonciu",
            "Bondoci",
            "Borosesti",
            "Botorani",
            "Bradu-Clocotici",
            "Bratia din Deal",
            "Bratia din Vale",
            "Bratovesti",
            "Brezoi",
            "Brosteni",
            "Bradisor",
            "Buciumeni",
            "Bucsani",
            "Budele",
            "Budesti",
            "Budesti",
            "Budurasti",
            "Bujoreni",
            "Bulagei",
            "Buleta",
            "Bumbuesti",
            "Bunesti",
            "Bungetani",
            "Burdalesti",
            "Butanu",
            "Buzdugan",
            "Barlogu",
            "Barsesti",
            "Barsesti",
            "Barsoiu",
            "Barzesti",
            "Babeni",
            "Babeni-Oltetu",
            "Babuesti",
            "Badeni",
            "Baiasa",
            "Baiasu",
            "Baile Govora",
            "Baile Olanesti",
            "Bajenari",
            "Balcesti",
            "Balteni",
            "Balutoaia",
            "Balsoara",
            "Baltateni",
            "Banesti",
            "Bantesti",
            "Barbuceni",
            "Barbarigeni",
            "Barbatesti",
            "Barcanesti",
            "Baroiu",
            "Batasani",
            "Capu Dealului",
            "Carcadiesti",
            "Casa Veche",
            "Ceretu",
            "Cermegesti",
            "Cermegesti",
            "Cerna",
            "Cernelele",
            "Cernisoara",
            "Cetateaua",
            "Cherasti",
            "Chiceni",
            "Chirculesti",
            "Chiricesti",
            "Cioboti",
            "Ciocaltei",
            "Ciocanari",
            "Cioponesti",
            "Ciortesti",
            "Ciorasti",
            "Ciresu",
            "Ciresul",
            "Ciucheti",
            "Ciumagi",
            "Ciungetu",
            "Ciutesti",
            "Coasta",
            "Coasta",
            "Coasta Cerbului",
            "Coasta Mare",
            "Cocoru",
            "Colelia",
            "Coltesti",
            "Condoiesti",
            "Contea",
            "Copaceni",
            "Copaceni",
            "Corbii din Vale",
            "Corbu",
            "Cornet",
            "Costesti",
            "Cosani",
            "Cremenari",
            "Creteni",
            "Crangu",
            "Cucesti",
            "Cuci",
            "Cucoiu",
            "Cuculesti",
            "Cueni",
            "Curtea",
            "Cainenii Mari",
            "Cainenii Mici",
            "Carlogani",
            "Carstanesti",
            "Caligi",
            "Calimanesti",
            "Calina",
            "Calinesti",
            "Cazanesti",
            "Cazanesti",
            "Catetu",
            "Dealu Bisericii",
            "Dealu Corni",
            "Dealu Glameia",
            "Dealu Launele",
            "Dealu Mare",
            "Dealu Mare",
            "Dealu Mare",
            "Dealu Scheiului",
            "Dealu Valeni",
            "Dejoi",
            "Deleni",
            "Delureni",
            "Delureni",
            "Delureni",
            "Dezrobiti",
            "Diaconesti",
            "Dianu",
            "Diculesti",
            "Dimulesti",
            "Dobresti",
            "Dobricea",
            "Dobriceni",
            "Dobrusa",
            "Dosu Raului",
            "Dozesti",
            "Draganu",
            "Dragioiu",
            "Dragoesti",
            "Dragulesti",
            "Draganesti",
            "Draganesti",
            "Dragasani",
            "Dumbrava",
            "Dumbravesti",
            "Dangesti",
            "Daesti",
            "Daesti",
            "Dancai",
            "Fedelesoiu",
            "Feteni",
            "Firesti",
            "Firijba",
            "Fiscalia",
            "Folestii de Jos",
            "Folestii de Sus",
            "Fotesti",
            "Frasina",
            "Francesti",
            "Francesti-Coasta",
            "Fumureni",
            "Fundatura",
            "Fartatesti",
            "Fauresti",
            "Fauresti",
            "Galicea",
            "Geamana",
            "Geamana",
            "Genuneni",
            "Ghindari",
            "Ghiobesti",
            "Ghioroiu",
            "Gibesti",
            "Ginerica",
            "Giulesti",
            "Giulestii de Sus",
            "Giurgiuveni",
            "Giuroiu",
            "Glodu",
            "Glavile",
            "Golotreni",
            "Goranu",
            "Gorunesti",
            "Gorunesti",
            "Govora",
            "Greblesti",
            "Greci",
            "Gropeni",
            "Grosi",
            "Gruieri",
            "Gruiu",
            "Gruiu Lupului",
            "Gradistea",
            "Guguianca",
            "Gura Crucilor",
            "Gura Vaii",
            "Gurisoara",
            "Gusoeni",
            "Gusoianca",
            "Galtofani",
            "Garnicet",
            "Garnicetu",
            "Gageni",
            "Gainesti",
            "Ganesti",
            "Gantulei",
            "Gaujani",
            "Gavanesti",
            "Herasti",
            "Horezu",
            "Hotarele",
            "Hotarasa",
            "Hotaroaia",
            "Iacovile",
            "Ifrimesti",
            "Igoiu",
            "Ilaciu",
            "Ionesti",
            "Irimesti",
            "Izbasesti",
            "Izvorasu",
            "Izvoru",
            "Izvoru Rece",
            "Izvoru Rece",
            "Jarostea",
            "Lalosu",
            "Lespezi",
            "Linia",
            "Linia",
            "Linia Dealului",
            "Linia Hanului",
            "Linia pe Vale",
            "Livezi",
            "Lunca",
            "Lungesti",
            "Lupoaia",
            "Lupuiesti",
            "Lacusteni",
            "Lacustenii de Jos",
            "Lacustenii de Sus",
            "Ladesti",
            "Launele de Jos",
            "Malaia",
            "Malu",
            "Malu Alb",
            "Malu Vartop",
            "Mamu",
            "Marcea",
            "Marita",
            "Mateesti",
            "Mecea",
            "Meieni",
            "Meresesti",
            "Mierea",
            "Mihaesti",
            "Mijati",
            "Mijlocu",
            "Milcoiu",
            "Milesti",
            "Milostea",
            "Miresti",
            "Mitrofani",
            "Mlaceni",
            "Modoia",
            "Mogesti",
            "Mogosesti",
            "Mologesti",
            "Mosteni",
            "Mrenesti",
            "Muereasca",
            "Muereasca de Sus",
            "Munteni",
            "Mangureni",
            "Maciuceni",
            "Madulari",
            "Madulari",
            "Magura",
            "Magureni",
            "Maldaresti",
            "Maldaresti",
            "Maldaresti",
            "Maldarestii de Jos",
            "Maneasa",
            "Manicea",
            "Manailesti",
            "Marcusu",
            "Margineni",
            "Maricesti",
            "Mazili",
            "Mazararu",
            "Neghinesti",
            "Negraia",
            "Negreni",
            "Negrulesti",
            "Nemoiu",
            "Nenciulesti",
            "Netesti",
            "Nicolesti",
            "Nisipi",
            "Obislavu",
            "Obogeni",
            "Obrocesti",
            "Obarsia",
            "Ocnele Mari",
            "Ocracu",
            "Olanu",
            "Olteanca",
            "Olteanca",
            "Olteni",
            "Oltetani",
            "Oltetu",
            "Opatesti",
            "Orlesti",
            "Ostroveni",
            "Otetelisu",
            "Otesani",
            "Oveselu",
            "Padina",
            "Palanga",
            "Perisani",
            "Pertesti",
            "Pesceana",
            "Pietrari",
            "Pietrari",
            "Pietrarii de Sus",
            "Pietreni",
            "Pietroasa",
            "Piscu Mare",
            "Piscu Pietrei",
            "Piscu Scoartei",
            "Pleasa",
            "Plesesti",
            "Plesoiu",
            "Plesoiu",
            "Podeni",
            "Poenita",
            "Poiana",
            "Poienari",
            "Pojogi-Cerna",
            "Popesti",
            "Popesti",
            "Popesti",
            "Popesti",
            "Popesti",
            "Popesti",
            "Popesti",
            "Popesti",
            "Popesti",
            "Portaresti",
            "Predesti",
            "Preotesti",
            "Priloage",
            "Pripoara",
            "Pripoare",
            "Priporu",
            "Procopoaia",
            "Prodanesti",
            "Proieni",
            "Prundeni",
            "Paraienii de Jos",
            "Paraienii de Mijloc",
            "Paraienii de Sus",
            "Paduretu",
            "Parausani",
            "Pascoaia",
            "Pasculesti",
            "Pasarei",
            "Patesti",
            "Pausesti",
            "Pausesti-Maglasi",
            "Pausesti-Otasau",
            "Racovita",
            "Racovita",
            "Racu",
            "Robaia",
            "Robesti",
            "Roesti",
            "Roesti",
            "Romanesti",
            "Romanii de Jos",
            "Romanii de Sus",
            "Romani",
            "Rotarasti",
            "Rosia",
            "Rosiile",
            "Rosoveni",
            "Ruda",
            "Rugetu",
            "Rugetu",
            "Runcu",
            "Rusanesti",
            "Ramesti",
            "Ramesti",
            "Ramnicu Valcea",
            "Rapa Caramizii",
            "Rapanesti",
            "Rau Vadului",
            "Radacinesti",
            "Ratalesti",
            "Saioci",
            "Satu Poieni",
            "Scaiosi",
            "Schitu",
            "Scorusu",
            "Scundu",
            "Scarisoara",
            "Scaueni",
            "Seaca",
            "Seciu",
            "Silea",
            "Sinesti",
            "Slatioara",
            "Slavitesti",
            "Snamana",
            "Spinu",
            "Sparleni",
            "Stanomiru",
            "Stoenesti",
            "Stoenesti",
            "Stoiculesti",
            "Stoicanesti",
            "Stoilesti",
            "Streminoasa",
            "Stroesti",
            "Strachinesti",
            "Stuparei",
            "Stanculesti",
            "Stanesti",
            "Stanesti",
            "Stanesti-Lunca",
            "Sub Deal",
            "Suiesti",
            "Surdoiu",
            "Surpatele",
            "Surpati",
            "Suseni",
            "Sutesti",
            "Sanbotin",
            "Sarbi",
            "Salistea",
            "Salistea",
            "Salatrucel",
            "Sarsanesti",
            "Sarulesti",
            "Sascioara",
            "Tanislavi",
            "Teiu",
            "Teiul",
            "Teiusu",
            "Telechesti",
            "Tepsenari",
            "Tetoiu",
            "Tighina",
            "Tina",
            "Titesti",
            "Titireci",
            "Tomsani",
            "Trundin",
            "Tufanii",
            "Tulei-Campeni",
            "Turburea",
            "Turcesti",
            "Tutulesti",
            "Tanasesti",
            "Tatarani",
            "Udresti",
            "Ulmetu",
            "Ulmetel",
            "Ursoaia",
            "Urzica",
            "Ursani",
            "Ursi",
            "Ursi",
            "Usurei",
            "Vaideeni",
            "Valea Alunisului",
            "Valea Babei",
            "Valea Balceasca",
            "Valea Caselor",
            "Valea Cheii",
            "Valea Gradistei",
            "Valea Lunga",
            "Valea Mare",
            "Valea Mare",
            "Valea Macesului",
            "Valea Raului",
            "Valea Scheiului",
            "Valea Ursului",
            "Valea Viei",
            "Valea Valeni",
            "Valea lui Stan",
            "Verdea",
            "Vetelu",
            "Viisoara",
            "Vladesti",
            "Vladuceni",
            "Vladulesti",
            "Voicesti",
            "Voicestii din Vale",
            "Voiculeasa",
            "Voineasa",
            "Voinesita",
            "Vulpuesti",
            "Varleni",
            "Valeni",
            "Valeni",
            "Varateci",
            "Varatica",
            "Varatici",
            "Vatasesti",
            "Zgubea",
            "Zmeuratu",
            "Zarnesti",
            "Zatreni",
            "Zatrenii de Sus",
            "Zavideni",
            "Zavoieni",
            "Serbaneasa",
            "Serbanesti",
            "Serbanesti",
            "Serbanesti",
            "Serbanesti",
            "Sirineasa",
            "Solicesti",
            "Sotani",
            "Stefanesti",
            "Stefanesti",
            "Stirbesti",
            "Suricaru",
            "Suta",
            "Susani",
            "Tepesti",
            "Tuturu"
          ]
        },
        {
          name: "Vrancea",
          cities: [
            "Adjud",
            "Adjudu Vechi",
            "Alexandru Vlahuta",
            "Andreiasu de Jos",
            "Andreiasu de Sus",
            "Anghelesti",
            "Argea",
            "Armeni",
            "Arva",
            "Arsita",
            "Bahnele",
            "Balta Ratei",
            "Beciu",
            "Belciugele",
            "Bicestii de Jos",
            "Bicestii de Sus",
            "Bichesti",
            "Biliesti",
            "Bizighesti",
            "Blidari",
            "Blidari",
            "Bodesti",
            "Boghesti",
            "Boghestii de Sus",
            "Bogza",
            "Bolotesti",
            "Bontesti",
            "Bordeasca Noua",
            "Bordeasca Veche",
            "Bordesti",
            "Bordestii de Jos",
            "Botarlau",
            "Brosteni",
            "Bradetu",
            "Bradacesti",
            "Buda",
            "Budesti",
            "Burca",
            "Barsesti",
            "Batcari",
            "Balesti",
            "Balanesti",
            "Batinesti",
            "Carsochesti-Corabita",
            "Ceardac",
            "Cerbu",
            "Chiojdeni",
            "Chiricani",
            "Chitcani",
            "Ciolanesti",
            "Ciorani",
            "Ciorasti",
            "Ciuslea",
            "Clipicesti",
            "Cocosari",
            "Codresti",
            "Colacu",
            "Copacesti",
            "Corbita",
            "Cornetu",
            "Coroteni",
            "Costisa",
            "Costisa",
            "Costisa de Sus",
            "Cotesti",
            "Covrag",
            "Coza",
            "Campineanca",
            "Campuri",
            "Candesti",
            "Carligele",
            "Caiata",
            "Calienii Noi",
            "Calienii Vechi",
            "Calimaneasa",
            "Calimanesti",
            "Catauti",
            "Dealu Cucului",
            "Dealu Lung",
            "Dealu Sarii",
            "Diocheti-Rediu",
            "Doaga",
            "Domnesti-Sat",
            "Domnesti-Targ",
            "Dragosloveni",
            "Dragosloveni",
            "Dumbrava",
            "Dumbraveni",
            "Dumitresti",
            "Dumitrestii de Sus",
            "Dumitrestii-Fata",
            "Dupa Magura",
            "Dalhauti",
            "Faraoanele",
            "Farcas",
            "Feldioara",
            "Fetesti",
            "Fetig",
            "Fitionesti",
            "Focsani",
            "Frecatei",
            "Fagetu",
            "Faurei",
            "Galbeni",
            "Garoafa",
            "Ghebari",
            "Ghimicesti",
            "Gogoiu",
            "Golesti",
            "Golestii de Sus",
            "Gologanu",
            "Gresu",
            "Groapa Tufei",
            "Gugesti",
            "Gura Calitei",
            "Gura Vaii",
            "Gagesti",
            "Galoiesti",
            "Haret",
            "Holbanesti",
            "Homocea",
            "Hotaru",
            "Hangulesti",
            "Haulisca",
            "Igesti",
            "Iresti",
            "Iugani",
            "Ivancesti",
            "Izvoarele",
            "Jaristea",
            "Jgheaburi",
            "Jiliste",
            "Jitia",
            "Jitia de Jos",
            "Jorasti",
            "Lacu lui Baban",
            "Lepsa",
            "Lespezi",
            "Liesti",
            "Livada",
            "Livezile",
            "Lojnita",
            "Luncile",
            "Lupoaia",
            "Lamotesti",
            "Largaseni",
            "Lastuni",
            "Mahriu",
            "Maluri",
            "Mera",
            "Mesteacanu",
            "Mihalceni",
            "Milcovel",
            "Milcovul",
            "Mircestii Noi",
            "Mircestii Vechi",
            "Modruzeni",
            "Moraresti",
            "Motnau",
            "Movilita",
            "Muncei",
            "Muncelu",
            "Magura",
            "Maicanesti",
            "Manastioara",
            "Martinesti",
            "Maracini",
            "Marasesti",
            "Marasti",
            "Matacina",
            "Neculele",
            "Negrilesti",
            "Nereju",
            "Nereju Mic",
            "Nistoresti",
            "Nanesti",
            "Nanesti",
            "Naruja",
            "Obrejita",
            "Ochesesti",
            "Odobasca",
            "Odobesti",
            "Olesesti",
            "Olteni",
            "Olareni",
            "Oreavu",
            "Paltin",
            "Panciu",
            "Petreanu",
            "Petresti",
            "Pietroasa",
            "Pietroasa",
            "Pietroasa",
            "Pietroasa",
            "Piscu Radului",
            "Piscu Reghiului",
            "Pitulusa",
            "Plesesti",
            "Plopu",
            "Ploscuteni",
            "Plostina",
            "Placinteni",
            "Podu Lacului",
            "Podu Narujei",
            "Podu Stoica",
            "Podu Schiopului",
            "Poduri",
            "Podurile",
            "Poenile",
            "Poiana",
            "Poiana Cristei",
            "Poiana Stoichii",
            "Poienita",
            "Popesti",
            "Prahuda",
            "Precistanu",
            "Prisaca",
            "Prisecani",
            "Pufesti",
            "Putna",
            "Padureni",
            "Padureni",
            "Padureni",
            "Patrascani",
            "Paulesti",
            "Paunesti",
            "Pavalari",
            "Rasca",
            "Rebegari",
            "Reghiu",
            "Repedea",
            "Romanesti",
            "Rotilestii Mari",
            "Rotilestii Mici",
            "Roscari",
            "Rosioara",
            "Rucareni",
            "Ruget",
            "Ruginesti",
            "Ramniceanca",
            "Ramniceni",
            "Rachitasu",
            "Rachitosu",
            "Racoasa",
            "Radulesti",
            "Radacinesti",
            "Raiuti",
            "Rastoaca",
            "Sahastru",
            "Salcia Noua",
            "Salcia Veche",
            "Satu Nou",
            "Scafari",
            "Scanteia",
            "Seciu",
            "Sihlea",
            "Siminoc",
            "Slimnic",
            "Slobozia Botesti",
            "Slobozia Bradului",
            "Slobozia Ciorasti",
            "Spinesti",
            "Spulber",
            "Spatareasa",
            "Strajescu",
            "Straoane",
            "Stupina",
            "Suraia",
            "Sarbi",
            "Terchesti",
            "Tichiris",
            "Tinoasa",
            "Titila",
            "Tojanii de Jos",
            "Tojanii de Sus",
            "Topesti",
            "Trestia",
            "Trestieni",
            "Trotusanu",
            "Tulburea",
            "Tulnici",
            "Tutu",
            "Tamboesti",
            "Taratu",
            "Tabucesti",
            "Tanasari",
            "Tanasoaia",
            "Tataru",
            "Tataranu",
            "Ungureni",
            "Unirea",
            "Urechesti",
            "Ursoaia",
            "Vadu Rosca",
            "Valea Beciului",
            "Valea Cotesti",
            "Valea Mica",
            "Valea Milcovului",
            "Valea Neagra",
            "Valea Sarii",
            "Varnita",
            "Verdea",
            "Vetresti-Herastrau",
            "Vidra",
            "Viisoara",
            "Viisoara",
            "Vintileasca",
            "Vitanesti",
            "Vitanestii de sub Magura",
            "Vizantea Manastireasca",
            "Vizantea Razaseasca",
            "Vladnicu de Jos",
            "Vladnicu de Sus",
            "Voetin",
            "Voloscani",
            "Vrancioaia",
            "Vulcaneasa",
            "Vulturu",
            "Vajaitoarea",
            "Valcani",
            "Valcele",
            "Valcelele",
            "Vanatori",
            "Vartescoiu",
            "Valeni",
            "Valeni",
            "Valeni",
            "Varsatura",
            "Serbesti",
            "Serbanesti",
            "Sindrilari",
            "Siscani",
            "Sotarcari",
            "Tepa",
            "Tifesti",
            "Tipau"
          ]
        },
        {
          name: "Bucuresti",
          cities: [
            "Sector 1",
            "Sector 2",
            "Sector 3",
            "Sector 4",
            "Sector 5",
            "Sector 6"
          ]
        }
      ]
    };
  },
  props: {
    field: {
      required: false,
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: false
    },
    selectedValue: {
      type: String,
      required: false,
      default: ""
    },
    placeholder: {
      type: String,
      required: false,
      default: "Select Something"
    },
    validation: {
      type: String,
      required: false
    },
    styles: {
      type: Object,
      required: false,
      default: () => {}
    },
    color: {
      type: String,
      default: "#0F2967"
    },
    borderColor: {
      type: String,
      default: "#a3b8ea"
    }
  },
  methods: {
    updateComponent(event) {
      this.$refs.select.style.color = this.color;
      this.$emit("component-updated", {
        text: event.target.value
      });
      this.$emit("input", event.target.value);
      this.locations.forEach((item) => {
        if (item.name === this.county) {
          this.cities = item.cities;
          this.$store.commit("setNewCities", this.cities);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
$medium: 800px;

.selectInputWrapper {
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: #fff url("../../assets/icons/form/dropdown.svg") no-repeat !important;
    background-size: 14px !important;
    background-position: right 10px center !important;
    border-radius: 0.25rem !important;
  }
  position: relative;
  margin: 0;
  .error_min {
    width: 16px;
  }
  .inputError {
    position: absolute;
    top: 11px;
    right: 10px;
  }
}

select {
  background: transparent;
  outline: 0;
  box-shadow: none;
  transition: border-color 0.15s;
  border-radius: 0px !important;
  border: 1px solid var(--borderColor);
  box-sizing: border-box !important;
  padding-left: 15px !important;
  height: 44px !important;
  cursor: pointer;
  width: 100%;
  font-size: 16px;
  color: var(--color);
  &.is-invalid {
    border-color: #dc3545 !important;
    background: #fff0f1 !important;
  }
}

.floating-label {
  position: absolute;
  top: -17px;
  left: 0;
  padding-right: 7px;
  transition: transform 0.1s;
  pointer-events: none;
  transform-origin: 0 100%;
  transform: translateY(-50%);
  font-size: 16px;
  line-height: 20px;
  color: var(--color);
  font-weight: 700;
}

select:focus + .floating-label,
select.visited + .floating-label,
select:not(:focus):valid ~ .floating-label {
  // transform: translateY(-135%) scale(0.8);
}

.validation-error {
  color: #dc3545;
  font-size: 13px;
  margin-left: 0px;
  margin-top: 0px;
  position: absolute;

  .error_min {
    width: 16px;
  }
}
</style>
